<!-- 订单关怀 发送 -->
<template>
  <div class="page_condition" style="background-color: #2e72f8">
    <!--条件刷选-->
    <el-drawer
      :withHeader="false"
      :show-close="false"
      :visible.sync="drawers"
      :direction="'rtl'"
      :before-close="handleClose"
      :size="'900px'"
      custom-class="outside_Drawer"
    >
      <!-- :size="drawerWidth" -->
      <div class="mask">
        <div class="box-hugs" key="1546">
          <div class="box-content-hug">
            <div class="box-content" v-loading="selectLoading">
              <div>
                <span class="page_title">创建任务</span>
                <span @click="ModularBtnClose()" class="del_icon">x</span>
              </div>
              <div class="top_step">
                <div class="top_step_item step1">
                  <span class="circle_icon" v-if="stepNum == 1">1</span>
                  第一步 筛选任务条件
                </div>
                <div class="to_next"><i class="el-icon-arrow-right"></i></div>
                <div class="top_step_item step2">
                  <span class="circle_icon">2</span>
                  第二步 发送短信编辑
                </div>
              </div>

            <div style="overflow: auto;height: calc(100% - 100px);padding-bottom: 100px;">
              <!--任务名称：-->
              <div class="right-content" style="margin-top: 40px">
                <div class="right-content-left">任务名称：</div>
                <div class="right-content-right">
                  <el-input
                    v-model="postForm.taskName"
                    placeholder="请输入任务名称"
                    size="small"
                    style="width: 588px"
                    maxlength="30"
                    show-word-limit
                  ></el-input>
                </div>
              </div>
              <!--任务时间-->
              <div class="right-content">
                <div class="right-content-left">任务时间：</div>
                <div class="right-content-right" style="line-height: 32px">
                  <el-radio-group v-model="postForm.taskType" @change="changeTaskType">
                    <el-radio :label="0">
                      <span>持续开启</span>
                    </el-radio>
                    <el-radio :label="1">
                      <span style="margin-right: 8px">指定时间</span>
                    </el-radio>
                  </el-radio-group>
                  <div class="my_select_time" v-if="postForm.taskType === 1">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="postForm.taskStartTime"
                      type="datetime"
                      placeholder="开始日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 120px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      @change="moneyPayTimeChange"
                    ></el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="postForm.taskEndTime"
                      type="datetime"
                      placeholder="结束日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 145px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      @change="moneyPayTimeChange"
                    ></el-date-picker>
                    <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
                    <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                  </div>
                </div>
              </div>

              <!--发送时间-->
              <div class="right-content">
                <div class="right-content-left">发送时间：</div>
                <div class="right-content-right" style="margin-left: 0px">
                  <span v-if="menuType == 1" style="padding: 0 16px 0 0">买家下单后</span>
                  <span v-if="menuType == 2" style="padding: 0 16px 0 0">订单拍下</span>
                  <span v-if="menuType == 3" style="padding: 0 16px 0 0">首次催付后</span>
                  <span v-if="menuType == 5" style="padding: 0 16px 0 0">买家付款后</span>
                  <span v-if="menuType == 6" style="padding: 0 16px 0 0">买家取消订单后</span>
                  <span v-if="menuType == 7" style="padding: 0 16px 0 0">商品发货后</span>
                  <span v-if="menuType == 8" style="padding: 0 16px 0 0">买家付款后</span>
                  <span v-if="menuType == 9" style="padding: 0 16px 0 0">物流显示派件立即发送短信 </span>
                  <span v-if="menuType == 10" style="padding: 0 16px 0 0">买家签收后</span>
                  <span v-if="menuType == 11" style="padding: 0 16px 0 0">订单锁定后立即发送</span>
                  <span v-if="menuType == 12 || menuType == 13" style="padding: 0 16px 0 0">订单完成后</span>
                  <span v-if="menuType == 14 || menuType == 20" style="padding: 0 16px 0 0">买家给出好评后</span>
                  <span v-if="menuType == 15" style="padding: 0 16px 0 0">买家中差评后</span>
                  <span v-if="menuType == 16" style="padding: 0 16px 0 0">收到买家退款申请立即发送短信安抚</span>
                  <span v-if="menuType == 17" style="padding: 0 16px 0 0">卖家同意退款并需要买家退货时立即发短信给买家</span>
                  <span v-if="menuType == 18" style="padding: 0 16px 0 0">卖家拒绝退款后，立即发短信给买家</span>
                  <span v-if="menuType == 19" style="padding: 0 16px 0 0">退款成功立即发送短信给买家</span>
                  <span v-if="menuType == 26" style="padding: 0 16px 0 0">客户入会后</span>
                  <span v-if="menuType == 27" style="padding: 0 16px 0 0">等级升级为</span>
                  <span v-if="menuType == 28" style="padding: 0 16px 0 0">等级降级为</span>
                  <span v-if="menuType == 29" style="padding: 0 16px 0 0">客户退会后</span>
                  <span v-if="menuType == 30" style="padding: 0 16px 0 0">当变动超过</span>
                  <span v-if="menuType == 31" style="padding: 0 16px 0 0">买家下单后</span>
                  <span v-if="menuType == 32" style="padding: 0 16px 0 0">未入会用户下单后</span>
                  <span v-if="menuType == 33" style="padding: 0 16px 0 0">买家下单后</span>
                  <span v-if="menuType == 34" style="padding: 0 16px 0 0">买家下单后</span>
                  <el-select v-if="menuType == 27 || menuType == 28" v-model="formData.levelChange" placeholder="请选择" size="small" style="width: 80px; margin: 0 6px">
                    <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <span v-if="menuType == 27" style="padding-left: 10px">且会员升级后</span>
                  <span v-if="menuType == 28" style="padding-left: 10px">且会员降级后</span>
                  <el-input
                    v-if="menuType == 30"
                    v-model="formData.pointChange"
                    size="small"
                    style="width: 136px"
                    @keyup.native="filNumber"
                    maxlength="10"
                    @blur="sendConditionTips"
                  ></el-input>
                  <el-input
                    v-if="menuType != 4 && menuType != 9 && menuType != 11 && menuType != 16 && menuType != 17 && menuType != 18 && menuType != 19 && menuType != 30"
                    v-model="postForm.sendCondition"
                    size="small"
                    style="width: 136px"
                    @keyup.native="filNumber"
                    maxlength="10"
                    @blur="sendConditionTips"
                  ></el-input>
                  <el-select
                    v-if="menuType != 4 && menuType != 9 && menuType != 11 && menuType != 16 && menuType != 17 && menuType != 18 && menuType != 19 && !isMemCare && !isShopCare"
                    v-model="postForm.sendUnitTime"
                    placeholder="请选择"
                    size="small"
                    style="width: 136px; margin: 0 6px"
                  >
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <span v-if="menuType == 1" style="padding-left: 10px">发送提醒</span>
                  <span v-if="menuType == 2 || menuType == 3" style="padding-left: 10px">未付款，向买家发送催付短信</span>
                  <span v-if="menuType == 5 || menuType == 6 || menuType == 7" style="padding-left: 10px">发送提醒</span>
                  <span v-if="menuType == 8" style="padding-left: 10px">未发货，向买家发送提醒</span>
                  <span v-if="menuType == 10 || menuType == 12" style="padding-left: 10px">发送短信</span>
                  <span v-if="menuType == 13" style="padding-left: 10px">向已收货未评价的买家发送催评短信</span>
                  <span v-if="menuType == 14 || menuType == 20" style="padding-left: 10px">发送感谢短信</span>
                  <span v-if="menuType == 15 || menuType == 21" style="padding-left: 10px">发送安抚短信</span>
                  <span v-if="menuType == 26" style="padding-left: 10px">分钟发送关怀</span>
                  <span v-if="menuType == 27" style="padding-left: 10px">分钟发送关怀</span>
                  <span v-if="menuType == 28" style="padding-left: 10px">分钟发送关怀</span>
                  <span v-if="menuType == 29" style="padding-left: 10px">分钟发送关怀</span>
                  <span v-if="menuType == 30" style="padding-left: 10px">积分时发送提醒</span>
                  <span v-if="menuType == 31" style="padding-left: 10px">分钟发送关怀</span>
                  <span v-if="menuType == 32" style="padding-left: 10px">分钟发送消息</span>
                  <span v-if="menuType == 33" style="padding-left: 10px">分钟发送提醒</span>
                  <span v-if="menuType == 34" style="padding-left: 10px">分钟发送提醒</span>
                  <!-- <el-radio-group v-if="menuType==4" v-model="postForm.sendType"> -->
                  <!-- <el-radio :label="1"> -->
                  <span v-if="menuType == 4">
                    尾款开始后
                    <el-input
                      v-model="postForm.sendCondition"
                      size="small"
                      style="width: 80px"
                      @keyup.native="filNumber"
                      maxlength="10"
                      @blur="sendConditionTips"
                    ></el-input>
                    <el-select v-model="postForm.sendUnitTime" placeholder="请选择" size="small" style="width: 80px; margin: 0 6px">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <span v-if="balancePath"> ~ 尾款结束前</span>
                    <el-input
                      v-if="balancePath"
                      v-model="postForm.balancePaymentRemindEndMinutes"
                      size="small"
                      style="width: 80px"
                      @keyup.native="filNumber"
                      maxlength="10"
                      @blur="sendConditionTips3"
                    ></el-input>
                    <el-select  v-if="balancePath" v-model="postForm.sendUnitTime2" placeholder="请选择" size="small" style="width: 80px; margin: 0 6px">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    未付款，向买家发送催付短信</span
                  >
                  <!-- </el-radio> -->
                  <!-- </el-radio-group> -->
                  <!-- <p v-if="menuType == 9 || menuType == 10" style="color: rgb(254, 77, 69); margin-top: 2px"> -->
                  <div style="width: 286px" v-if="menuType == 9 || menuType == 10" class="footTips">
                    <img
                      src="@/assets/images/new_icon_waring_yellow.png"
                      style="
                        display: inline-block;
                        float: left;
                        position: absolute;
                        width: 14px;
                        height: 14px;
                        color: #ffffff;
                        margin: 0px 4px 0 3px;
                      "
                    />
                    <span style="margin-left: 24px"> 注意：仅支持中通、京东和顺丰快递；</span>
                  </div>
                  <div v-if="menuType == 4" class="footTips" style="width: 588px;height: unset;">
                    <img
                      src="@/assets/images/new_icon_waring_yellow.png"
                      style="
                        display: inline-block;
                        float: left;
                        position: absolute;
                        top:5px;
                        width: 14px;
                        height: 14px;
                        color: #ffffff;
                        margin: 0px 4px 0 3px;
                      "
                    />
                    <span style="margin-left: 24px;white-space: wrap;line-height: 24px;">仅对任务开启后，在预售尾款支付期间且仍未付尾款的消费者发送一条催付短信，发送方式为一次性批量发送，如需多次催付，请前往<span @click="toMarketing" style="text-decoration: underline; color: #7f85e9;cursor: pointer;">预售订单发送</span></span>
                  </div>
                  <!-- </p> -->
                </div>
                <!--发送时段-->
                <div class="right-content" style="margin-top: 8px">
                  <div class="right-content-left">发送时段：</div>
                  <div class="right-content-right">
                    <span>每天</span>

                    <el-time-picker
                      class="time"
                      v-model="postForm.startRemindTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      size="small"
                      style="width: 100px; margin-left: 16px"
                    ></el-time-picker>
                    <!-- <el-time-picker
                      style="width: 100px;margin-left: 12px;"
                      v-model="postForm.startRemindTime"
                      :format="'HH:mm'"
                      :clearable="false"
                      @change="remindTimeTips"
                      placeholder="选择时间"
                    ></el-time-picker> -->
                    <span>&nbsp; 至 &nbsp;</span>
                    <!-- <el-time-picker
                      :clearable="false"
                      v-model="postForm.endRemindTime"
                      :format="'HH:mm'"
                      placeholder="选择时间"
                      :picker-options="{selectableRange:this.maxStartRemindTime + ' - 23:59:59'}"
                      style="width: 100px;"
                    ></el-time-picker> -->
                    <el-time-picker
                      class="time"
                      v-model="postForm.endRemindTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      size="small"
                      style="width: 100px"
                    ></el-time-picker>
                    <span>&nbsp;&nbsp; 时，发送短信。其他时间 &nbsp;</span>
                    <!-- 选择发送段 -->
                    <el-select v-model="postForm.remindSendType" placeholder="请选择" size="small" style="width: 136px; margin-left: 6px">
                      <el-option v-for="item in optionsTwo" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-tooltip class="item" effect="light" placement="top-start">
                      <div slot="content">
                        <span>1.顺延第二天发送：该时间段满足发送条件的订单，会顺延至第二天设置的时间段内发送短信。</span><br />
                        <span>2.不发送说明：该时间段所有满足发送条件的订单，将不再发送短信。</span>
                      </div>
                      <span class="question_icon">?</span>
                    </el-tooltip>
                    <div style="margin-top: 10px">
                      <el-checkbox v-model="postForm.isLunchBreak">
                        <span>午休时间 &nbsp;</span>
                      </el-checkbox>
                      <el-time-picker
                        class="time"
                        v-model="postForm.startLunchBreak"
                        format="HH:mm"
                        value-format="HH:mm"
                        :picker-options="{
                          selectableRange: '09:00:00 - 22:00:00',
                        }"
                        placeholder="选择时间"
                        size="small"
                        style="width: 100px"
                      ></el-time-picker>
                      <span>&nbsp; 至 &nbsp;</span>
                      <el-time-picker
                        class="time"
                        v-model="postForm.endLunchBreak"
                        format="HH:mm"
                        value-format="HH:mm"
                        :picker-options="{
                          selectableRange: '09:00:00 - 20:00:00',
                        }"
                        placeholder="选择时间"
                        size="small"
                        style="width: 100px"
                      ></el-time-picker>
                      <span>&nbsp;&nbsp; 不发送，向后顺延 &nbsp;</span>
                    </div>
                  </div>
                </div>

                <!-- 订金支付时间 -->
                <div class="right-content" v-if="menuType == 4">
                  <div class="right-content-left">定金支付时间：</div>
                  <div class="right-content-right">
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.moneyPayStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 120px; font-size: 12px"
                        class="time1"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      ></el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.moneyPayEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 145px; font-size: 12px"
                        :picker-options="pickerOptions1"
                        class="time2"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      >
                      </el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="clearTime2"></i>
                      <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
                    </div>
                    <span :style="{ color: changeColor }" style="margin-left: 10px">{{ balancePath ? "必填" : "必填" }}</span>
                  </div>
                </div>
                <!-- 尾款支付时间 -->
                <div class="right-content" v-if="balancePath" style="position: relative;height: 66px;">
                  <div class="right-content-left">
                    尾款支付时间：
                  </div>
                  <div
                    style="background: #fffaee;width: 800px;height: 40px;position: absolute;top: 41px;
    left: 19px;color: #666;
    padding: 5px;"
                  >
                    <img
                      src="@/assets/images/new_icon_reminder.png"
                      style="
                            display: inline-block;
                            float: left;
                            width: 14px;
                            height: 14px;
                            color: #ffffff;
                            margin: 0px 4px 0 3px;
                          "
                    />
                    <span>定金和尾款支付时间，建议同官方后台创建的"商品预售”保持一致。</span>
                  </div>
                  <div class="right-content-right">
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.balanceTimeStart"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 120px; font-size: 12px"
                        class="time1"
                        :picker-options="pickerOptions2"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      ></el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.balanceTimeEnd"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 145px; font-size: 12px"
                        class="time2"
                        :picker-options="pickerOptions3"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      >
                      </el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="clearTime3"></i>
                      <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
                    </div>
                    <span :style="{ color: changeColor }" style="margin-left: 10px">必填</span>
                  </div>
                </div>

                <!--发送条件： -->
                <!-- <div class="right-content" v-if="menuType != 20 && menuType != 21"> -->
                <div class="right-content" v-if="!isMemCare">
                  <div class="right-content-left">发送条件：</div>
                  <div class="right-content-right">
                    <div v-if="menuType != 2 && menuType != 3 && menuType != 4 && menuType != 31" style="margin-bottom: 10px;">
                      <el-checkbox v-model="postForm.isOrderMoney">
                        <span>实付金额达到 &nbsp;&nbsp;</span>
                      </el-checkbox>
                      <el-input
                        v-model="postForm.startOrderMoney"
                        placeholder="0"
                        size="small"
                        style="width: 125px"
                        maxlength="15"
                        class="color_gray"
                        @keyup.native="postForm.startOrderMoney = oninput(postForm.startOrderMoney)"
                      >
                        <!-- @change="moneyChange" -->
                        <template slot="suffix">
                          <span>元</span>
                        </template>
                      </el-input>
                      <span>&nbsp; 至 &nbsp;</span>
                      <el-input
                        v-model="postForm.endOrderMoney"
                        placeholder="100"
                        size="small"
                        style="width: 125px"
                        maxlength="15"
                        class="color_gray"
                        @keyup.native="postForm.endOrderMoney = oninput(postForm.endOrderMoney)"
                      >
                        <!-- @change="moneyChange" -->
                        <template slot="suffix">
                          <span>元</span>
                        </template>
                      </el-input>
                    </div>
                    <div style="overflow: hidden">
                      <el-checkbox v-model="postForm.isProductNum">
                        <span>商品数量 &nbsp;&nbsp;</span>
                      </el-checkbox>
                      <div style="display: inline-block; position: relative">
                        <el-input
                          v-model="postForm.startProductNum"
                          placeholder="0"
                          size="small"
                          style="width: 125px; position: relative"
                          maxlength="8"
                          @keyup.native="filNumber"
                          class="color_gray"
                        >
                          <template slot="suffix">
                            <span>件</span>
                          </template>
                        </el-input>
                      </div>
                      <span>&nbsp; 至 &nbsp;</span>
                      <div style="display: inline-block; position: relative">
                        <el-input
                          v-model="postForm.endProductNum"
                          placeholder="0"
                          size="small"
                          maxlength="8"
                          style="width: 125px; position: relative"
                          @keyup.native="filNumber"
                          class="color_gray"
                        >
                          <!-- @change="moneyChange" -->
                          <template slot="suffix">
                            <span>件</span>
                          </template>
                        </el-input>
                      </div>
                    </div>
                    <template v-if="!venderType">
                      <div v-if="menuType != 2 && menuType != 3 && menuType != 4 && menuType != 31" style="margin-top: 10px; overflow: hidden">
                        <el-checkbox v-model="postForm.isSellerRemark">
                          <span>商家备注包含</span>
                        </el-checkbox>
                        <el-select v-model="postForm.sellerRemarkType" @change="(val)=>{if(val=='0') postForm.sellerRemark = ''}" style="width:120px;margin-left: 8px;">
                          <el-option :value="1" label="指定备注"></el-option>
                          <el-option :value="0" label="任意备注"></el-option>
                        </el-select>
                        <el-input 
                          v-if="postForm.sellerRemarkType == 1"
                          v-model="postForm.sellerRemark"
                          placeholder="多关键词用“，”分开"
                          size="small"
                          style="width: 280px; margin-left:8px"
                          maxlength="200"
                        ></el-input>
                        <el-select v-model="postForm.isSellerRemarkSend" placeholder="请选择" size="small" style="width: 136px;margin-left:8px">
                          <el-option v-for="item in sendOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <!-- <el-radio v-model="postForm.isSellerRemarkSend" label="1">发送</el-radio>
                      <el-radio v-model="postForm.isSellerRemarkSend" label="0">
                        不发送 -->
                        <el-tooltip class="item" effect="light" content="商家订单备注，含关键字订单，200字内" placement="top-start">
                          <span class="question_icon">?</span>
                        </el-tooltip>
                        <!-- </el-radio> -->
                      </div>

                      <div v-if="menuType != 2 && menuType != 3 && menuType != 4 && menuType != 31" style="margin-top: 10px; overflow: hidden">
                        <el-checkbox v-model="postForm.isBuyerMessage">
                          <span>买家备注包含</span>
                        </el-checkbox>
                        <el-select v-model="postForm.buyerRemarkType" @change="(val)=>{if(val=='0') postForm.buyerMessage = ''}" style="width:120px;margin-left: 8px;">
                          <el-option :value="1" label="指定备注"></el-option>
                          <el-option :value="0" label="任意备注"></el-option>
                        </el-select>
                        <el-input
                          v-if="postForm.buyerRemarkType ==1"
                          v-model="postForm.buyerMessage"
                          placeholder="多关键词用“，”分开"
                          size="small"
                          style="width: 280px;margin-left: 8px;"
                          maxlength="200"
                        ></el-input>
                        <!--  -->
                        <el-select v-model="postForm.isBuyerMessageSend" placeholder="请选择" size="small" style="width: 136px;margin-left: 8px;">
                          <el-option v-for="item in sendOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>

                        <el-tooltip class="item" effect="light" content="买家订单备注，含关键字订单，200字内" placement="top-start">
                          <span class="question_icon">?</span>
                        </el-tooltip>
                      </div>
                    </template>
                  </div>
                </div>

                <!-- 物流编码 -->
                <div class="right-content" v-if="menuType == 9 || menuType == 10">
                  <div class="right-content-left">
                    物流编码：
                    <div class="request-tip">（京东物流必填）</div>
                  </div>
                  <div class="right-content-right">
                    <el-input v-model="postForm.logisticsNum" size="small" style="width: 136px" maxlength="15"></el-input>
                    <span style="padding: 0 16px 0 0"> 使用京东物流请填写接入物流时的商家编码，否则无法进行短信发送；示例：010K0001</span>
                  </div>
                </div>
                <!-- 顺丰寄件人手机号 -->
                <div class="right-content" v-if="menuType == 9 || menuType == 10">
                  <div class="right-content-left">
                    顺丰寄件人手机号：
                    <div class="request-tip">（顺丰物流必填）</div>
                  </div>
                  <div class="right-content-right">
                    <el-input v-model="postForm.tailNumber" size="small" @keyup.native="limitInput" style="width: 136px" maxlength="4"></el-input>
                    <span style="padding: 0 16px 0 0"> 使用顺丰物流请填写寄件人手机号后四位，否则无法发送短信</span>
                  </div>
                </div>

                <!-- 中通寄件人手机号 -->
                <div class="right-content" v-if="menuType == 9 || menuType == 10">
                  <div class="right-content-left">
                    中通寄件人手机号：
                    <div class="request-tip">（中通物流必填）</div>
                  </div>
                  <div class="right-content-right">
                    <el-input v-model="postForm.ztExpressPhone" size="small" @keyup.native="limitInput" style="width: 136px" maxlength="4"></el-input>
                    <span style="padding: 0 16px 0 0"> 使用中通物流请填写寄件人手机号后四位，否则无法发送短信</span>
                  </div>
                </div>


                <!--过滤设置：-->
                <div class="right-content">
                  <div class="right-content-left">过滤设置：</div>
                  <div class="right-content-right">
                    <div>
                      <el-checkbox-group v-model="postForm.filterCondition" @change="filterCondiions">
                        <el-checkbox label="1">
                          <span>同1个买家1天只提醒一次</span>
                        </el-checkbox>
                        <el-checkbox label="2">
                          <span>屏蔽黑名单</span>
                          <span @click="routerLinkOne()" :style="{ color: changeColor }" style="margin-left: 10px">设置黑名单</span>
                        </el-checkbox>
                        <el-checkbox label="3" v-if="menuType == 2 || menuType == 3 || menuType == 4">
                          <span>多笔订单有付款的不催</span>
                          <el-tooltip
                            class="item"
                            effect="light"
                            content="同一个买家，多笔订单有付款的，按照下单时间1小时前后不再催付；"
                            placement="top-start"
                          >
                            <span class="question_icon">?</span>
                          </el-tooltip>
                        </el-checkbox>
                        <el-checkbox label="4" v-if="menuType == 13 && !venderType">
                          <span>屏蔽给过中差评客户</span>
                        </el-checkbox>
                        <template v-if="!venderType">
                          <el-checkbox label="5" v-if="menuType == 13">
                            <span>屏蔽退过款客户</span>
                          </el-checkbox>
                        </template>
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>

                
                <!-- Note-----会员筛选条件 -->
                <div class="right-content" v-if="!isMemCare && menuType != 32">
                  <div class="right-content-left">会员筛选：</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.memberSelect" label="0">
                      <span>全部</span>
                    </el-radio>
                    <el-radio v-model="postForm.memberSelect" label="1">
                      <span>只发送会员</span>
                    </el-radio>
                    <el-radio v-model="postForm.memberSelect" label="2">
                      <span>只发送非会员</span>
                    </el-radio>
                  </div>
                </div>
                <div class="right-content" v-else-if="menuType != 32">
                  <div class="right-content-left">会员筛选：</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.memberSelect" label="0">
                      <span>发送全部会员</span>
                    </el-radio>
                    <el-radio v-model="postForm.memberSelect" label="3">
                      <span>只发送已购会员</span>
                    </el-radio>
                    <el-radio v-model="postForm.memberSelect" label="4">
                      <span>只发送未购会员</span>
                    </el-radio>
                  </div>
                  
                </div>
                <div class="right-content" v-if="!isMemCare && menuType != 32 && postForm.memberSelect == 1">
                  <div class="right-content-left"></div>
                  <div class="right-content-right"> 
                    <el-checkbox-group
                      v-model="postForm.memberSelectLevel"
                      @change="handleSelectLevel"
                    >
                      <el-checkbox
                        v-for="item in memberLevelOptions"
                        :label="item.value"
                        :key="item.value"
                        @change="changeMemberLevels(item.value)"
                      >
                        <span>{{ item.name }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>

              <!-- 运单号 -->
              <template v-if="!routerPath && !isMemCare && !isShopCare">
                <div
                  class="right-content"
                  v-if="
                    menuType != 1 &&
                      menuType != 2 &&
                      menuType != 3 &&
                      menuType != 4 &&
                      menuType != 9 &&
                      menuType != 20 &&
                      menuType != 21 &&
                      menuType != 10
                  "
                >
                  <div class="right-content-left">运单号：</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.shipmentNum" label="0">
                      <span>全部发送</span>
                    </el-radio>
                    <el-radio v-model="postForm.shipmentNum" label="1">
                      <span>不发送有运单号订单</span>
                    </el-radio>
                    <el-radio v-model="postForm.shipmentNum" label="2">
                      <span>不发送无运单号订单</span>
                    </el-radio>
                  </div>
                </div>
              </template>
              <!--订单类型：-->
              <!-- <div
                  class="right-content"
                  v-if="menuType!=1 && menuType!=2 && menuType!=3 && menuType!=4 && menuType!=13"
                >
                  <div class="right-content-left">订单类型：</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.orderType" label="0">
                      <span>全部</span>
                    </el-radio>
                    <el-radio
                      v-model="postForm.orderType"
                      label="1"
                    >
                      <span>预售</span>
                    </el-radio>
                    <el-radio v-model="postForm.orderType" label="2" style="margin-right: 8px;">
                      <span>非预售</span>
                      <el-select
                        v-model="postForm.presellType"
                        placeholder="请选择"
                        size="small"
                        style="width: 105px;margin-left: 8px;vertical-align: b给过ottom;"
                        v-if="postForm.orderType == 1 && menuType==3"
                      >
                        <el-option
                          v-for="item in optionsThree"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-radio>
                  </div>
                </div> -->

              <!--付款类型：-->
              <!-- <div
                  class="right-content"
                  v-if="menuType==6 || menuType==7"
                >
                  <div class="right-content-left">付款类型：</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.moneyType" :label="item.value" v-for="(item,index) in moneyTypeList" :key="index">
                      <span>{{item.label}}</span>
                    </el-radio>
                  </div>
                </div> -->

              <!-- 付款方式 -->
              <div class="right-content" v-if="menuType != 1 && menuType != 2 && menuType != 3 && menuType != 4 && !isMemCare && !isShopCare">
                <div class="right-content-left">不发送付款方式：</div>
                <div class="right-content-right">
                  <div>
                    <el-checkbox-group v-model="postForm.payType" @change="filterCondiions">
                      <el-checkbox :label="item.value" v-for="(item, index) in payTypeList" :key="index">
                        <span>{{ item.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>

              <!--选择地区：-->
              <div class="right-content" v-if="menuType != 4 && menuType != 14 && menuType != 15 && menuType != 20 && menuType != 21 && !isMemCare" >
                <div class="right-content-left">选择地区：</div>
                <div class="right-content-right">
                  <div class="bb" style="width: 560px">
                    <el-radio
                      v-model="postForm.areaType"
                      v-for="item in areaData"
                      :key="item.value"
                      :label="item.value"
                      @change="customArea(item.value)"
                    >
                      <span>{{ item.name }}</span>
                    </el-radio>
                    <div class="button" @click="popupShowBtn" v-show="postForm.areaType == '3'">
                      已选择
                      <span :style="{ color: '#7f85e9' }">{{ checkedList | getCityLength }}</span>
                      个
                    </div>
                  </div>
                </div>
              </div>

              <!--选择商品-->
              <div class="right-content" v-if="!isMemCare">
                <div class="right-content-left">选择商品：</div>
                <div class="right-content-right">
                  <div class="bb" style="width: 420px">
                    <el-radio-group v-model="postForm.isAllItem" @change="selGoods">
                      <el-radio v-for="item in shoppingData" :key="item.name" :label="item.value">
                        <span>{{ item.name }}</span>
                      </el-radio>
                    </el-radio-group>
                    <div v-show="isShowSelectGoods" class="button" @click="showSelectGoods">
                      已选择
                      <span :style="{ color: '#7f85e9' }">{{ goodsStateLength }}</span>
                      个
                    </div>
                  </div>
                </div>
              </div>

              <!--凑单商品-->
              <div class="right-content" v-if="menuType == 31">
                <div class="right-content-left">凑单商品：</div>
                <div class="right-content-right">
                  <div class="bb" style="width: 420px">
                    <div class="bb-button" @click="showSelectOrderGoods">选择凑单商品（{{formData.intelligentSkuId ? '1':'0'}}/1）</div>
                    <span>温馨提示：凑单商品只能选1个</span>
                  </div>
                </div>
              </div>

              <!-- 针对评分 -->
              <div class="right-content" v-if="menuType == 14 || menuType == 15 || menuType == 20 || menuType == 21">
                <div class="right-content-left">针对评分：</div>
                <div class="right-content-right">
                  <div>
                    <el-checkbox-group v-model="postForm.selectStart" @change="filterCondiions">
                      <el-checkbox :label="item.value" v-for="(item, index) in handleStarList" :key="index">
                        <span>{{ item.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>

              <!-- 发送上限  暂时隐藏 -->
              <div class="right-content" v-if="!isMemCare && menuType != 31 && menuType != 32">
                <div class="right-content-left">发送上限：</div>
                <div class="right-content-right">
                  <span>每日发送量达到</span>&nbsp;
                  <el-input v-model="postForm.dayLimit" size="small" @keyup.native="limitInput1" style="width: 100px" ></el-input>&nbsp;
                  <span>时不发送</span>   
                </div>
              </div>
              </div>

              <div class="next_box">
                <div class="next" :style="{ background: changeColor }" @click="nextBtn()">
                  下一步
                </div>
              </div>

              <!--第二部-->
              <el-drawer
                :withHeader="false"
                :show-close="false"
                :append-to-body="true"
                :before-close="handleClose2"
                :visible.sync="innerDrawer"
                custom-class="inner_Drawer"
                :size="'1100px'"
              >
                <div
                  class="box-conten-small myTwo"
                  key="1547"
                  style="
                    background: #fff;
                    z-index: 9 !important;
                    position: relative;
                    height: 100%;
                  "
                >
                  <div>
                    <span class="page_title">创建任务</span>
                    <span @click="backOne" class="del_icon">x</span>
                  </div>
                  <div class="top_step">
                    <div class="top_step_item step3" :class="{ '': stepNum != 1 }">
                      <span class="circle_icon"><i class="el-icon-check"></i></span>
                      第一步 筛选任务条件
                    </div>
                    <div class="to_next">
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="top_step_item step4">
                      <span class="circle_icon">2</span>
                      第二步 发送短信编辑
                    </div>
                  </div>
                  <div class="two-content" style="position: relative">
                    <div :style="menuType == '2' ? '': 'padding: 100px 0'">
                      <template v-if="hasSms">
                        <div v-if="showSwitch" class="two-item">
                          <div class="item-left">短信触达：</div>
                          <div class="item-right" style="max-width: 548px;line-height: 32px;">
                            <el-switch
                              v-model="formData.isSendSms">
                            </el-switch>
                          </div>
                        </div>
                        <template v-if="openSms">
                          
                          <div class="two-item">
                            <div class="item-left">编辑短信：</div>
                            <template v-if="isOfficial">
                              <div class="item-right">
                                <div class="write-message-box">
                                  <div class="message-content-box">
                                    <div class="message-input-box" style="color: red">
                                      <el-input
                                        v-if="false"
                                        type="textarea"
                                        :rows="7"
                                        maxlength="500"
                                        id="copyIndexInfo"
                                        @input="sendInfoText"
                                        @click.native="getFourIndex"
                                        ref="sendText"
                                        placeholder
                                        v-model="inputContent"
                                        class="send-textare"
                                        disabled
                                      ></el-input>
                                      <div class="sms-content-x">
                                        <div v-html="smsContent2html(inputContent)"></div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="footInfo">
                                    <div>
                                      <button class="keep" @click.prevent="templateShow = true">
                                        短信模板
                                      </button>

                                      <span
                                        >已输入
                                        <span :style="{ color: changeColor }">{{ sendInfoLength }}</span>
                                        个字（含签名及退订文字），预计
                                        <span :style="{ color: changeColor }">{{
                                          Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70)
                                        }}</span>
                                        条短信</span
                                      >
                                    </div>
                                    <div class="ask-content">
                                      <span
                                        style="
                                          font-weight: normal;
                                          margin-left: 12px;
                                          color: #6069ff;
                                        "
                                        >计费规则</span
                                      >
                                      <span class="question_icon" style="margin-left: 4px">?</span>
                                      <div class="ask-icon-select">
                                        <div>
                                          1.70个字计1条短信，超过70字按照67字每条计费。
                                        </div>
                                        <div>
                                          2.一个汉字，字母或标点空格都算作一个字。
                                        </div>
                                        <div>
                                          3.带标签短信以实际发送为准，有可能超过默认字数。
                                        </div>
                                        <!-- <div>4."签名"包含在字数中。</div> -->
                                        <div>4."签名"与"拒收请回复R"包含在字数中。</div>
                                        <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                                        <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <div class="message-tips-box" style="max-width:600px">
                                    <div>
                                      <img src="@/assets/images/tishi.png" />
                                      <span>注：输入网址前、后加空格，否则无法正常打开！</span>
                                    </div>
                                    <div v-if="getInputFilterList&&getInputFilterList.length>0">
                                      <img src="@/assets/images/tishi.png" />
                                      <span>
                                        注：易被手机拦截内容：
                                        <span
                                          v-for="(item,index) in getInputFilterList"
                                          :key="index"
                                        >({{item.word}}，建议替换为：{{item.replace}})</span>
                                      </span>
                                    </div>
                                  </div> -->
                                </div>
                              </div>
                            </template>
                            <template v-else>
                              <div class="item-right">
                                <div class="write-message-box write-message-box2">
                                  <div class="label">
                                    <div
                                      style="
                                        float: left;
                                        font-size: 14px;
                                        color: #333;
                                      "
                                    >
                                      可选标签：
                                    </div>
                                    <div class="label_content">
                                      <template v-for="(item, index) in smsLabel">
                                        <div @click="selectTagTap(item)" class="label_items" :key="index">
                                          {{ item }}
                                        </div>
                                      </template>
                                    </div>
                                  </div>
                                  <div class="message-content-box">
                                    <div class="message-input-box" style="color: red">
                                      <el-input
                                        type="textarea"
                                        :rows="7"
                                        maxlength="500"
                                        id="copyIndexInfo"
                                        @input="sendInfoText"
                                        @click.native="getFourIndex"
                                        ref="sendText"
                                        placeholder
                                        v-model="inputContent"
                                        class="send-textare"
                                      ></el-input>
                                    </div>
                                  </div>

                                  <div class="footInfo">
                                    <div>
                                      <button class="selectBtn" @click.prevent="templateShow = true">
                                        选择模板
                                      </button>
                                      <button class="keepBtn" @click.prevent="handleShowModule">
                                        保存模板
                                      </button>
                                      <!-- <button
                                        class="keep"
                                        @click.prevent="templateShow = true"
                                      >
                                        短信模板
                                      </button> -->
                                      <span
                                        >已输入
                                        <span :style="{ color: changeColor }">{{ sendInfoLength }}</span>
                                        个字（含签名及退订文字），预计
                                        <span :style="{ color: changeColor }">{{
                                          Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70)
                                        }}</span>
                                        条短信</span
                                      >
                                    </div>
                                    <div class="ask-content">
                                      <span
                                        style="
                                          font-weight: normal;
                                          margin-left: 12px;
                                          color: #6069ff;
                                        "
                                        >计费规则</span
                                      >
                                      <span class="question_icon" style="margin-left: 4px">?</span>
                                      <div class="ask-icon-select">
                                        <div>
                                          1.70个字计1条短信，超过70字按照67字每条计费。
                                        </div>
                                        <div>
                                          2.一个汉字，字母或标点空格都算作一个字。
                                        </div>
                                        <div>
                                          3.带标签短信以实际发送为准，有可能超过默认字数。
                                        </div>
                                        <div>4."签名"与"拒收请回复R"包含在字数中。</div>
                                        <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                                        <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>

                              <!-- 温馨提示 -->
                          <div class="topTis top_bg" style="width: 548px;margin-left: 118px;margin-top: 8px;" v-if="isOfficial && menuType != 2">
                            <!-- <i class="el-icon-warning" style="color: #FE8F8A; marginRight: 8px;"></i> -->
                            <img
                              src="@/assets/images/new_icon_reminder.png"
                              style="
                                display: inline-block;
                                float: left;
                                width: 14px;
                                height: 14px;
                                color: #ffffff;
                                margin: 3px 4px 0 3px;
                              "
                            />
                            <div v-if="menuType != 20 && menuType != 21" class="desc" style="background: transparent">
                              <p>
                                1.此功能是京东官方功能，发送短信需使用官方模板，不支持手动编辑；
                              </p>
                              <p>
                                2.短信内容中含变量标签时,发送时平台会自动替换为实际信息；
                              </p>
                              <p>
                                3.后台管理-短信模板，可自行申请官方模板，官方审核通过后即可使用。
                              </p>
                              <p v-if="longlinkFlay" style="color:#d9001b;word-wrap: break-word;word-break: break-all;">
                                4.模板中自定义链接的原网址绑定为: {{ this.longUrllink }}
                              </p>
                              <p v-if="longlinkFlay" style="word-wrap: break-word;word-break: break-all;max-width: 500px;">
                                5.原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                              </p>
                            </div>
                            <div v-else>
                              <p>
                                1.此功能为京东官方功能，暂不支持商家自行编辑短信内容，请选择京东官方提供的短信模板
                              </p>
                              <p>
                                2.后台管理-短信模板，可自行申请官方模板，官方审核通过后即可使用。
                              </p>
                              <p v-if="longlinkFlay">3.模板中自定义链接的原网址绑定为: {{ this.longUrllink }}</p>
                              <p v-if="longlinkFlay">
                                5.原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                              </p>
                            </div>
                          </div>

                          <div class="topTis top_bg" style="width: 620px; margin-top: 15px; margin-left: 118px;" v-if="menuType == 2">
                            <img
                              src="@/assets/images/new_icon_reminder.png"
                              style="
                                display: inline-block;
                                float: left;
                                width: 14px;
                                height: 14px;
                                color: #ffffff;
                                margin: 3px 4px 0 3px;
                              "
                            />
                            <div class="desc" style="background: transparent">
                              <p>
                                1.此功能是京东官方功能，发送短信需使用官方模板，不支持手动编辑；
                              </p>
                              <p>
                                2.短信内容中含变量标签时,发送时平台会自动替换为实际信息；
                              </p>
                              <p>
                                3.后台管理-短信模板，可自行申请官方模板，官方审核通过后即可使用。
                              </p>
                              <p v-if="longlinkFlay" style="color:#d9001b;word-wrap: break-word;word-break: break-all;">
                                4.模板中自定义链接的原网址绑定为: {{ this.longUrllink }}
                              </p>
                              <p v-if="longlinkFlay" style="word-wrap: break-word;word-break: break-all;max-width: 500px;">
                                5.原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                              </p>
                            </div>
                          </div>
                          <div class="two-item">
                            <div class="item-left">短信签名：</div>
                            <div class="item-right">
                              <div style="width: 580px">
                                <div class="btnList">
                                  <template v-for="(item, index) in suffixList">
                                    <div class="btnBox" :key="index" @click="changeSufix(item)">
                                      <button
                                        class="btn"
                                        :class="{
                                          btn_active: item == selSuffixName,
                                        }"
                                        style="width: 100%"
                                      >
                                        {{ item }}
                                      </button>
                                      <span v-show="item == selSuffixName" class="check">
                                        <i class="el-icon-check"></i>
                                      </span>
                                    </div>
                                  </template>
                                  <span style="fontsize: 14px; cursor: pointer" :style="{ color: changeColor }" @click="moreBtn()">更换</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="two-item" v-if="longlinkFlay">
                            <div class="item-left">辅助工具：</div>
                            <div class="item-right">
                              <div class="tool">
                                <p @click="insertShortUrlShow = true">
                                  <i class="iconfont iconbtn_duanwangzhi"></i>
                                  插入短网址
                                </p>
                              </div>
                            </div>
                          </div>
                          <div v-if="!isOfficial" class="topTis topTis2">
                            <img
                              src="@/assets/images/new_icon_reminder.png"
                              style="
                                display: inline-block;
                                float: left;
                                width: 14px;
                                height: 14px;
                                color: #ffffff;
                                margin: 3px 4px 0 3px;
                              "
                            />
                            <div class="desc">
                              <p>（1）输入网址前、后加空格，否则无法正常打开；</p>
                              <p>
                                （2）根据运营商规定，请不要发送“返现” “加微信”相关内容的短信；
                              </p>
                              <p>（3）短信内容请不要含有繁体字。</p>
                            </div>
                          </div>

                          <div class="two-item">
                            <div class="item-left">
                              <span style="display: inline-block">短信测试：</span>
                            </div>
                            <div class="item-right">
                              <!-- <el-select
                                v-model="postForm.testSelect"
                                placeholder="请选择"
                                size="small"
                                style="width: 136px;margin-right:6px"
                              >
                                <el-option
                                  v-for="item in testOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select> -->
                              <div class="input-box">
                                <!-- <el-input
                                  size="small"
                                  v-model="smsTestSendParams.mobiles"
                                  style="width: 224px"
                                  placeholder="输入测试号码"
                                ></el-input> -->
                                <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                              <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                              </div>
                              <div class="test-button" @click="testSend">
                                发送短信测试
                              </div>
                              <div class="test-button test_button2" @click="smsState2 = true">
                                短信记录
                              </div>
                              <div class="test-button test_button2" style="width: auto;" @click="showchangetestphone = true">
                                修改测试手机号
                              </div>
                            </div>
                          </div>
                        </template>
                      </template>
                      <template v-if="hasDongDong">
                        <div v-if="showSwitch" class="two-item">
                          <div class="item-left">咚咚消息：</div>
                          <div class="item-right" style="max-width: 548px;line-height: 32px;">
                            <el-switch
                              v-model="formData.isSendDongDong">
                            </el-switch>
                          </div>
                        </div>
                        <template v-if="openDongDong">
                          <div class="two-item">
                            <div class="item-left">发送客服：</div>
                            <div class="item-right" style="max-width: 568px;">
                              <el-input
                                style="max-width: 548px;"
                                placeholder='请输入客服ID，支持最多5个，可用英文","分隔'
                                @change="handleWaiterInput"
                                v-model="formData.waiter"
                              ></el-input>
                              <el-tooltip 
                                class="item"
                                effect="light"
                                content="请从官方客服平台kf.jd.com客服总览获取客服ID"
                                placement="top-start"
                              >
                                <div slot="content">请从官方客服平台 <a href="https://kf.jd.com/" target="_blank">kf.jd.com</a> 客服总览获取客服ID</div>
                                <span class="question_icon" style="margin-left: 4px;background-color: #ff9449;border-color:#FFFFFF; color:#ffffff !important;cursor: pointer;">!</span>
                              </el-tooltip>
                            </div>
                          </div>
                          <div class="two-item">
                            <div class="item-left">咚咚消息：</div>
                            <div class="item-right" style="max-width: 548px;">
                              <el-input
                                type="textarea"
                                :rows="7"
                                maxlength="140"
                                show-word-limit
                                v-model="formData.dongDongContent"
                              ></el-input>
                            </div>
                          </div>
                          <div class="two-item">
                            <div class="item-left">辅助工具：</div>
                            <div class="item-right" style="max-width: 548px;">
                              <div class="tool">
                                <p @click="insertShortUrlShow = true;isDDUrl = true">
                                  <i class="iconfont iconbtn_duanwangzhi"></i>
                                  插入短网址
                                </p>
                              </div>
                            </div>
                          </div>
                        </template>
                      </template>
                      <template v-if="!hasSms && !hasDongDong">
                        <div class="notShow">
                          <img src="@/assets/images/未开通富信.png" alt="">
                          <p>您还未开通此功能!</p>
                        </div>
                      </template>
                    </div>

                    <div v-if="openSms" class="xiao-hug xiao_hug" style="position: absolute; right: 40px; top: 80px">
                      <div style="margin: 0 auto">
                        <div class="mobile-box">
                          <div v-if="isOfficial" class="message-content">【{{ selSuffixName }}】{{ postForm.content | enVToChinese }}</div>
                          <div v-else class="message-content">【{{ selSuffixName }}】{{ postForm.content | enVToChinese }}</div>
                        </div>
                        <div class="mobile-tips">短信预览效果</div>
                      </div>
                    </div>
                  </div>
                  <!-- 二次催付开启 -->
                  <!-- !hasDongDong && postForm.isOpenSecond ：无咚咚消息，打开了二次催付按钮 -->
                  <div class="second-remind" v-if="menuType == '2'" :style="(!hasDongDong && postForm.isOpenSecond)? 'padding-top: 220px':
                  (postForm.isOpenSecond && (!openDongDong && openSms)? 'padding-top: 135px': 'padding-top: 5px')">
                    <div class="second-remind-switch"> 
                      <span class="second-label">二次催付：</span>
                      <el-switch
                        v-model="postForm.isOpenSecond">
                      </el-switch>
                      <template v-if="postForm.isOpenSecond">
                        <div class="second-time-box">
                          <span>首次催付后</span>
                          <el-input v-model="postForm.sendCondCondit" placeholder="" style="width: 136px; margin-left: 6px;" maxlength="10"></el-input>
                          <el-select
                            v-model="postForm.secondUnitTimeType"
                            placeholder="请选择"
                            size="small"
                            style="width: 136px; margin: 0 6px"
                          >
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                          <span>未付款，向买家发送催付短信</span>
                        </div>
                      </template>
                    </div>
                    <template v-if="postForm.isOpenSecond">
                      <div class="two-content" style="position: relative">
                        <template v-if="hasSms">
                          <div v-if="showSwitch" class="two-item">
                            <div class="item-left">短信触达：</div>
                            <div class="item-right" style="max-width: 548px;line-height: 32px;">
                              <el-switch
                                v-model="formSecond.isSendSms">
                              </el-switch>
                            </div>
                          </div>
                          <template v-if="openSmsSecond">
                            <div class="two-item">
                              <div class="item-left">编辑短信：</div>
                              <div class="item-right">
                                <div class="write-message-box">
                                  <div class="message-content-box">
                                    <div class="message-input-box" style="color: red">
                                      <div class="sms-content-x">
                                        <!-- todo -->
                                        <template v-if="!!postForm.contnet2 && postForm.contnet2.length > 0">
                                          <div v-html="smsContent2html2(inputContent2)"></div>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="footInfo">
                                    <div>
                                      <button class="keep" @click.prevent="templateShow2 = true">
                                        短信模板
                                      </button>

                                      <span
                                        >已输入
                                        <span :style="{ color: changeColor }">{{ sendInfoLength2 }}</span>
                                        个字（含签名及退订文字），预计
                                        <span :style="{ color: changeColor }">{{
                                          Math.ceil(sendInfoLength2 > 70 ? sendInfoLength2 / 67 : sendInfoLength2 / 70)
                                        }}</span>
                                        条短信</span
                                      >
                                    </div>
                                    <div class="ask-content">
                                      <span
                                        style="
                                          font-weight: normal;
                                          margin-left: 12px;
                                          color: #6069ff;
                                        "
                                        >计费规则</span
                                      >
                                      <span class="question_icon" style="margin-left: 4px">?</span>
                                      <div class="ask-icon-select">
                                        <div>
                                          1.70个字计1条短信，超过70字按照67字每条计费。
                                        </div>
                                        <div>
                                          2.一个汉字，字母或标点空格都算作一个字。
                                        </div>
                                        <div>
                                          3.带标签短信以实际发送为准，有可能超过默认字数。
                                        </div>
                                        <!-- <div>4."签名"包含在字数中。</div> -->
                                        <div>4."签名"与"拒收请回复R"包含在字数中。</div>
                                        <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                                        <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- 提示语 -->
                            <div class="topTis top_bg" style="width: 620px; margin-top: 15px; margin-left: 118px;">
                              <img
                                src="@/assets/images/new_icon_reminder.png"
                                style="
                                  display: inline-block;
                                  float: left;
                                  width: 14px;
                                  height: 14px;
                                  color: #ffffff;
                                  margin: 3px 4px 0 3px;
                                "
                              />
                              <div class="desc" style="background: transparent">
                                <p>
                                  1.此功能是京东官方功能，发送短信需使用官方模板，不支持手动编辑；
                                </p>
                                <p>
                                  2.短信内容中含变量标签时,发送时平台会自动替换为实际信息；
                                </p>
                                <p>
                                  3.后台管理-短信模板，可自行申请官方模板，官方审核通过后即可使用。
                                </p>
                                <p v-if="longlinkFlay" style="color:#d9001b;word-wrap: break-word;word-break: break-all;">
                                  4.模板中自定义链接的原网址绑定为: {{ this.longUrllink }}
                                </p>
                                <p v-if="longlinkFlay" style="word-wrap: break-word;word-break: break-all;max-width: 500px;">
                                  5.原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                                </p>
                              </div>
                            </div>
                            <!-- 短信签名 -->
                            <div class="two-item">
                              <div class="item-left">短信签名：</div>
                              <div class="item-right">
                                <div style="width: 580px">
                                  <div class="btnList">
                                    <template v-for="(item, index) in suffixList">
                                      <div class="btnBox" :key="index" @click="changeSufix(item)">
                                        <button
                                          class="btn"
                                          :class="{
                                            btn_active: item == selSuffixName,
                                          }"
                                          style="width: 100%"
                                        >
                                          {{ item }}
                                        </button>
                                        <span v-show="item == selSuffixName" class="check">
                                          <i class="el-icon-check"></i>
                                        </span>
                                      </div>
                                    </template>
                                    <span style="fontsize: 14px; cursor: pointer" :style="{ color: changeColor }" @click="moreBtn()">更换</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- 短信测试 -->
                            <div class="two-item">
                              <div class="item-left">
                                <span style="display: inline-block">短信测试：</span>
                              </div>
                              <div class="item-right">
                                <div class="input-box">
                                  <!-- <el-input
                                    size="small"
                                    v-model="smsTestSendParams2.mobiles"
                                    style="width: 224px"
                                    placeholder="输入测试号码"
                                  ></el-input> -->
                                  <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                              <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                                </div>
                                <div class="test-button" @click="testSend2">
                                  发送短信测试
                                </div>
                                <div class="test-button test_button2" @click="smsState2 = true">
                                  短信记录
                                </div>
                                <div class="test-button test_button2" style="width: auto;" @click="showchangetestphone = true">
                                  修改测试手机号
                                </div>
                              </div>
                            </div>
                            <!-- 手机 -->
                            <div class="xiao-hug xiao_hug" style="position: absolute; right: 40px; top: 0">
                              <div style="margin: 0 auto">
                                <div class="mobile-box">
                                  <div class="message-content">【{{ selSuffixName }}】{{ postForm.contnet2 | enVToChinese }}</div>
                                </div>
                                <div class="mobile-tips">短信预览效果</div>
                              </div>
                            </div>
                          </template>
                        </template>
                        <template v-if="hasDongDong">
                          <div v-if="showSwitch" class="two-item">
                            <div class="item-left">咚咚消息：</div>
                            <div class="item-right" style="max-width: 548px;line-height: 32px;">
                              <el-switch
                                v-model="formSecond.isSendDongDong">
                              </el-switch>
                            </div>
                          </div>
                          <template v-if="openDongDongSecond">
                            <div class="two-item">
                              <div class="item-left">发送客服：</div>
                              <div class="item-right" style="max-width: 568px;">
                                <el-input
                                  style="max-width: 548px;"
                                  placeholder='请输入客服ID，支持最多5个，可用 "," 分隔'
                                  @change="handleWaiterInputByformSecond"
                                  v-model="formSecond.waiter"
                                ></el-input>
                                <el-tooltip 
                                  class="item"
                                  effect="light"
                                  content="请从官方客服平台kf.jd.com客服总览获取客服ID"
                                  placement="top-start"
                                >
                                  <div slot="content">请从官方客服平台 <a href="https://kf.jd.com/" target="_blank">kf.jd.com</a> 客服总览获取客服ID</div>
                                  <span class="question_icon" style="margin-left: 4px;background-color: #ff9449;border-color:#FFFFFF; color:#ffffff !important;cursor: pointer;">!</span>
                                </el-tooltip>
                              </div>
                            </div>
                            <div class="two-item">
                              <div class="item-left">咚咚消息：</div>
                              <div class="item-right" style="max-width: 548px;">
                                <el-input
                                  type="textarea"
                                  :rows="7"
                                  maxlength="140"
                                  show-word-limit
                                  v-model="formSecond.dongDongContent"
                                ></el-input>
                              </div>
                            </div>
                            <div class="two-item">
                              <div class="item-left">辅助工具：</div>
                              <div class="item-right" style="max-width: 548px;">
                                <div class="tool">
                                  <p @click="insertShortUrlShow = true;isSecondDDUrl = true">
                                    <i class="iconfont iconbtn_duanwangzhi"></i>
                                    插入短网址
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>
                        </template>
                        <template v-if="!hasSms && !hasDongDong">
                          <div class="notShow">
                            <img src="@/assets/images/未开通富信.png" alt="">
                            <p>您还未开通此功能!</p>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <!-- 按钮 -->
                  <div class="box-step" style="padding: 0 10px">
                    <div class="btn_all" style="">
                      <div
                        class="button2"
                        :style="{ background: changeColor }"
                        @click="
                          () => {
                            return saveTap(1);
                          }
                        "
                        :class="{ disBtn2: disBtn2 === true }"
                      >
                        <i v-show="loadBtn1" class="el-icon-loading"></i>
                        保存并开启
                      </div>
                      <div
                        class="button1"
                        :style="{
                          border: '1px solid' + changeColor,
                          color: changeColor,
                        }"
                        @click="saveTap(0)"
                        :class="{ disBtn1: disBtn1 === true }"
                      >
                        <i v-show="loadBtn2" class="el-icon-loading"></i>
                        保存设置
                      </div>
                      <div class="button1 return_btn" style="float: right" @click="backOne">
                        返回上一步
                      </div>
                    </div>
                  </div>

                  <!-- </div> -->
                </div>
              </el-drawer>
            </div>
          </div>
          <!-- <div :style="{'height':scorllY}"></div> -->
          <!--<div style="height: 1px;"></div>-->
        </div>
      </div>
    </el-drawer>

    <!-- 自定义城市弹窗 -->
    <city-popover v-model="areaState" :checkedList="checkedList" :isProvince="true" @on-change="changeCity"></city-popover>
    <short-message v-if="shortState" @transferName="shortBtn1" :isShowTip="isShowTip"></short-message>
    <!-- 选择商品组件 -->
    <!-- <select-goods v-if="goodsState" @transferName="goodsPopupBtn" :postForm="postForm.itemList"></select-goods> -->
    <template v-if="!venderType">
      <select-goods
         v-if="goodsState"
        :isShow="goodsState"
        :moduleType="true"
        :skuSearch="false"
        :selectGoods="returnSelectGoods"
        :selectGoodsSkuList="selectGoodsSkuList"
        :GoodsSkuIsflay="true"
        @close="selectGoodsChange"
      ></select-goods>
    </template>
    <template v-if="venderType">
      <select-goods
        v-if="goodsState"
        :isShow="goodsState"
        :moduleType="true"
        :skuSearch="menuType == 4 || menuType == 20 || menuType == 21 || venderType ? true : false"
        :selectGoods="returnSelectGoods"
        :selectGoodsSkuList="selectGoodsSkuList"
        :GoodsSkuIsflay="true"
        @close="selectGoodsChange"
      ></select-goods>
    </template>
    <!-- 凑单商品 -->
    <!-- <select-goods
        key="order"
        v-if="goodsOrderState"
        :isShow="goodsOrderState"
        :moduleType="true"
        :skuSearch="true"
        :selectGoods="returnSelectGoods"
        :selectGoodsSkuList="selectGoodsSkuList"
        :GoodsSkuIsflay="false"
        :limit="1"
        @close="selectOrderGoodsChange"
      ></select-goods> -->
    <select-goods
        key="order"
        v-if="goodsOrderState"
        :isShow="goodsOrderState"
        :moduleType="true"
        :skuSearch="true"
        :selectGoods="returnSelectOrderGoods"
        :selectGoodsSkuList="selectOrderGoodsSkuList"
        :GoodsSkuIsflay="false"
        :limit="1"
        @close="selectOrderGoodsChange"
      ></select-goods>
    <!-- <select-goods
      :skuSearch="menuType == 4 || menuType == 20 || menuType == 21 || venderType ? true : false"
      :isShow="goodsState2"
      :moduleType="true"
      :selectGoods="returnSelectGoodsExclude"
      @close="selectGoodsChange2"
    ></select-goods> -->

    <!-- 选择模板 -->
    <sms-template
      v-if="templateShow"
      :isShow="templateShow"
      v-bind="$attrs"
      :isOfficial="isOfficial"
      :iscareModul="true"
      @close="templateChange"
    ></sms-template>
    <!-- 选择模板二次催付 -->
    <sms-template
      v-if="templateShow2"
      :isShow="templateShow2"
      v-bind="$attrs"
      :isOfficial="isOfficial"
      :iscareModul="true"
      @close="templateChange2"
    ></sms-template>

    <!-- 保存模板 -->
    <my-popup title="保存模板" width="370" :flag="keepTmpShow" zIndex="3500" @close="keepTmpChange">
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select v-model="keepTmpValue" placeholder="请选择" style="width: 240px">
            <el-option v-for="(item, index) in dirList" :key="index" :label="item.title" :value="item.tid"></el-option>
            <!-- <el-option label="云短信旗舰店专用" :value="1"></el-option>
            <el-option label="太阳短信旗舰店专用" :value="2"></el-option>
            <el-option label="月亮短信旗舰店专用" :value="3"></el-option>-->
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

    <!-- 短信记录 -->
    <sms-template2 :smsDialog="smsState2" v-if="smsState2" @transferName="shortBtnTwo2" :showTest="true"></sms-template2>
    <!-- 发送确认弹窗 -->
    <el-dialog :visible.sync="showSendConfirm" title="发送确认" append-to-body width="450px" custom-class="send-con-dialog">
      <div>
        <span>提交号码为 {{ phoneLenght }}</span>
        <!-- <span v-if="!isTestSend">发送人数<span :style="{'color': globalBG}">{{sendPeopleNum}}</span>人</span> -->
        ，当前短信字数为
        <span :style="{ color: changeColor }">{{ sendInfoLength }}</span>
        字，每条短信以
        <span :style="{ color: changeColor }">{{ Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}</span>
        条计费，提交
        <span :style="{ color: changeColor }">{{ phoneLenght * Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}</span>
        条短信，以实际发送条数为准！
      </div>
      <div class="btn-group">
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
        <el-button @click="showSendConfirm = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 发送确认弹窗 二次催付 -->
    <el-dialog :visible.sync="showSendConfirm2" title="发送确认" append-to-body width="450px" custom-class="send-con-dialog">
      <div>
        <span>提交号码为 {{ phoneLenght }}</span>
        <!-- <span v-if="!isTestSend">发送人数<span :style="{'color': globalBG}">{{sendPeopleNum}}</span>人</span> -->
        ，当前短信字数为
        <span :style="{ color: changeColor }">{{ sendInfoLength }}</span>
        字，每条短信以
        <span :style="{ color: changeColor }">{{ Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}</span>
        条计费，提交
        <span :style="{ color: changeColor }">{{ phoneLenght * Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}</span>
        条短信，以实际发送条数为准！
      </div>
      <div class="btn-group">
        <el-button type="primary" @click="handleSendConfirm2">发送</el-button>
        <el-button @click="showSendConfirm2 = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 插入短链接 -->
    <insert-short-dialog v-show="insertShortUrlShow" zIndex="4000" :typeSms="smsType" @close="handleCloseShort"></insert-short-dialog>
    
    <changetestphone :textPhoneId="textPhoneId" :nowtestMobiles="nowtestMobiles" v-if="showchangetestphone" @close="showchangetestphone = false" @mobilPhoneSubmit="mobilPhoneSubmit"></changetestphone>
  </div>
</template>

<script>
import shortMessage from "./chidrenCare/shorts-message.vue";
// import smsTemplate from "./chidrenCare/sms-templates.vue";
import selectBaby from "./chidrenCare/goods-abbreviation.vue";
import logisticsLink from "./chidrenCare/logisticsLink";

import testVue from "./chidrenCare/testVue";
import sendConfirm from "../../components/send-confirm.vue";
// import CityPopover from "../../components/city-popover";
import CityPopover from "@/components/city-popover-x";
// import SelectGoods from "../../components/select-goods";
import SelectGoods from "../../components/selectGoodsMonitor";

import smsTemplate from "@/views/serviceCenter/sms_template";
import smsTemplate2 from "@/components/sms-templates-x.vue";
import myPopup from "../../components/myPopup";

import { addOrdersCare, updateOrdersCare } from "@/api/care/orderCare";
import { updateAndSave, OrdersCareRefundInfo, addRefundProvinceConfig } from "@/api/care/refundReminderConfigController";
import { insertOrUpdate } from "@/api/care/popCommentConfigController";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { preCommit,NewPreCommit, precisionMarketing, platformSend,getValidSmsTestMobiles } from "@/api/smsSend";

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { getTemplateDir, createTemplate } from "@/api/smsTemplates";
import insertShortDialog from "@/components/insert-short-dialog";
// import { SEND_DEFAULT_INFO } from "./carePublic";
import moment from "moment";
import changetestphone from "@/components/changetestphone.vue";
// import miniPage from "../service/dialog/miniPage";

const defaultForm = {};
// const JZH_CODE = "9,10,11";
const JZH_CODE = [
  { code: "9", city: "" },
  { code: "10", city: "" },
  { code: "11", city: "" },
];

// const PY_CODE = "5,25,26,29,31";
const PY_CODE = [
  { code: "5", city: "" },
  { code: "25", city: "" },
  { code: "26", city: "" },
  { code: "29", city: "" },
  { code: "31", city: "" },
];

const DEFAULT_TIME = {
  1: { time: "30", type: "0" },
  2: { time: "30", type: "0" },
  3: { time: "30", type: "0" },
  4: { time: "30", type: "0" },
  5: { time: "0", type: "0" },
  6: { time: "0", type: "0" },
  7: { time: "0", type: "0" },
  8: { time: "12", type: "1" },
  9: { time: "0", type: "0" },
  10: { time: "0", type: "0" },
  11: { time: "0", type: "0" },
  12: { time: "0", type: "0" },
  13: { time: "0", type: "0" },
  14: { time: "0", type: "0" },
  15: { time: "0", type: "0" },
  16: { time: "0", type: "0" },
  17: { time: "0", type: "0" },
  18: { time: "0", type: "0" },
  19: { time: "0", type: "0" },
  20: { time: "0", type: "0" },
  21: { time: "0", type: "0" },
  26: { time: "0", type: "0" },
  27: { time: "0", type: "0" },
  28: { time: "0", type: "0" },
  29: { time: "0", type: "0" },
  30: { time: "0", type: "0" },
  31: { time: "0", type: "0" },
  32: { time: "0", type: "0" },
  33: { time: "0", type: "0" },
  34: { time: "0", type: "0" },
};
export default {
  name: "page-condition",

  destroyed() {
    document.body.style.overflow = "";
  },
  watch: {},
  components: {
    insertShortDialog,
    shortMessage,
    smsTemplate,
    sendConfirm,
    smsTemplate2,
    CityPopover,
    SelectGoods,
    selectBaby,
    logisticsLink,
    testVue,
    // miniPage,
    // selectOderGoods,
    myPopup,
    changetestphone
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    isShowTip: {
      type: Boolean,
      default: false,
    },
    scorllY: {
      type: String,
      require: true,
    },
    bodyHeight: {
      type: Number,
      require: true,
    },
    isAdd: {
      type: Boolean,
    },
    menuType: {
      type: Number,
    },
    // 接受父组件的数据
    postForms: {
      type: Object,
      // default() {
      //   return defaultForm;
      // }
    },
    // isShow: {
    //   type: Boolean
    // },
  },

  data() {
    return {
      textPhoneId:"",
      nowtestMobiles:"",
      showchangetestphone:false,
      testOptions: [], // 获取测试手机号
      Selectmobiles:[],

      permissionsList: [],
      longlinkFlay: false,
      longlinkFlay2: false,
      longUrllink2: "",
      longUrllink: "",
      smsType: 2,
      insertShortUrlShow: false,
      isDDUrl:false,
      isSecondDDUrl:false,
      // drawerWidth: '780px',
      drawerWidth: "1000px",
      drawers: false,
      innerDrawer: false, // 嵌套的抽屉
      timer: null,
      selectGoodsSkuList: [],
      returnSelectGoods: [], //选择商品回显
      returnSelectGoodsAppoint: [], //指定商品
      returnSelectGoodsExclude: [], //排除商品
      returnSelectOrderGoods:[], //凑单商品回显
      selectOrderGoodsSkuList:[],
      TTip: "拒收请回复R",
      loadBtn1: false,
      //保存模板数据
      dirList: [],
      // 保存模板状态控制 ---- 内容
      keepTmpShow: false,
      keepTmpValue: "",
      loadBtn2: false,
      isShowSelectGoods: false,
      startList: [
        // {
        //   value: "0",
        //   label: ""
        // },
        {
          value: "1",
          label: "1星",
        },
        {
          value: "2",
          label: "2星",
        },
        {
          value: "3",
          label: "3星",
        },
        {
          value: "4",
          label: "4星",
        },
        {
          value: "5",
          label: "5星",
        },
      ],
      moneyTypeList: [
        {
          value: "0",
          label: "不限",
        },
        {
          value: "1",
          label: "在线支付",
        },
        {
          value: "2",
          label: "货到付款",
        },
      ],
      payTypeList: [
        {
          value: "1",
          label: "货到付款",
        },
        {
          value: "2",
          label: "邮局汇款",
        },
        {
          value: "3",
          label: "自提",
        },
        {
          value: "4",
          label: "在线支付",
        },
        {
          value: "5",
          label: "公司转账",
        },
        {
          value: "6",
          label: "银行卡转账",
        },
      ],
      templateShow: false, // 短信模板弹窗
      templateShow2: false, // 短信模板弹窗二次催付
      stepNum: 1, // 步骤条
      disBtn1: "",
      disBtn2: "",
      hahah: "",
      remindConfigItemObj: {},
      goodsOderState: false,
      difficultType: 1,
      testVueDialog: false,
      babyState: false, //宝贝
      logisticsLinkDialog: false, //物流
      lastInsertLink: "",
      checkedList: [],
      maxStartRemindTime: "00:00:00",
      filterWordsList: [],
      getInputFilterList: [],
      cursurPosition: 0, //光标内容
      suffixList: [], //短信签名列表
      selSuffixName: "", //选中签名
      tradeFromJHS: "JHS",
      //sendInfoLength: "", //输入长度
      areaList: [],
      taskTile: "",
      postForm: {
        orderStartTime: "",
        testSelect: 0,
        dayLimit:"",
      },
      checkedTradeFrom: [],
      reasonReturnList: [], //退款原因列表
      buyerGoodsValue: "0",
      checkedMemberLevel: [],
      checkedSellerFlag: [],
      checkedFilterCondition: [],
      SellerRemarkTips: false,
      allRadio: false,
      goodsState: false,
      goodsState2: false,
      goodsOrderState:false,
      isOne: true,
      isTwo: false,
      isNoteReply: false,
      smsState2: false,
      //changeColor: "#2062E7",
      topPX: "146px",
      name: "",
      radioTime: "1",
      taskTime: [],
      sendTime: "",
      testOptions: [
        {
          value: "0",
          label: "手动输入",
        },
        {
          value: "1",
          label: "13143364647",
        },
        {
          value: "2",
          label: "13143364648,15578842725,15578842424",
        },
      ],
      sendOptions: [
        {
          value: "1",
          label: "发送",
        },
        {
          value: "0",
          label: "不发送",
        },
      ],
      options: [
        {
          value: "0",
          label: "分钟",
        },
        {
          value: "1",
          label: "小时",
        },
        {
          value: "2",
          label: "天",
        },
      ],
      value: "",
      optionsTwo: [
        {
          value: "2",
          label: "顺延第二天发送",
        },
        {
          value: "1",
          label: "不发送",
        },
      ],
      valueTwo: "",
      optionsThree: [
        {
          value: "",
          label: "全部",
        },
        // {
        //   value: "0",
        //   label: "未付定金"
        // },
        {
          value: "1",
          label: "已付定金，未付尾款",
        },
        {
          value: "2",
          label: "已付定金，已付尾款",
        },
      ],
      levelOptions:[
        {
          value: 0,
          label: "不限",
        },
        {
          value: 1,
          label: "1级",
        },
        {
          value: 2,
          label: "2级",
        },
        {
          value: 3,
          label: "3级",
        },
        {
          value: 4,
          label: "4级",
        },
        {
          value: 5,
          label: "5级",
        },
      ],
      valueThree: "",
      sendTimeStart: "",
      sendTimeEnd: "",
      sendTimeTwo: "",
      sendTimeStartTwo: "",
      sendTimeEndTwo: "",
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      cheakenInputOne: "",
      cheakenInputTwo: "",
      cheakenInputThree: "",
      cheakenInputFour: "",
      sendRadio: "1",
      sendRadioTwo: "1",

      isIndeterminate: true,
      radioTypeOne: "1",
      flagOne: [1],
      isIndeterminateTwo: true,
      filterOne: [1],
      filterData: [
        {
          value: 1,
          name: "首次到店会员",
          input: true,
        },
        {
          value: 2,
          name: "首次到店会员",
          input: true,
        },
        {
          value: 3,
          name: "店铺会员",
          input: false,
        },
        {
          value: 4,
          name: "高级会员",
          input: false,
        },
        {
          value: 5,
          name: "VIP会员",
          input: false,
        },
        {
          value: 6,
          name: "至尊VIP会员",
          input: false,
        },
      ],
      filter1: false,
      filter2: false,
      filter3: false,
      filter4: false,
      filter5: false,
      filterInput: "",
      filterInput2: "",
      areaOne: 1,
      areaData: [
        {
          value: "0",
          name: "全部",
        },
        {
          value: "1",
          name: "江浙沪",
        },
        {
          value: "2",
          name: "偏远地区（疆藏云海蒙）",
        },
        {
          value: "3",
          name: "自定义",
        },
      ],
      shoppingOne: 1,
      shoppingData: [
        {
          value: "0",
          name: "全部商品",
        },
        {
          value: "1",
          name: "指定商品",
        },
        {
          value: "2",
          name: "排除商品",
        },
      ],
      allArea: false,
      smallArea: false,
      farArea: false,
      isEast: true,
      eastAll: false,
      checkedElse: false,
      areaState: false,
      areaStateLength: 0,

      // 选中商品的数量
      goodsStateLength: 0,
      goodsStateLength1: 0,
      goodsStateLength2: 0,

      radio: "1",
      textarea: "",
      shortState: false,
      smsState: false,
      sendState: false,
      couponState: false,

      sendInfoList: [
        {
          id: "1",
          label: "#买家姓名#",
        },
        {
          id: "2",
          label: "#买家昵称#",
        },
        {
          id: "3",
          label: "#订单号#",
        },
        {
          id: "4",
          label: "#下单时间#",
        },
        {
          id: "5",
          label: "#商品名称#",
        },
      ],
      pickerOptions0: {
        disabledDate: (time) => {
          if (!this.postForm.moneyPayEndTime) {
            return time.getTime() > Date.now();
          } else {
            let endTime = new Date(this.postForm.moneyPayEndTime).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime;

            return;
            //  time.getTime() > Date.now() - 8.64e7
            // );
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (!this.postForm.moneyPayStartTime) {
            return time.getTime() > Date.now();
          } else {
            let startTime = new Date(this.postForm.moneyPayStartTime).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return (
              time.getTime() < startTime - 24 * 3600 * 1000 + 1
              // ||
              // time.getTime() > Date.now() ||
              // time.getTime() > maxTime
            );
          }
        },
      },
      // 禁止选择今天之前的
      pickerOptions2: {
        disabledDate: (time) => {
          //此条为设置禁止用户选择今天之前的日期，包含今天。
          // return time.getTime() <= (Date.now());
          //此条为设置禁止用户选择今天之前的日期，不包含今天。
          if (this.postForm.moneyPayEndTime) {
            let startTime = new Date(this.postForm.moneyPayEndTime).getTime();
            return time.getTime() < startTime - 24 * 3600 * 1000 + 1;
          } else {
            return time.getTime() < Date.now();
          }
        },
      },
      pickerOptions3: {
        disabledDate: (time) => {
          if (!this.postForm.balanceTimeStart) {
            if (this.postForm.moneyPayEndTime) {
              let startTime = new Date(this.postForm.moneyPayEndTime).getTime();
              return time.getTime() < startTime;
            } else {
              return time.getTime() < Date.now();
            }
          } else {
            // 最大选择时间  （时间跨度不能大于一年）
            let startTime = new Date(this.postForm.balanceTimeStart).getTime();
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return time.getTime() < startTime - 24 * 3600 * 1000 + 1;
          }
        },
      },
      /***
       * sms测试发送
       * */
      smsTestSendParams: {
        mobiles: "",
      },
      smsTestSendParams2: {
        mobiles: "",
      },
      phoneLenght: 0, //测试号码数量
      showSendConfirm: false, //是否显示发送确认弹框
      showSendConfirm2: false, //是否显示发送确认弹框 - 二次催付
      selectLoading: false, //点选择商品弹窗时，弹窗还没显示的loading
      pickerDisabled: this.beginDate(), // 限制结束时间要大于开始时间
      routerPath: false, // 自营路由
      venderQuanxian: this.$store.state.loginUserInfo.venderType,
      balancePath: false, // 预售时间

      // 首次催付后xx
      secondTime: "30",

      formData:{
        isSendSms: true,
        isSendDongDong: true,
        waiter: "",
        dongDongContent: "",
        levelChange: 0,
        pointChange: 0,
        intelligentSkuId: "",
      },
      formSecond:{
        isSendSms: true,
        isSendDongDong: true,
        waiter: "",
        dongDongContent: "",
      },
      memberLevelOptions: [
        {
          value: "-1",
          name: "全部",
        },
        {
          value: "1",
          name: "一星会员",
        },
        {
          value: "2",
          name: "二星会员",
        },
        {
          value: "3",
          name: "三星会员",
        },
        {
          value: "4",
          name: "四星会员",
        },
        {
          value: "5",
          name: "五星会员",
        },
      ],
    };
  },
  created: function() {
    this.permissionsList = this.$store.getters.loginUserInfo.permissions;
    const path = this.$route.path;
    if (
      path == "/orderCare/payReminder/payReminder" ||
      path == "/orderCare/transreMind/cancelMind" ||
      path == "/orderCare/transreMind/sendreMind" ||
      path == "/orderCare/moneyBack/moneyBack" ||
      path == "/orderCare/comtCare/autoEvaluation"
    ) {
      this.routerPath = this.$store.state.loginUserInfo.venderType;
    }
    if (path == "/orderCare/orderCare/presaleExpediting") {
      this.balancePath = this.$store.state.loginUserInfo.venderType;
    }
    document.body.style.overflow = "hidden";
    console.log("menuType===", this.menuType);
    this.getOfficialSuffix();
    // console.log(this.scorllY);
    // this.selSuffixName = this.suffix
    if (!this.isAdd) {
      //商品数量回显
      this.postForms.isProductNum = this.postForms.isProductNum ==1 ? true:false;
      // console.log("this.postForms=========>", this.postForms);
      this.postForm = this.postForms;
      // const lodingPage = this.postForms.content.indexOf("#LandingPage#") > -1;
      const lodingPage = this.postForms.transformUrl;
      this.longlinkFlay = lodingPage;
      this.longUrllink = lodingPage ? this.postForms.url : "";
      // this.postForm = this.postForms;
      this.postForm = Object.assign({}, this.postForms);
      console.log('this.postForm------>', this.postForm)
      this.postForm.content = lodingPage
        ? this.postForms.content.replace("#LandingPage#", ` ${this.postForms.transformUrl} `)
        : this.postForms.content;
      this.postForm.contnet2 = lodingPage
        ? this.postForms.contnet2.replace("#LandingPage#", ` ${this.postForms.transformUrl2} `)
        : this.postForms.contnet2;
      // 地区选择回显
      this.checkedList = this.postForm.zip;
      // 二次催付条件
      if(this.postForms.secondConfigObj && this.postForms.secondConfigObj.condit){
        this.postForm.sendCondCondit = this.postForms.secondConfigObj.condit;
        this.postForm.templateId2 = this.postForms.secondConfigObj.templateId;
        this.formSecond.isSendSms = this.postForms.secondConfigObj.isSendSms;
        this.formSecond.isSendDongDong = this.postForms.secondConfigObj.isSendDongDong;
        this.formSecond.waiter = this.postForms.secondConfigObj.waiter;
        this.formSecond.dongDongContent = this.postForms.secondConfigObj.dongDongContent;
      }
      this.formData.isSendSms = this.postForms.isSendSms ,
      this.formData.isSendDongDong = this.postForms.isSendDongDong ,
      this.formData.waiter = this.postForms.waiter ,
      this.formData.dongDongContent = this.postForms.dongDongContent ,
      this.formData.levelChange = this.postForms.levelChange ,
      this.formData.pointChange = this.postForms.pointChange ,
      this.formData.intelligentSkuId = this.postForms.intelligentSkuId ,
      
      // 二次催付时间回显
      
    console.log("this.postForms=========>", this.postForms);

      // 任务已选商品回显
      if (this.postForm.itemList && (this.postForm.itemList.wareList || this.postForm.itemList.skuList)) {
        if (this.venderQuanxian) {
          this.selectGoodsSkuList = this.postForm.itemList.skuList.map((i) => {
            return {
              ...i,
              wareTitle: i.itemTitle || i.title,
              logo: i.images || i.logo,
              isAdd: true,
              skuId: i.skuId,
            };
          });
          // this.returnSelectGoods = this.postForm.itemList.skuList.map((i) => {
          //   return {
          //     ...i,
          //     wareTitle: i.itemTitle || i.title,
          //     logo: i.images || i.logo,
          //     isAdd: true,
          //     // wareId: Number(i.wareId),
          //     skuId: i.skuId,
          //   };
          // });
          this.goodsStateLength = this.postForm.itemList.skuList ? this.postForm.itemList.skuList.length : 0;
        }
        if (!this.venderQuanxian) {
          this.returnSelectGoods = this.postForm.itemList.wareList.map((i) => {
            return {
              ...i,
              wareTitle: i.itemTitle || i.title,
              logo: i.images || i.logo,
              isAdd: true,
              wareId: Number(i.wareId),
              skuId: i.skuId || "",
              skuList: i.skuId
                ? i.skuId.split(",").map((ele) => {
                    return { skuId: ele };
                  })
                : [],
            };
          });
          this.selectGoodsSkuList = this.postForm.itemList.skuList.map((i) => {
            return {
              ...i,
              wareTitle: i.itemTitle || i.title,
              logo: i.images || i.logo,
              isAdd: true,
              // wareId: Number(i.wareId),
              skuId: i.skuId,
            };
          });
          // console.log(this.returnSelectGoods, this.selectGoodsSkuList, this.venderQuanxian, 666666);
          let skuArr = this.postForm.itemList.wareList
            .map((i) => i.skuId)
            .join(",")
            .split(",");
          let skuArr1 = this.postForm.itemList.skuList.map((i) => i.skuId);
          // this.goodsStateLength = this.unique(skuArr1, skuArr).length;
          this.goodsStateLength = this.postForm.itemList.wareList.length + this.postForm.itemList.skuList.length
        }
        if (this.postForms.isAllItem == 1) {
          this.returnSelectGoodsAppoint = this.returnSelectGoods;
          this.goodsStateLength1 = this.goodsStateLength;
        } else {
          this.returnSelectGoodsExclude = this.returnSelectGoods;
          this.goodsStateLength2 = this.goodsStateLength;
        }
        this.isShowSelectGoods = true;
      }

      // if (this.postForm.zip && this.postForm.zip.join(",") != "") {
      // this.postForm.areaType = "3";
      // }
      // if (this.postForm.zip && this.postForm.zip.join(",") == JZH_CODE) {
      // this.postForm.areaType = "1";
      // }
      // if (this.postForm.zip && this.postForm.zip.join(",") == PY_CODE) {
      // this.postForm.areaType = "2";
      // }
    }
    // console.log("this.postForm.areaType:", this.postForm.areaType);

    if (this.isAdd) {
      // console.log(this.$parent.asideName);
      this.longlinkFlay = false;
      this.longUrllink = "";
      this.postForm = {
        id: "", //任务ID
        taskName: this.$parent.asideName + " " + this.getNowDate(), //任务名称
        taskType: 0, //持续开启 (0:持续开启，1指定时间)
        sendType: 0, //发送时间类型
        taskStartTime: "", //指定任务时间开始
        taskEndTime: "", //指定任务时间结束
        moneyPayStartTime: "", //订金支付时间开始
        moneyPayEndTime: "", //订金支付时间结束
        payType: [], // 付款方式
        moneyType: "0", // 付款类型
        selectStart: [], // 针对评分
        sendCondition2: "30", //发送时间
        sendUnitTime2: DEFAULT_TIME[this.menuType].type, //发送时间单位(0 分， 1 时， 2 天)
        balancePaymentRemindEndMinutes: 0, // 尾款结束前
        sendCondition: DEFAULT_TIME[this.menuType].time, //发送时间
        sendUnitTime: DEFAULT_TIME[this.menuType].type, //发送时间单位(0 分， 1 时， 2 天)
        startRemindTime: this.menuType == 4 ? "9:00" : "07:00", //发送时段开始
        endRemindTime: "22:00", //发送时段结束
        remindSendType: "2", //发送时段，其他时间，发送类型1， 超出时间不发送， 2、 超出时间次日发送 默认2
        sendTime: "", //发送时段，其他时间设置多久发送
        isLunchBreak: false, // 发送时段 是否开启午休时间 1 开启(true)， 0 关闭(false)
        startLunchBreak: "12:00", //发送时段，午休开始时间
        endLunchBreak: "13:00", //发送时段，午休结束时间
        isOrderMoney: false, //发送条件 是否开启实付金额 1 开启(true) 0 关闭(false),
        startOrderMoney: "", //发送条件 实付金额开始,
        endOrderMoney: "", //发送条件 实付金额结束,
        isProductNum: false, //发送条件 是否开启商品数量 1 开启(true) 0 关闭(false),
        startProductNum: "", // 发送条件 商品数量开始,
        endProductNum: "", // 发送条件 商品数量结束,
        isBuyerMessage: false, // 发送条件 是否开启买家留言包含 1 开启(true) 0 关闭(false),
        buyerRemarkType: 1, // 买家备注类型-指定备注/任意备注
        buyerMessage: "", //发送条件 买家留言包含,
        isBuyerMessageSend: "1", //发送条件 买家留言是否发送 1 发送， 0 不发送,
        isDefaultGoodRate: false,
        isSellerRemark: false, // 发送条件 是否开启卖家备注包含 1 开启(true) 0 关闭(false),
        sellerRemarkType: 1, // 卖家备注类型-指定备注/任意备注
        sellerRemark: "", // 发送条件 卖家备注包含,
        isSellerRemarkSend: "1", //发送条件 卖家备注是否发送 1 发送， 0 不发送,
        logisticsNum: "", //物流编码
        tailNumber: "", //顺丰寄件人手机号
        ztExpressPhone: "", //中通寄件人手机号
        tradeFrom: [""], //订单来源 WAP(手机);TAOBAO(PC端);JHS(聚划算);HITAO(嗨淘);TOP(TOP平台) 一笔订单可能同时有以上多个标记， 则以逗号分隔,
        shipmentNum: "0", //运单号  0 全部发送   1 不发送有运单号订单  2 不发送无运单号订单
        memberSelect:'0', // 会员筛选  0全部  1只发送会员   2只发送非会员
        memberSelectLevel: ["-1"], // 会员等级列表
        orderType: "0", //订单类型 0 不限， 1 预售， 2 非预售 传入数值,
        presellType: "", //订单类型 预售类型 全部'' 0 未付定金， 1 已付定金未付尾款， 2 定金已付尾款已付 传入数值,
        sellerFlag: [""], //订单标旗 卖家备注旗帜 灰、 红、 黄、 绿、 蓝、 紫 分别对应 0、 1、 2、 3、 4、 5 传入数值,不限传'',
        precedenceMobileType: "1", //发送号码 1、 优先收货人手机号码， 2、 优先支付宝手机号码, 3、 收货人手机号码 4、 支付宝手机号码 默认1,
        memberLevel: [""], // 会员等级 0 店铺会员 1 普通会员， 2 高级会员， 3 VIP会员， 4 至尊VIP 多个逗号拼接,不限传''
        filterCondition: ["2"], //过滤设置  1: 同一个手机多少天只提醒一次， 2: 屏蔽黑名单， 3 屏蔽给过中差评客户， 4 屏蔽退过款的客户 5. 同一买家有付过款的不催前后 6. 评价内容含指定屏蔽词不发 7. 屏蔽无需物流的订单 8. 评价字数超过多少不发,
        filterWantTime: "0", //过滤设置 同一个旺旺设置天数,
        filterMobileTime: "0", //过滤设置 同一个手机设置天数,
        areaType: "0", //选择地区 选择地区 0 全部地区， 1 江浙沪， 2 偏远地区， 3 指定地区,
        zip: "", // 选择地区 地区编码
        isAllItem: "0", //选择商品 选择商品 0 全部商品， 1 指定商品， 2 排除商品 默认0,
        itemList: [], // 选择商品 商品集合,
        suffix: "【好听的面】", // 短信签名 带上[],
        content: "", // 短信内容,
        isOpen: 1, // 是否开启 1 开启， 0 关闭 默认1,
        type: this.menuType || 1, // 类型 类型 必传 1 下单关怀 2 下单关怀(货到) 3 处方药关怀 4 常规催付 5 二次催付 6 预售催付 7 聚划算催付 8 付款关怀 9 智能凑单 10 延时发货 11 发货提醒 12 疑难件提醒 13 同城提醒 14 派件提醒 15 签收提醒 16 物流广告 17 回款关怀 18 自动催评 19 好评感谢 20 中差评安抚 21 申请退款 22 同意退款 23 拒绝退款 24 退款成功
        //后续的条件
        addOnItems: "", //选择商品 3: 凑单商品,
        filterBeyondWords: "", //过滤设置 设置评价超过字数,
        filterBlockWord: "", //过滤设置 设置屏蔽过滤词,
        filterBuyerTime: "", //过滤设置 同一个卖家付过款设置天数,
        goodDays: "", //发送条件 好评天数,
        goodNumber: "", // 发送条件 好评字数超过多少字,
        isGoodDays: false, // 发送条件 是否开启确认收货后多少天内给好评 1 开启 0 关闭,
        evaluateWhetherToSend: false, // 已评价是否发送短信 0不发送 1发送 ,
        isGoodNumber: "", // 发送条件 是否开启好评字数 1 开启 0 关闭,
        isNoteReply: false, //是否短信回复备注到卖家备注 0 是 1 否,
        notUpdatedTime: "24", // 物流未更新疑难件规则 设置包裹未更新时间,
        notUpdatedUnit: "1", //物流未更新疑难件规则 设置包裹未更新时间单位,
        orderSplitCondition: false, // 拆分订单限制发送条件, 1、 同一订单拆单发货发1条短信， 2、 同一订单拆单发货发多条短信,
        orderSplitType: "1", //拆分订单类型, 1、 不限， 2、 仅限拆单， 3、 排除拆单,
        paymentType: "0", // 催付类型0催定金 订金未付开始发送 1 催尾款 定金已付尾款未付开始发送,
        orderStartTime: "",
        precedenceLevel: "", // 优先级别,
        reasonReturn: [], //退货原因 传入原因ID 多个以半角逗号分隔,
        reasonReturnType: "", //退货原因 是否排除退货原因 0: 全选 1: 排除,
        // refundApply: this.menuType == 21 ? "0" : "", //发送时间 退款申请 0: 退款 1: 退款退货 2: 退款不退货,
        remindConfigItem: [], // 选择商品 凑单商品,
        remindSellerConfigId: "", //id,
        // rxAuditStatus: this.menuType == 3 ? "1" : "", //发送时间 处方药（ 处方药审核状态， 1 审核通过 - 1 审核不通过 只有开启处方药提醒才有改字段）,
        sellerNick: "", // 买家昵称,
        unReceiptedZip: "", // 疑难件提醒 未签收地区编码,
        unUpdateZip: "", //疑难件提醒 未更新地区编码,
        unreceiptedTime: "3", // 未签收疑难件规则 设置包裹未签收时间,
        unreceiptedUnit: "2", // 未签收疑难件规则 设置包裹未签收时间单位,
        shipmentsRemindType: "0",

        // 二次催付
        isOpenSecond: false,
        secondConfigObj: {
          condit: "",
          contnet: "",
        },
        contnet2: "",
        //催付时间回显
        sendCondCondit: 30,
        secondUnitTimeType: "0",
      };
      this.formData.isSendSms = true;
      this.formData.isSendDongDong = true;
      this.formData.waiter = "";
      this.formData.dongDongContent = "";
      this.formData.levelChange = 0;
      this.formData.pointChange = 0;
      this.formData.intelligentSkuId = "";

      this.formSecond.isSendSms = true;
      this.formSecond.isSendDongDong = true;
      this.formSecond.waiter = "";
      this.formSecond.dongDongContent = "";

      // if (this.menuType == '4') {
      //   // 预售尾款催付
      //   this.postForm.remindSendType = '2'
      // }

      //新建任务 默认短信消息
      // this.inputContent = SEND_DEFAULT_INFO[this.menuType];

      // 双十一作战攻略跳转过来的
      if (localStorage.getItem("myMessageTheme") && localStorage.getItem("myMessageTheme").length > 0) {
        this.postForm.taskName = localStorage.getItem("myMessageTheme");
        // 任务时间（指定时间）
        if (localStorage.getItem("myStartTime") && localStorage.getItem("myStartTime").length > 0) {
          this.postForm.taskType = 1;
          this.taskTimeChange = [localStorage.getItem("myStartTime"), localStorage.getItem("myEndTime")];
        }
        // postForm.sendUnitTime
        if (localStorage.getItem("myStartRemindTime") && localStorage.getItem("myStartRemindTime").length > 0) {
          // this.postForm.startRemindTime = localStorage.getItem("myStartRemindTime"); // 发送时段，开始
          // this.postForm.endRemindTime = localStorage.getItem("myEndRemindTime"); // 发送时段，结束
          this.$set(this.postForm, "startRemindTime", new Date(2019, 7, 4, 0, 5));
          this.$set(this.postForm, "endRemindTime", new Date(2019, 7, 4, 23, 59));
          // console.log("startRemindTime,endRemindTime===",this.postForm.startRemindTime,this.postForm.endRemindTime);
        }
        // 发送时间
        if (localStorage.getItem("mySendTime") && localStorage.getItem("mySendTime").length > 0) {
          this.postForm.sendCondition = localStorage.getItem("mySendTime");
        }
        // 发送时间的类型（0分钟，1小时）
        if (localStorage.getItem("mySendTimeType") && localStorage.getItem("mySendTimeType").length > 0) {
          this.postForm.sendUnitTime = localStorage.getItem("mySendTimeType");
        }
        // 催付类型：
        if (localStorage.getItem("myPaymentType") && localStorage.getItem("myPaymentType").length > 0) {
          this.postForm.paymentType = localStorage.getItem("myPaymentType");
        }
        // 短信内容
        if (localStorage.getItem("myMessageContent") && localStorage.getItem("myMessageContent").length > 0) {
          this.inputContent = localStorage.getItem("myMessageContent");
          // console.log("111111111", this.inputContent, localStorage.getItem("myMessageContent"));
        }
        localStorage.setItem("myMessageTheme", "");
      }

      if (this.SellerSignData && this.SellerSignData[0].suffix) {
        this.selSuffixName = this.SellerSignData[0].suffix; //默认第一个签名
        this.postForm.suffix = this.SellerSignData[0].suffix;
      }

      //  this.postForm=addForm
      //新建任务默认勾选
    }

    this.isNoteReply = this.postForm.isNoteReply == "0" ? true : false;

    this.taskTile = "下单关怀" + moment().format("YYYYMMDD HH:mm");
    if (this.taskTimeChange[0] == "" || !this.taskTimeChange || this.taskTimeChange[0] == "0") {
      const date = [this.getCurrentMonthFirst() + " 00:00:00", this.msToDate(this.getCurrentMonthLast()).hasTime];
      // console.log(date[0], date[1]);
      this.postForm.taskStartTime = date[0];
      this.postForm.taskEndTime = date[1];
    }
    const date1 = [this.getDay(0, "-") + " 07:00:00", this.getDay(0, "-") + " 22:00:00"];
    this.startRemindTime = date1[0];
    this.endRemindTime = date1[1];
  },
  computed: {
    // 获取vuex中是state.SellerSignData和state.modelName的值
    ...mapState(["SellerSignData", "modelName"]),
    ...mapState({
      changeColor: "globalBG",
      globalLableList: "globalLableList",
      //   把city映射给currentCIty
    }),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    ...mapGetters(["suffix"]),
    isOfficial() {
      return this.$route.meta.isOfficial;
    },
    smsLabel() {
      return this.$route.meta.smsLabel;
    },
    taskTimeChange: {
      get: function() {
        let taskTime = [];
        taskTime.push(this.postForm.taskStartTime);
        taskTime.push(this.postForm.taskEndTime);
        return taskTime;
      },
      set: function(value) {
        if (value !== null) {
          this.taskTime = value;
          this.postForm.taskStartTime = value[0];
          this.postForm.taskEndTime = value[1];
        } else {
          const date = [this.getCurrentMonthFirst() + " 00:00:00", this.msToDate(this.getCurrentMonthLast()).hasTime];
          this.postForm.taskStartTime = date[0];
          this.postForm.taskEndTime = date[1];
          // this.postForm.taskStartTime = ''
          // this.postForm.taskEndTime = ''
        }
      },
    },
    tradeFromChange: {
      get: function() {
        if (this.isNullStr(this.postForm.tradeFrom)) {
          return this.checkedTradeFrom;
        }
        return this.postForm.tradeFrom.split(",");
      },
      set: function(value) {
        this.checkedTradeFrom = value;
        this.postForm.tradeFrom = value.join(",");
      },
    },
    memberLevelChange: {
      get: function() {
        if (this.isNullStr(this.postForm.memberLevel)) {
          return this.checkedMemberLevel;
        }
        return this.postForm.memberLevel.split(",");
      },
      set: function(value) {
        this.checkedMemberLevel = value;
        this.postForm.memberLevel = value.join(",");
      },
    },
    sellerFlagChange: {
      get: function() {
        if (this.isNullStr(this.postForm.sellerFlag)) {
          return this.checkedSellerFlag;
        }
        return this.postForm.sellerFlag.split(",");
      },
      set: function(value) {
        this.checkedSellerFlag = value;
        this.postForm.sellerFlag = value.join(",");
      },
    },
    inputContent: {
      get() {
        return this.postForm.content;
      },
      set(val) {
        this.postForm.content = val;
      },
    },
    inputContent2: {
      get() {
        return this.postForm.contnet2;
      },
      set(val) {
        this.postForms.contnet2 = val;
      },
    },
    contentLength() {
      return this.postForm.content.length;
    },
    sendInfoLength() {
      try {
        if (this.postForm.content) {
          return this.$linkConvertNum(this.$ChineseVToEn(this.postForm.content, true)) + this.selSuffixName.length + 2;
        } else {
          return this.selSuffixName.length + 2;
        }
      } catch (e) {
        return 0;
      }
    },
    sendInfoLength2() {
      try {
        if (this.postForm.contnet2) {
          return this.$linkConvertNum(this.$ChineseVToEn(this.postForm.contnet2, true)) + this.selSuffixName.length + 2;
        } else {
          return this.selSuffixName.length + 2;
        }
      } catch (e) {
        return 0;
      }
    },
   
    condit() {
      let result = this.postForm.sendCondition;
      if (this.postForm.sendUnitTime == 1) {
        result = result * 60;
      }
      if (this.postForm.sendUnitTime == 2) {
        result = result * 24 * 60;
      }
      return result;
    },
    
    condit2() {
      let result = this.postForm.sendCondCondit;
      if (this.postForm.secondUnitTimeType == 1) {
        result = result * 60;
      }
      if (this.postForm.secondUnitTimeType == 2) {
        result = result * 24 * 60;
      }
      return result;
    },
    
    conditEnd() {
      let result = this.postForm.balancePaymentRemindEndMinutes;
      if (this.postForm.sendUnitTime2 == 1) {
        result = result * 60;
      }
      if (this.postForm.sendUnitTime2 == 2) {
        result = result * 24 * 60;
      }
      return result;
    },
    taskTypeActive() {
      return this.$parent.taskTypeActive;
    },
    apiTypeActive() {
      return this.$parent.apiTypeActive;
    },
    // 针对评分
    handleStarList: {
      get() {
        if (this.menuType == 14 || this.menuType == 20) {
          this.postForm.selectStart = this.startList.slice(3).map((item) => item.value);
          return this.startList.slice(3);
        } else {
          this.postForm.selectStart = this.startList.slice(0, 3).map((item) => item.value);
          return this.startList.slice(0, 3);
        }
      },
    },

    // 会员关怀
    isMemCare(){
      if([26,27,28,29,30].includes(this.menuType)){
        return true;
      }else{
        return false;
      }
    },
    // 购物关怀
    isShopCare(){
      if([31,32,33,34].includes(this.menuType)){
        return true;
      }else{
        return false;
      }
    },
    apiWord(){
      if([2,5,12].includes(this.menuType)){
        return "order:remind"
      }else if([26,27,28,29,30].includes(this.menuType)){
        return "remind"
      }else if([31,32,33,34].includes(this.menuType)){
        return "shopping:remind"
      }else{
        return ""
      }
    },
    diffTask(){
      // 临时新加三个需要咚咚消息
      if([2,5,12].includes(this.menuType)){
        return true;
      }else if(this.menuType >= 26){
        return true;
      }else{
        return false;
      }
    },
    showSwitch(){
      if(!this.diffTask){
        return false;
      }
      // 包含两种权限
      if(this.permissionsList.indexOf(`hide:${this.apiWord}:send`) != "-1" && this.permissionsList.indexOf(`hide:${this.apiWord}:dongdong:send`) != "-1"){
        return true;
      }else{
        return false;
      }
        
    },
    hasSms(){
      if(!this.diffTask){
        return true;
      }
      if(this.permissionsList.indexOf(`hide:${this.apiWord}:send`) != "-1"){
        return true;
      }else{
        return false;
      }

    },
    hasDongDong(){
      if(!this.diffTask){
        return false;
      }
      if(this.permissionsList.indexOf(`hide:${this.apiWord}:dongdong:send`) != "-1"){
        return true;
      }else{
        return false;
      }
    },
    openSms(){
      if(!this.hasSms){
        return false;
      }
      if(this.showSwitch && !this.formData.isSendSms){
        return false;
      }else{
        return true;
      }
    },
    openDongDong(){
      if(!this.hasDongDong){
        return false;
      }
      if(this.showSwitch && !this.formData.isSendDongDong){
        return false;
      }else{
        return true;
      }
    },
    openSmsSecond(){
      if(!this.hasSms){
        return false;
      }
      if(this.showSwitch && !this.formSecond.isSendSms){
        return false;
      }else{
        return true;
      }
    },
    openDongDongSecond(){
      if(!this.hasDongDong){
        return false;
      }
      if(this.showSwitch && !this.formSecond.isSendDongDong){
        return false;
      }else{
        return true;
      }
    }
    
  },
  filters: {
    getCityLength(list) {
      var length = 0;
      if (list && list.length > 0) {
        list.forEach((item) => {
          if (item.city) {
            length += item.city.split(",").length;
          }
        });
      }
      return length;
    },
  },
  mounted() {
    this.getValidSmsTestMobiles()
    console.log("menuType", this.menuType);

    //  console.log(this.menuType,'66666666666666');


    if (this.postForms == undefined) {
      this.$set(this.postForm, "filterCreatedStart", this.getDateStr(-30) + " 00:00:00");
      this.$set(this.postForm, "filterCreatedEnd", this.getDateStr(-1) + " 23:59:59");
    }

    // 抽屉从右出现
    this.drawers = this.drawer;

    // 订金支付时间
    // this.postForm.moneyPayStartTime = this.getCurrentMonthFirst() + " 00:00:00";
    // this.postForm.moneyPayEndTime = this.msToDate(this.getCurrentMonthLast()).hasTime;
  },
  watch: {
    goodsState(val) {
      if (val === true) {
        this.selectLoading = false;
      }
    },
  },
  methods: {
    mobilPhoneSubmit(val){
      this.getValidSmsTestMobiles()
      this.showchangetestphone = false
    },
    getValidSmsTestMobiles() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
          this.Selectmobiles = [];
          this.testOptions = res.data.smsTestMobiles
          this.nowtestMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    // 短信测试手机号 
    selectTestMobiles(val) {
      this.smsTestSendParams.mobiles = this.Selectmobiles.join(',')
      this.smsTestSendParams2.mobiles = this.Selectmobiles.join(',')
    },
    // 关闭短链接
    handleCloseShort(val, obj) {
      
      this.insertShortUrlShow = false;
      if(this.isDDUrl){
        this.isDDUrl = false;
        if (val) {
          this.formData.dongDongContent = this.formData.dongDongContent + " " + obj.shortLink + " ";
        }
        return
      }
      if(this.isSecondDDUrl){
        this.isSecondDDUrl = false;
        if (val) {
          this.formSecond.dongDongContent = this.formSecond.dongDongContent + " " + obj.shortLink + " ";
        }
        return
      }
      if (val) {
        this.longUrllink = obj.originUrl2;
        this.insertContent(" " + obj.shortLink + " ", obj);
        // this.moduleOForm.content =
        //   this.moduleOForm.content + " " + obj.shortLink + " ";
      }
    },
    insertContent(myValue, obj) {
      myValue = this.$ChineseVToEn(myValue, true);
      // const smsContent = document.querySelector(".sms-content-x").children[0];
      if (this.postForm.transformUrl) {
        this.postForm.content = this.postForm.content.replace(this.postForm.transformUrl, myValue);
      } else {
        this.postForm.content = this.postForm.content.replace(/#LandingPage#/g, myValue);
      }
      this.postForm.transformUrl = " " + obj.shortLink + " ";

      // if (startPos || startPos.selectionStart == "0" || startPos === 0) {
      //   smsContent.value = smsContent.value.substring(0, startPos) + myValue + smsContent.value.substring(endPos, smsContent.value.length);
      //   smsContent.selectionStart = startPos + myValue.length;
      //   smsContent.selectionEnd = startPos + myValue.length;
      //   smsContent.focus();
      // } else {
      //   smsContent.value += myValue;
      //   smsContent.focus();
      // }
      // this.inputContent = smsContent.value;
    },
    limitInput(event) {
      event.target.value = event.target.value.replace(/[^\d]/g, "");
    },
    limitInput1(event){
     var reg = /^([1-9][0-9]*)$/;
     if (reg.test(event.target.value)) { //只能输入大于0的正整数
      this.postForm.dayLimit= event.target.value
     } else {
      this.postForm.dayLimit= ''
      this.$message.error('只能输入大于0的正整数')
     }
    },
    smsContent2html(val) {
      var list = this.globalLableList;
      list.forEach((item, index) => {
        var label = item.key;
        var index = val.indexOf(label);

        if (index != "-1") {
          var html = [
            '<div class="ask-content-x">',
            `<span style="color: rgb(96, 105, 255)">#${item.value}#</span>`,
            // `<span style="color: rgb(96, 105, 255)">${item.key}</span>`,
            '<div class="ask-icon-select">',
            item.value,
            "</div>",
            "</div>",
          ].join("");
          val = val.replace(label, html);
        }
      });
      // 自定义链接变蓝
      if (this.postForm.transformUrl) {
        if (val.indexOf(this.postForm.transformUrl) != -1) {
          var html = [`<span style="color: rgb(96, 105, 255);">${this.postForm.transformUrl}</span>`].join("");
          val = val.replace(this.postForm.transformUrl, html);
        }
      }
      return val;
    },
    smsContent2html2(val) {
      var list = this.globalLableList;
      list.forEach((item, index) => {
        var label = item.key;
        var index = val.indexOf(label);

        if (index != "-1") {
          var html = [
            '<div class="ask-content-x">',
            `<span style="color: rgb(96, 105, 255)">#${item.value}#</span>`,
            // `<span style="color: rgb(96, 105, 255)">${item.key}</span>`,
            '<div class="ask-icon-select">',
            item.value,
            "</div>",
            "</div>",
          ].join("");
          val = val.replace(label, html);
        }
      });
      // 自定义链接变蓝
      if (this.postForm.transformUrl2) {
        if (val.indexOf(this.postForm.transformUrl2) != -1) {
          var html = [`<span style="color: rgb(96, 105, 255);">${this.postForm.transformUrl2}</span>`].join("");
          val = val.replace(this.postForm.transformUrl2, html);
        }
      }
      return val;
    },
    changeTaskType(val) {
      if (val == 1) {
        const date = [this.getCurrentMonthFirst() + " 00:00:00", this.msToDate(this.getCurrentMonthLast()).hasTime];
        console.log(date[0], date[1]);
        this.postForm.taskStartTime = date[0];
        this.postForm.taskEndTime = date[1];
      }
    },
    // 保存模板 显示
    handleShowModule() {
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.dirList = res.data;
          this.keepTmpShow = true;
        }
      });
      // console.log(this.dirList);
    },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.postForm.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("保存模板成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 获取官方和系统的的短信签名
    getOfficialSuffix() {
      let type = 1;
      if (this.$route.meta.isOfficial) {
        type = 2;
      }
      getPrecisionJdSuffixList(type).then((res) => {
        if (res.code == "1") {
          var suffixList = res.data;
          this.suffixList = suffixList;
          this.selSuffixName = suffixList[0];
        }
      });
    },
    changeSufix(item) {
      this.selSuffixName = item;
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      done();
      // })
      // .catch(_ => {});
      // this.drawers = false;
      this.$emit("transferName", true);
    },
    handleClose2(done) {
      // this.$confirm('还有未保存的工作哦确定关闭吗？')
      //     .then(_ => {
      done();
      // })
      // .catch(_ => {});
      // this.drawerWidth = '780px';
    },
    oninput(num) {
      var str = num;
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
      str = str.replace(/\.\d\d\d$/, ""); // 小数点后只能输两位
      return str;
    },

    moneyChange() {
      let start = +this.postForm.startOrderMoney;
      let end = +this.postForm.endOrderMoney;
      if (start > end) {
        this.$message.warning("实付金额初始数值不能大于结束数值");
        this.postForm.startOrderMoney = "";
      }

      let start2 = +this.postForm.startProductNum;
      let end2 = +this.postForm.endProductNum;
      if (start2 > end2) {
        this.$message.warning("商品数量初始数值不能大于结束数值");
        this.postForm.startProductNum = "";
      }
    },
    // 指定商品
    selectGoodsChange(val, item) {
      this.goodsState = false;
      if (val || item) {
        // 数据缓存到指定商品数组
        if (this.postForm.isAllItem == 1) {
          this.goodsStateLength1 = val.length;
          this.goodsStateLength = this.goodsStateLength1;
          this.returnSelectGoodsAppoint = val;
        } else {
          // 数据缓存到排除商品数组
          this.goodsStateLength2 = val.length;
          this.goodsStateLength = this.goodsStateLength2;
          this.returnSelectGoodsExclude = val;
        }
        if (!this.venderQuanxian) {
          let skuArr = [];
          val.forEach((i) => {
            if (i.skuList != 0) {
              i.skuList.forEach((ele) => {
                if (ele.skuId) {
                  skuArr.push(ele.skuId);
                } else {
                  skuArr.push(ele);
                }
              });
            }
          });
          let skuArr1 = item.map((i) => i.skuId);
          this.selectGoodsSkuList = item;
          this.postForm.itemList = [];
          this.postForm.itemList = [...val, ...item];
          this.returnSelectGoods = val;
          this.goodsStateLength = this.postForm.itemList.length 
        }else{
          this.returnSelectGoods = [];
          this.selectGoodsSkuList = val;
          this.postForm.itemList = [];
          this.postForm.itemList = [...val];
        }
      }
    },
    // 凑单商品
    selectOrderGoodsChange(val, item){
      this.goodsOrderState = false;
      if (val || item) {
        let goodslist =  [...val];
        if(goodslist.length!=0){
          this.formData.intelligentSkuId = goodslist[0].skuId;
        }else{
          this.formData.intelligentSkuId = '';
        }
        this.selectOrderGoodsSkuList = [];
        this.selectOrderGoodsSkuList.push( goodslist[0] )
        this.postForm.itemList = this.selectOrderGoodsSkuList;
        if(goodslist.length==0){
          this.returnSelectOrderGoods = []
          this.selectOrderGoodsSkuList = [];
        }
      }
      
    },
    // 排除商品
    // selectGoodsChange2(val) {
    //   console.log("商品选择返回==", val);
    //   this.goodsState2 = false;
    //   if (val !== false) {
    //     console.log("商品选择返回==222");
    //     this.postForm.itemList = val;
    //     this.goodsStateLength2 = val.length;
    //     this.goodsStateLength = this.goodsStateLength2;
    //     this.returnSelectGoodsExclude = val;
    //   }
    // },
    moneyPayTimeChange() {
      let start = new Date(this.postForm.moneyPayStartTime).valueOf();
      let end = new Date(this.postForm.moneyPayEndTime).valueOf();
      if (end < start) {
        this.$message.warning("开始时间不得大于结束时间");
        this.postForm.moneyPayStartTime = "";
      }

      let start2 = new Date(this.postForm.taskStartTime).valueOf();
      let end2 = new Date(this.postForm.taskEndTime).valueOf();
      if (end2 < start2) {
        this.$message.warning("开始时间不得大于结束时间");
        this.postForm.taskStartTime = "";
      }

      let start3 = new Date(this.postForm.balanceTimeStart).valueOf();
      let end3 = new Date(this.postForm.balanceTimeEnd).valueOf();
      if (end3 < start3) {
        this.$message.warning("开始时间不得大于结束时间");
        this.postForm.balanceTimeStart = "";
      }

      if(this.postForm.balanceTimeStart && this.postForm.moneyPayEndTime){
        if(end >= start3){
          this.$message.warning("尾款支付开始时间不得小于定金支付结束时间");
          this.postForm.balanceTimeStart = "";
        }
      }
    },
    // 保存模板隐藏
    templateChange(val, item) {
      console.log("选择模板的返回==", val, item);
      // this.inputContent = item.content;
      if (val == true) {
        this.longlinkFlay = item.content.indexOf("#LandingPage#") > -1 ? true : false;
        this.longUrllink = "";
        this.postForm.transformUrl = "";
        this.selectTemplate = item;
        this.postForm.content = item.content;
        this.postForm.templateId = item.officialTemplateId;
      }
      // 京东模板id
      this.templateShow = false;
    },
    // 保存模板隐藏 二次催付
    templateChange2(val, item) {
      console.log("二次催付选择模板的返回==", val, item);
      // this.inputContent = item.content;
      if (val == true) {
        this.longlinkFlay2 = item.content.indexOf("#LandingPage#") > -1 ? true : false;
        this.longUrllink = "";
        this.postForm.transformUrl2 = "";
        this.$set(this.postForm, 'contnet2' , item.content);
        this.postForm.contnet2 = item.content;
        this.postForm.templateId2 = item.officialTemplateId;
      }
      // 京东模板id
      this.templateShow2 = false;
    },
    clearTime() {
      // this.smsSearchParams.sendStartTime = "";
      // this.smsSearchParams.sendEndTime = "";
      // this.taskTimeChange = ["",""],
      // this.taskTimeChange[1] = "";
      this.postForm.taskStartTime = "";
      this.postForm.taskEndTime = "";
    },
    // 订金支付时间的清空
    clearTime2() {
      this.postForm.moneyPayStartTime = "";
      this.postForm.moneyPayEndTime = "";
    },
    // 尾款支付时间的清空
    clearTime3() {
      this.postForm.balanceTimeStart = "";
      this.postForm.balanceTimeEnd = "";
    },

    // 限制结束时间要大于开始时间
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.postForm.filterCreatedStart) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.postForm.filterCreatedStart).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    showSelectOrderGoods(){
      this.goodsOrderState = true;
    },
    showSelectGoods() {
      // if(this.postForm.isAllItem == "0"){
      //   this.postForm.isAllItem = "1";
      //   this.goodsState = true;
      // }
      console.log(this.returnSelectGoods);
      this.goodsState = true;

      // this.selectLoading = true;
    },
    difNumberBluer(item) {
      // console.log(this.postForm[item]);
      if (!this.postForm[item] || this.postForm[item] == "") {
        this.postForm[item] = 0;
      }
      this.postForm[item] = Number(this.postForm[item]) > 10000000 ? 10000000 : Number(this.postForm[item]);

      this.postForm[item] = Number(this.postForm[item]) > 10000000 ? 10000000 : Number(this.postForm[item]);
    },
    //疑难杂件
    difficultCity(v) {
      if (this.difficultType == 1) {
        this.postForm.unReceiptedZip = v;
        // console.log(this.postForm.unReceiptedZip);
      } else if (this.difficultType == 2) {
        this.postForm.unUpdateZip = v;
        // console.log(this.postForm.unUpdateZip);
      } else {
      }
    },
    //疑难件地区选择 1//2
    difficult(type) {
      let t = Number(type);
      this.difficultType = t;
      //未签收
      //this.checkedList = [];
      //       unReceiptedZip (string, optional): 疑难件提醒 未签收地区编码 ,
      // unUpdateZip (string, optional): 疑难件提醒 未更新地区编码 ,
      //this.postForms.unReceiptedZip

      // this.areaState = true;

      this.areaState = false;
      this.$nextTick(() => {
        this.areaState = true;
      });

      this.difficultType = t;
      if (type == 1) {
        // console.log(this.checkedList, "-----------");
        this.checkedList = this.postForm.unReceiptedZip || [];
        //未更新
      } else if (type == 2) {
        this.checkedList = this.postForm.unUpdateZip || [];
      }
    },

    getNowDate() {
      var date = new Date();
      var seperator1 = "";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + Hours + seperator2 + Minutes + seperator2 + Seconds;
      return currentdate;
    },
    msToDate(msec) {
      let datetime = new Date(msec);
      let year = datetime.getFullYear();
      let month = datetime.getMonth();
      let date = datetime.getDate();
      let hour = datetime.getHours();
      let minute = datetime.getMinutes();
      let second = datetime.getSeconds();

      let result1 =
        year +
        "-" +
        (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) +
        "-" +
        (date + 1 < 10 ? "0" + date : date) +
        " " +
        (hour + 1 < 10 ? "0" + hour : hour) +
        ":" +
        (minute + 1 < 10 ? "0" + minute : minute) +
        ":" +
        (second + 1 < 10 ? "0" + second : second);

      let result2 = year + "-" + (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) + "-" + (date + 1 < 10 ? "0" + date : date);

      let result = {
        hasTime: result1,
        withoutTime: result2,
      };

      return result;
    },
    //最后一天
    getCurrentMonthLast() {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      return new Date(nextMonthFirstDay - oneDay);
    },
    getCurrentMonthFirst() {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return date.getFullYear() + "-" + month + "-" + day;
    },

    checkReturnShow(arr) {
      if (this.postForm[arr].length == 0) {
        this.postForm[arr] = [""];
      }
    },

    changeCheckBox(v, arr) {
      //arr VM 传入数组
      // console.log(v, arr);
      if (v[v.length - 1] === "" || v.length === 0) {
        this.postForm[arr] = [""];
        return;
      }
      for (let i = 0; i < v.length; i++) {
        if (v.length >= 2 && v[i] == "") {
          this.postForm[arr].splice(i, 1);
        }
      }
    },

    //编辑短信输入
    sendInfoText(v) {
      console.log(this.inputContent);
      if (this.inputContent.indexOf("【") != -1 || this.inputContent.indexOf("】") != -1) {
        this.$message.info("通道规则：短信内容请勿包含【】符号！"); //不能输入【】符号,自动去除
        this.inputContent = this.inputContent.replace(/[【】]/g, "");
      }
      if (v.length + this.selSuffixName.length > 70) {
        document.getElementById("copyIndexInfo").style.color = "red";
      } else {
        document.getElementById("copyIndexInfo").style.color = "#606266";
      }
      //       var str = "123";
      // console.log(str.search("3") != -1 );
      let text = v;
      this.getInputFilterList = [];
      for (let i = 0; i < this.filterWordsList.length; i++) {
        if (text.search(this.filterWordsList[i].word) != -1) {
          this.getInputFilterList.push(this.filterWordsList[i]);
        } else {
          this.getInputFilterList.splice(i, 1);
        }
      }
    },

    //获取编写
    getFourIndex() {
      var oTxt1 = document.getElementById("copyIndexInfo");
      this.cursurPosition = -1;
      if (oTxt1.selectionStart) {
        //非IE浏览器
        this.cursurPosition = oTxt1.selectionStart;
      } else {
        //IE
        try {
          var range = document.selection.createRange();
          range.moveStart("character", -$input.value.length);
          this.cursurPosition = range.text.length;
        } catch (e) {
          this.cursurPosition = 0;
        }
      }
    },
    /***
     * 标签点击事件
     * */
    selectTagTap(tagName) {
      //insert short

      //指定插入位置
      let insertStr = (soure, start, newStr) => {
        return soure.slice(0, start) + newStr + soure.slice(start);
      };
      this.postForm.content = insertStr(this.postForm.content, this.getFocusIndex(), tagName);

      this.postForm.content = this.postForm.content.substr(0, 500);
      (this.cursurPosition = this.getFocusIndex() + tagName.length),
        this.$nextTick(() => {
          this.set_text_value_position("copyIndexInfo", this.cursurPosition);
        });
    },
    //正整数0-30
    filterBuyerDay(item) {
      let num = Number(this.postForm[item]);
      if (num <= 30 && num >= 0) {
        this.postForm[item] = num;
      } else {
        this.postForm[item] = 0;
      }
    },
    //正整数0-720
    filterBuyerTime(v) {
      let num = Number(this.postForm.filterBuyerTime);
      if (num <= 720 && num >= 0) {
        this.postForm.filterBuyerTime = num;
      } else {
        this.postForm.filterBuyerTime = 0;
      }
    },
    //过滤二选一
    filterCondiions(v) {
      // console.log(v[v.length - 1]);
      for (let i = 0; i < v.length; i++) {
        if (v[v.length - 1] == "0") {
          if (v[i] == "1") {
            this.postForm.filterCondition.splice(i, 1);
          }
        }
        if (v[v.length - 1] == "1") {
          if (v[i] == "0") {
            this.postForm.filterCondition.splice(i, 1);
          }
        }
      }
    },
    //自定义地区
    customArea(v) {
      if (v == 3) {
        this.popupShowBtn();
        return;
      }
    },
    /*** *
     * 获取店铺信息
     */
    getSoftwareInfo() {
      // getSoftwareInfo({}).then(res => {
      //   if (res.code == 200) {
      //     if (this.isAdd) {
      //       this.postForm.suffix = this.SellerSignData[0].suffix;
      //       // console.log(this.SellerSignData,'------------------')
      //       this.selSuffixName = this.SellerSignData[0].suffix;
      //       //this.sendInfoLength = this.selSuffixName.length;
      //     }
      //   }
      // });
    },
    selGoods(value) {
      if (value == 0) {
        this.isShowSelectGoods = false;
        this.returnSelectGoods = [];
      }
      // 指定商品选项，指定商品加入到组件中回显
      if (value == 1 && !this.goodsState) {
        this.goodsStateLength = this.goodsStateLength1;
        this.returnSelectGoods = this.returnSelectGoodsAppoint;
        this.isShowSelectGoods = true;
      }
      // 排除商品选项，排除商品加入到组件中回显
      if (value == 2 && !this.goodsState) {
        this.goodsStateLength = this.goodsStateLength2;
        this.returnSelectGoods = this.returnSelectGoodsExclude;
        this.isShowSelectGoods = true;
      }
      if (!this.venderQuanxian) {
        let skuArr = [];
        this.returnSelectGoods.forEach((i) => {
          if (i.skuList != 0) {
            i.skuList.forEach((ele) => {
              skuArr.push(ele.skuId);
            });
          }
        });
        let skuArr1 = this.selectGoodsSkuList.map((i) => i.skuId);
        this.goodsStateLength = this.unique(skuArr1, skuArr).length;
      }
      // 表单的商品数组切换到指定选项的商品数组
      this.postForm.itemList = [...this.returnSelectGoods, ...this.selectGoodsSkuList];
      console.log(this.postForm.itemList);
    },
    //标准时间转时间
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      // return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
      return this.formatTen(hour) + ":" + this.formatTen(minute) + ":" + this.formatTen(second);
    },
    remindTimeTips(v) {
      console.log("v11111==", v);
      console.log(this.formatDate(v));
      console.log(typeof v);
      console.log(this.postForm.startRemindTime);
      if (v) {
        this.maxStartRemindTime = this.formatDate(v);
        this.postForm.endRemindTime = "";
      }
      // if (

      //   this.postForm.startRemindTime === null ||
      //   this.postForm.endRemindTime === null
      // ) {
      //   this.$message.error("发送时段不允许为空");
      // }
    },
    sendConditionTips() {
      if (this.postForm.sendCondition === "") {
        this.$message.error("发送时间不允许为空");
      }
    },
    sendConditionTips2() {
      if (this.postForm.sendCondition2 === "") {
        this.$message.error("发送时间不允许为空");
      }
    },
    sendConditionTips3() {
      if (this.postForm.balancePaymentRemindEndMinutes === "") {
        this.$message.error("发送时间不允许为空");
      }
    },
    blueNumbre(vm) {
      this.postForm[vm] = this.postForm[vm].replace(/[^\d]/g, "");
      this.postForm[vm] = this.postForm[vm] < 10000 ? this.postForm[vm] : 10000;
    },
    difNumber() {
      try {
        this.postForm.unreceiptedTime = this.postForm.unreceiptedTime.replace(/[^\.\d]/g, "");
        this.postForm.unreceiptedTime = this.postForm.unreceiptedTime.replace(".", "");
        this.postForm.notUpdatedTime = this.postForm.notUpdatedTime.replace(/[^\.\d]/g, "");
        this.postForm.notUpdatedTime = this.postForm.notUpdatedTime.replace(".", "");
      } catch (error) {}
    },
    filNumber() {
      console.log("input==");
      this.postForm.sendCondition = this.postForm.sendCondition.replace(/[^\.\d]/g, "");
      this.postForm.sendCondition = this.postForm.sendCondition.replace(".", "");

      this.postForm.balancePaymentRemindEndMinutes = this.postForm.balancePaymentRemindEndMinutes.replace(/[^\.\d]/g, "");
      this.postForm.balancePaymentRemindEndMinutes = this.postForm.balancePaymentRemindEndMinutes.replace(".", "");

      // this.postForm.sendCondition2 = this.postForm.sendCondition2.replace(
      //   /[^\.\d]/g,
      //   ""
      // );
      // this.postForm.sendCondition2 = this.postForm.sendCondition2.replace(
      //   ".",
      //   ""
      // );

      // //商品数量只能输入正整数
      if (this.postForm.startProductNum) {
        this.postForm.startProductNum = this.postForm.startProductNum.replace(/[^\d]/g, "");
        this.postForm.endProductNum = this.postForm.endProductNum.replace(/[^\d]/g, "");
      }
    },
    changeIsTwo() {
      let _that = this;
      let sendTime = 1;
      let sendBtnTimer = setInterval(changeSendBtn, 200);
      function changeSendBtn() {
        if (sendTime <= 0) {
          _that.isTwo = false;
          // console.log('清除定时器');
          clearInterval(sendBtnTimer);
          return false;
        }
        sendTime--;
        // console.log(sendTime)
      }
    },
    /**
     * 返回上一步
     */
    backOne() {
      // this.changeIsTwo();
      // $(".myOne").slideToggle(500);
      // this.handleClose2();
      this.innerDrawer = false;
    },
    /**
     * 自定义地区
     */
    getTransferName(event) {
      this.areaState = false;
      if (event.type !== 1) {
        if (event.data.length !== 0) {
          this.areaStateLength = event.data.length;
          this.areaList = event.data;
          let currentStr = event.data;
          this.postForm.zip = currentStr.join(",");
        }
        this.areaStateLength = event.data.length;
      }
    },
    changeStr(allstr, start, end, str, changeStr) {
      //allstr:原始字符串，start,开始位置,end：结束位  置,str：要改变的字，changeStr:改变后的字
      if (allstr.substring(start - 1, end - 1) == str) {
        return allstr.substring(0, start - 1) + changeStr + allstr.substring(end, allstr.length);
      } else {
        allstr;
      }
    },
    //设置光标位置
    set_text_value_position(obj, spos) {
      var tobj = document.getElementById(obj);
      if (spos < 0) spos = tobj.value.length;
      if (tobj.setSelectionRange) {
        //兼容火狐,谷歌
        setTimeout(function() {
          tobj.setSelectionRange(spos, spos);
          tobj.focus();
        }, 0);
      } else if (tobj.createTextRange) {
        //兼容IE
        var rng = tobj.createTextRange();
        rng.move("character", spos);
        rng.select();
      }
      //copyIndexInfo
    },

    //获取编写
    getFocusIndex() {
      var oTxt1 = document.getElementById("copyIndexInfo");
      let cursurPosition = -1;
      if (oTxt1.selectionStart) {
        //非IE浏览器
        return (cursurPosition = oTxt1.selectionStart);
      } else {
        //IE
        try {
          var range = document.selection.createRange();
          range.moveStart("character", -$input.value.length);
          return (cursurPosition = range.text.length);
        } catch (e) {
          return (cursurPosition = 0);
        }
      }
    },
    logiLinkFn(v) {
      this.logiState = v;
      this.$children.linkDialog = v;
    },
    logiLinkFn(v) {
      //指定插入位置
      let insertStr = (soure, start, newStr) => {
        return soure.slice(0, start) + newStr + soure.slice(start);
      };

      this.postForm.content = insertStr(this.postForm.content, this.getFocusIndex(), v);
      this.postForm.content = this.postForm.content.substr(0, 500);
      // (this.cursurPosition = this.getFocusIndex() + v.length),
      //   this.$nextTick(() => {
      //     this.set_text_value_position("copyIndexInfo", this.cursurPosition);
      //   });
      if (this.lastInsertLink != "") {
        this.postForm.content = this.postForm.content.replace(this.lastInsertLink, "");
      }
      this.logisticsLinkDialog = false;
      this.lastInsertLink = v;
    },

    /***
     * 发送测试短信
     * */
    testSend() {
      // 判断内容和手机号码都不能为空\
      var mobiles = this.smsTestSendParams.mobiles;

      if (!/[\S]+/.test(mobiles)) {
        this.$message.warning("手机号不能为空，请输入正确的手机号 !");
        return;
      }
      mobiles.split(",").forEach((element) => {
        if (!/^1[3456789]\d{9}$/.test(element)) {
          this.$message.warning("请输入正确的手机号 !");
          return;
        }
      });
      var content = this.postForm.content;
      if (content.indexOf("#LandingPage#") != -1) {
        this.$message.error("请先插入短网址");
        return;
      }
      if (content && content.trim().length > 0) {
        this.phoneLenght = this.smsTestSendParams.mobiles.split(",").length;
        // this.isTestSend = true;
        this.showSendConfirm = true;
      } else {
        this.$message.warning("短信内容不能为空哦！");
      }
    },
    testSend2() {
      // 判断内容和手机号码都不能为空\
      var mobiles = this.smsTestSendParams2.mobiles;

      if (!/[\S]+/.test(mobiles)) {
        this.$message.warning("手机号不能为空，请输入正确的手机号 !");
        return;
      }
      mobiles.split(",").forEach((element) => {
        if (!/^1[3456789]\d{9}$/.test(element)) {
          this.$message.warning("请输入正确的手机号 !");
          return;
        }
      });
      var content = this.postForm.contnet2;
      if (content.indexOf("#LandingPage#") != -1) {
        this.$message.error("请先插入短网址");
        return;
      }
      if (content && content.trim().length > 0) {
        this.phoneLenght = this.smsTestSendParams2.mobiles.split(",").length;
        // this.isTestSend = true;
        this.showSendConfirm2 = true;
      } else {
        this.$message.warning("短信内容不能为空哦！");
      }
    },

    // 确认发送弹窗确认按钮
    handleSendConfirm() {
      this.showSendConfirm = false;
      // 测试发送  预提交发送
      const params = {
        dataFrom: 0,
        sendType: 0,
        checkInvalidChar:false,
        mobiles: this.smsTestSendParams.mobiles.split(","),
      };
      console.log(params);
      // return
      // preCommit(params).then((res) => {
      let postData = {
        content: this.postForm.content,
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: params.mobiles.join(','),
        checkInvalidChar:false,
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          // this.preData.sendObjectCount = res.data.sendObjectCount;
          // this.preData.sendObjectId = res.data.sendObjectId;

          // this.sendPeopleNum = res.data.sendObjectCount;
          // let params2 = {
          //   content: this.postForm.content,
          //   sendObjectId: res.data.sendObjectId,
          //   smsSuffix: this.selSuffixName,
          //   blackFlag: false,
          //   smsType: 0
          // };
          // platformSend(params2).then((res) => {
          //   if (res.code == "1") {
              this.$message.success(res.data);
          //   } else {
          //     this.$message.error(res.message);
          //   }
          // });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 确认发送弹窗确认按钮 - 二次催付
    handleSendConfirm2() {
      this.showSendConfirm2 = false;
      // 测试发送  预提交发送
      const params = {
        dataFrom: 0,
        sendType: 0,
        checkInvalidChar:false,
        mobiles: this.smsTestSendParams2.mobiles.split(","),
      };
      console.log(params);
      // return
      // preCommit(params).then((res) => {
      let postData = {
        content: this.postForm.contnet2,
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: params.mobiles.join(','),
        checkInvalidChar:false,
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          // // this.preData.sendObjectCount = res.data.sendObjectCount;
          // // this.preData.sendObjectId = res.data.sendObjectId;

          // // this.sendPeopleNum = res.data.sendObjectCount;
          // let params2 = {
          //   content: this.postForm.contnet2,
          //   sendObjectId: res.data.sendObjectId,
          //   smsSuffix: this.selSuffixName,
          //   blackFlag: false,
          //   smsType: 0
          // };
          // platformSend(params2).then((res) => {
          //   if (res.code == "1") {
              this.$message.success(res.data);
          //   } else {
          //     this.$message.error(res.message);
          //   }
          // });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /***
     * 保存并开启
     * */
    // saveAndOpenTap() {
    //   this.postForm.type = this.modelName.type;
    //   let obj = { ...this.postForm };
    //   obj.isOpen = 1;
    //   for (let key in obj) {
    //     if (obj[key] == "") {
    //       obj[key] = null;
    //     }
    //   }
    //   let booleanData = {
    //     1: "isBuyerMessage",
    //     2: "isLunchBreak",
    //     3: "isOrderMoney",
    //     4: "isProductNum",
    //     5: "isSellerRemark",
    //     6: "isDefaultGoodRate"
    //   };
    //   for (let key in booleanData) {
    //     obj[booleanData[key]] = obj[booleanData[key]] ? "1" : "0";
    //   }
    //   //数组转对象值
    //   let arrChangeObj = {
    //     1: "sellerFlag",
    //     2: "filterCondition",
    //     3: "memberLevel",
    //     4: "tradeFrom",
    //     5: "reasonReturn"
    //   };
    //   // //数组转字符串
    //   for (let key in arrChangeObj) {
    //     obj[arrChangeObj[key]] = obj[arrChangeObj[key]]
    //       ? obj[arrChangeObj[key]].join(",")
    //       : "";
    //   }
    //   if (obj.isProductNum == "0") {
    //     delete obj.startProductNum;
    //     delete obj.endProductNum;
    //   }
    //   if (obj.isOrderMoney == "0") {
    //     delete obj.startOrderMoney;
    //     delete obj.endOrderMoney;
    //   }
    //   obj.taskType = 0;
    //   if (this.postForm.remindSellerConfigId) {
    //     updateOrdersCare(obj).then(res => {
    //       res.code === 200
    //         ? (this.$message.success(res.message),
    //           this.ModularBtn())
    //         : this.$message.error(res.message);
    //     });
    //   } else {
    //     addOrdersCare(obj).then(res => {
    //       res.code === 200
    //         ? (this.$message.success(res.message),
    //           this.ModularBtn())
    //         : this.$message.error(res.message);
    //     });
    //   }
    // },
    //会员等级
    goVipPage() {
      let routeUrl = this.$router.resolve({
        path: "/memberManage",
        hash: "#/memberlist/memberlevel",
      });
      window.open(routeUrl.href, "_blank");
    },
    //屏蔽黑名单 查看
    routerLinkOne() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
        query:{

        }
      });
      window.open(routeUrl.href, "_blank");
    },
    // 跳转到预售订单发送（精准营销）
    toMarketing() {
      let path = this.venderType ? "/marketing/marketing/self_presell_order_send" : "/marketing/marketing/pop_presell_order_send"
      // if(this.postForm.moneyPayStartTime || this.postForm.moneyPayEndTime){
        let routeUrl = this.$router.resolve({
          path: path,
          query:{
            type:1,
            moneyPayStartTime:this.postForm.moneyPayStartTime,
            moneyPayEndTime:this.postForm.moneyPayEndTime,
          }
        });
        window.open(routeUrl.href, "_blank");
      // }else{
      //   let routeUrl = this.$router.resolve({
      //     path: path,
      //   });
      //   window.open(routeUrl.href, "_blank");
      // }
     
    },

    ///保存检查
    async saveTap(v) {
      console.log("....v", v);
      if (this.disBtn1) {
        return;
      }
      if (this.disBtn2) {
        return;
      }
      if(this.menuType == 31 && !this.formData.intelligentSkuId){
        this.$message.error("请选择凑单商品");
        return;
      }
      if(!this.openDongDong && !this.openSms){
        this.$message.error("短信触达和咚咚消息触达，至少设置开启一个");
        return;
      }
      if(this.openDongDong){
        if (this.formData.waiter == "") {
          this.$message.error("发送客服不能为空");
          return;
        }
        if (this.formData.dongDongContent == "") {
          this.$message.error("消息内容不能为空");
          return;
        }
        if (this.formData.dongDongContent.length > 140) {
          this.$message.error("消息内容不能超过140");
          return;
        }
      }
      if(this.openSms){
        if (this.postForm.content == "") {
          this.$message.error("短信内容不能为空");
          return;
        }
        if (this.postForm.content.indexOf("#LandingPage#") != -1) {
          this.$message.error("请先插入短网址");
          return;
        }
      }
      // 二次催付和短信
      if(this.postForm.isOpenSecond){
        if(!this.openDongDongSecond && !this.openSmsSecond){
          this.$message.error("短信触达和咚咚消息触达，至少设置开启一个");
          return;
        }
        
        if(this.openSmsSecond){
          if (this.postForm.contnet2 == "") {
            this.$message.error("短信内容不能为空");
            return;
          }
          if (this.postForm.contnet2.indexOf("#LandingPage#") != -1) {
            this.$message.error("请先插入短网址");
            return;
          }
        }
        if(this.openDongDongSecond){
          if (this.formSecond.waiter == "") {
            this.$message.error("发送客服不能为空");
            return;
          }
          if (this.formSecond.dongDongContent == "") {
            this.$message.error("消息内容不能为空");
            return;
          }
          if (this.formSecond.dongDongContent.length > 140) {
            this.$message.error("消息内容不能超过140");
            return;
          }
        }
      }
      
      this.saveTapPost(v);
    },
    /***
     * 保存任务
     * */
    saveTapPost(v) {
      // todo： 二次催付修改
      //this.postForm.isOpen = 0;
      this.disBtn1 = true;
      this.disBtn2 = true;
      v == 0 ? (this.loadBtn2 = true) : (this.loadBtn1 = true);
      // let obj = { ...this.postForm };
      let obj = { ...this.postForm, url: this.longUrllink };
      obj.content = this.longlinkFlay ? this.postForm.content.replace(` ${this.postForm.transformUrl} `, `#LandingPage#`) : this.postForm.content;
      let regex = /\【|】/g;
      //let a=regex.test(obj.content);
      if (regex.test(obj.content)) {
        this.$message.error("通道规则：短信内容请勿包含【】符号！");
        return;
      }
      // obj.startRemindTime = obj.startRemindTime
      //   ? this.formatDate(obj.startRemindTime)
      //   : null;
      // obj.endRemindTime = obj.endRemindTime
      //   ? this.formatDate(obj.endRemindTime)
      //   : null;
      //布尔值转换
      // for (let key in obj) {
      //   if (obj[key] == "") {
      //     obj[key] = null;
      //   }
      // }
      let booleanData = {
        1: "isBuyerMessage",
        2: "isLunchBreak",
        3: "isOrderMoney",
        4: "isProductNum",
        5: "isSellerRemark",
        6: "isDefaultGoodRate",
        7: "isGoodNumber",
        8: "isGoodDays",
        9: "evaluateWhetherToSend",
      };
      for (let key in booleanData) {
        if (booleanData[key] == "evaluateWhetherToSend") {
          obj[booleanData[key]] = obj[booleanData[key]] ? "0" : "1";
        } else {
          obj[booleanData[key]] = obj[booleanData[key]] ? "1" : "0";
        }
      }

      if (obj.filterCondition && obj.filterCondition.length > 0) {
        try {
          obj.filterBuyerTime = obj.filterCondition.includes("5") ? obj.filterBuyerTime : null;
          obj.filterWantTime = obj.filterCondition.includes("0") ? obj.filterWantTime : null;
          obj.filterMobileTime = obj.filterMobileTime.includes("1") ? obj.filterMobileTime : null;
        } catch (e) {}
      }
      // if (!obj.filterCondition || !obj.filterCondition.length) {
      //   try {
      //     obj.filterBuyerTime = null;
      //     obj.filterWantTime = null;
      //     obj.filterBeyondWords = null;
      //     obj.filterBlockWord = null;
      //     obj.filterMobileTime = null;
      //   } catch (e) {}
      // }
      // 发送时段/午休时间转整数
      let dateChange = {
        1: "startRemindTime",
        2: "endRemindTime",
        3: "startLunchBreak",
        4: "endLunchBreak",
      };
      for (let key in dateChange) {
        // if (booleanData[key] == "evaluateWhetherToSend") {
        // obj[dateChange[key]] = this.dateParam(obj[dateChange[key]]);
        // } else {
        // obj[booleanData[key]] = obj[booleanData[key]] ? "1" : "0";
        // }
      }

      //数组转对象值
      let arrChangeObj = {
        1: "sellerFlag",
        2: "filterCondition",
        3: "memberLevel",
        4: "tradeFrom",
        5: "reasonReturn",
      };

      // //数组转字符串
      for (let key in arrChangeObj) {
        try {
          obj[arrChangeObj[key]] = obj[arrChangeObj[key]].filter((item) => item != "");
        } catch (e) {}
        this.$nextTick(() => {
          obj[arrChangeObj[key]] = obj[arrChangeObj[key]] ? obj[arrChangeObj[key]].join(",") : "";
        });
      }
      // return
      if (obj.remindSellerConfigId && v == 0) {
        obj.isOpen = obj.isOpen;
      } else {
        obj.isOpen = v;
      }
      obj.isNoteReply = this.isNoteReply ? "0" : "1";
      if (obj.isProductNum == "0") {
        obj.startProductNum = 0;
        obj.endProductNum = 0;
      }

      if (obj.isOrderMoney == "0") {
        obj.startOrderMoney = "";
        obj.endOrderMoney = "";
      }
      if (obj.taskType == 0 || !obj.taskType) {
        obj.taskStartTime = null;
        obj.taskEndTime = null;
      }
      if (obj.isBuyerMessage != 1) {
        obj.buyerMessage = null;
      }

      if (obj.isGoodNumber == "0") {
        obj.goodNumber = "";
      }
      if (obj.isGoodDays == 0) {
        obj.goodDays = "";
      }
      if (obj.evaluateWhetherToSend == 1) {
        obj.evaluateWhetherToSend = "";
      }
      if (obj.orderType == "0" || obj.orderType == "2") {
        obj.presellType = "";
      }
      if (obj.areaType == "1") {
        obj.zip = JZH_CODE;
      }
      if (obj.areaType == "2") {
        obj.zip = PY_CODE;
      }
      if (obj.areaType == "3") {
        // obj.zip = this.checkedList.join(",");
        obj.zip = this.checkedList;
      }
      if (!obj.isLunchBreak == "0") {
        obj.startLunchBreak == "", obj.endLunchBreak == "";
      }

      // obj.sellerFlag=obj.sellerFlag!=""?obj.sellerFlag:null
      this.$nextTick(() => {
        obj.sellerFlag = obj.sellerFlag ? obj.sellerFlag : "";
        obj.filterCondition = obj.filterCondition ? obj.filterCondition : "";
        obj.memberLevel = obj.memberLevel ? obj.memberLevel : "";
        obj.tradeFrom = obj.tradeFrom ? obj.tradeFrom : "";
      });
      // obj.startRemindTime = obj.startRemindTime.substring(
      //   0,
      //   obj.startRemindTime.length - 3
      // );
      // obj.endRemindTime = obj.endRemindTime.substring(
      //   0,
      //   obj.endRemindTime.length - 3
      // );
      obj.taskType = obj.taskType == 1 ? 1 : 0;
      obj.orderSplitCondition = obj.orderSplitCondition ? "1" : "2";
      if (this.menuType == 7) {
        obj.tradeFrom = "JHS";
      }
      if (this.menuType != 12) {
        obj.unReceiptedZip = null;
        obj.unUpdateZip = null;
        obj.unreceiptedTime = null;
        obj.unreceiptedUnit = null;
        obj.notUpdatedTime = null;
        obj.notUpdatedUnit = null;
      }

      obj.paymentType = this.menuType == 6 ? obj.paymentType : "";

      console.log(this.$parent.apiTypeActive);
      if (this.apiTypeActive == "remind") {
        this.remind(obj, v);
      } else if (this.apiTypeActive == "refund") {
        this.refund(obj, v);
        // console.log(obj);
      } else {
        console.log("......................v", v);

        let params = {
          dayLimit:obj.dayLimit,
          appointTimeEnd: obj.taskEndTime ? obj.taskEndTime : null,
          appointTimeStart: obj.taskStartTime ? obj.taskStartTime : null,

          // "benefitSendtype": 1,
          buyerRemarkIsSend: obj.isBuyerMessageSend == 1 ? true : false,
          content: obj.content,
          endOrderPayment: obj.endOrderMoney ? obj.endOrderMoney : null,
          endSendtimeConfig: obj.endRemindTime,
          extnoSendType: obj.remindSendType,
          filterBuyerRemark: obj.buyerMessage ? obj.buyerMessage : '',
          filterBuyerRemarkType: Number(obj.isBuyerMessage) + 1,
          filterVenderRemark: obj.sellerRemark ? obj.sellerRemark : '',
          filterVenderRemarkType: obj.isSellerRemark == "1" ? 2 : 1,

          goodsList: [],
          goodsNumEnd: obj.endProductNum,
          goodsNumFilterType: obj.isProductNum,
          goodsNumStart: obj.startProductNum,
          isOpen: v,
          itemFilterType: 1, //商品过滤类型
          lunchTimeEnd: obj.endLunchBreak,
          lunchTimeStart: obj.startLunchBreak,
          lunchTimeType: obj.isLunchBreak,
          orderPaymentFilterType: obj.isOrderMoney == 1 ? 2 : 1,
          payType: obj.payType.length == 0 ? "0" : obj.payType.join(","),
          payTypeFlag: true, //支付方式选择开关 0关闭 1开启 ,

          //指定地区
          provinceFilterType: obj.areaType == 0 ? 0 : 1,
          // 会员筛选
          memberSelect:String(obj.memberSelect),
          memberSelectLevel: obj.memberSelectLevel,
          // 过滤设置
          blackmobileFilterType: 1,
          badReviewFilterSetting: 0, // 屏蔽给过中差评客户
          refundFilterSetting: 0, // 屏蔽是否退过款用户
          samedayFilterSetting: true, // 同1个买家一天只提醒一次

          score: obj.selectStart.join(","),
          sellerRemarkIsSend: obj.isSellerRemarkSend == 1 ? true : false,
          sendCondit: this.condit,
          // "startExtnoConfig": "string",
          id: obj.id,
          startOrderPayment: obj.startOrderMoney ? obj.startOrderMoney : null,
          startSendtimeConfig: obj.startRemindTime,
          suffix: this.isOfficial ? this.selSuffixName : "【" + this.selSuffixName + "】",
          taskName: obj.taskName,
          taskType: obj.taskType == 0 ? 1 : 2,
          type: this.taskTypeActive,
          waybillFilterType: Number(obj.shipmentNum) + 1,
          runTime: this.postForm.runTime ? this.postForm.runTime : "", //Tag:自动催评增加 runTime 参数(21/9/15)
          buyerRemarkType: obj.buyerRemarkType,
          sellerRemarkType: obj.sellerRemarkType,

        };
        if (this.isOfficial) {
          params.officialTemplateId = obj.templateId;
          // delete params.blackmobileFilterType;
          // delete params.badReviewFilterSetting;
          // delete params.refundFilterSetting;
          // delete params.samedayFilterSetting;
          // delete params.waybillFilterType;
        }
        // console.log(params);
        if (obj.isAllItem != "0") {
          // 选择商品列表
          this.postForm.itemList = [...this.returnSelectGoods, ...this.selectGoodsSkuList];
          console.log(this.postForm.itemList);
          params.goodsList = this.postForm.itemList.map((res) => {
            // return {
            //   goodMon: res.jdPrice,
            //   goodID: res.wareId,
            //   imgSrc: res.logo || res.images,
            //   goodTxt: res.wareTitle || res.itemTitle,
            //   skuId: res.skuId,
            // };
            let obj = {
              goodMon: res.jdPrice || res.price,
              goodID: res.wareId,
              imgSrc: res.logo || res.images || res.wareLogo,
              goodTxt: res.wareTitle || res.itemTitle,
              skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
            };
            if (this.venderQuanxian) {
              obj.skuId = res.skuId;
            }
            return obj;
          });
        } else {
          params.goodsList = [];
        }
        // console.log(params.goodsList);
        // return
        if (!this.isOfficial) {
          // 同1个买家1天只提醒1次
          if (obj.filterCondition.indexOf("1") == -1) {
            params.samedayFilterSetting = false;
          }
          // 过滤黑名单
          if (obj.filterCondition.indexOf("2") == -1) {
            params.blackmobileFilterType = 2;
          }
        }
        // 是否过滤中差评用户
        if (obj.filterCondition.indexOf("4") == -1) {
          params.badReviewFilterSetting = 0;
        } else {
          params.badReviewFilterSetting = 1;
        }
        // // 是否过滤退过款用户
        if (obj.filterCondition.indexOf("5") == -1) {
          params.refundFilterSetting = 0;
        } else {
          params.refundFilterSetting = 1;
        }
        if (obj.filterCondition.indexOf("1") == -1) {
          params.samedayFilterSetting = false;
        } else {
          params.samedayFilterSetting = true;
        }
        // 顺延第二天发送增加字段

        if (params.extnoSendType == 2) {
          params.start_extno_config = params.startSendtimeConfig;
          params.end_extno_config = params.endSendtimeConfig;
        }

        // 商品过滤类型
        if (obj.isAllItem == 1) {
          params.itemFilterType = 3;
        }
        if (obj.isAllItem == 2) {
          params.itemFilterType = 2;
        }
        if (obj.areaType != 0) {
          // params.provinces = obj.zip && obj.zip.split(",");
          params.provinces = obj.zip;
        }
        // 尾款支付时间
        if (this.balancePath) {
          params.balanceTimeStart = this.postForm.balanceTimeStart;
          params.balanceTimeEnd = this.postForm.balanceTimeEnd;
        }
        params.memberSelectLevel = this.postForm.memberSelectLevel.join(",");
        // console.log(params.filterPayType);
        console.log(params);
        // if(params.intelligentSkuId){
        //   this.postForm.itemList = [...this.returnSelectGoods, ...this.selectGoodsSkuList];
        //   console.log(this.postForm.itemList);
        //   params.goodsList = this.postForm.itemList.map((res) => {
        //     // return {
        //     //   goodMon: res.jdPrice,
        //     //   goodID: res.wareId,
        //     //   imgSrc: res.logo || res.images,
        //     //   goodTxt: res.wareTitle || res.itemTitle,
        //     //   skuId: res.skuId,
        //     // };
        //     let obj = {
        //       goodMon: res.jdPrice || res.price,
        //       goodID: res.wareId,
        //       imgSrc: res.logo || res.images || res.wareLogo,
        //       goodTxt: res.wareTitle || res.itemTitle,
        //       skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
        //     };
        //     if (this.venderQuanxian) {
        //       obj.skuId = res.skuId;
        //     }
        //     return obj;
        //   });
        // }
        // return
        insertOrUpdate(params)
          .then((res) => {
            this.disBtn1 = false;
            this.disBtn2 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
            res.code === 1 ? (this.$message.success(res.message), this.ModularBtn()) : this.$message.error(res.message);
          })
          .catch(() => {
            this.disBtn1 = false;
            this.disBtn2 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
          });
      }
    },
    remind(obj, v) {
      console.log(v,obj,'666666');
      console.log("objsss", obj, this.postForm);
      // return
      // let remindSendType = this.remindSendType =="1"?0:1
      console.log(obj.isLunchBreak);
      let params = {
        dayLimit:obj.dayLimit,
        appointAreaType: obj.areaType == 0 ? 0 : 1,
        bargainTimeEnd: obj.moneyPayEndTime,
        bargainTimeStart: obj.moneyPayStartTime,
        // "buyTotalCountType": 0,
        buyerRemarkConfig: obj.buyerMessage ? obj.buyerMessage : '',
        buyerRemarkFilterType: obj.isBuyerMessage,
        buyerRemarkIsSend: obj.isBuyerMessageSend == "1" ? true : false,
        condit: this.condit,
        content: obj.content,
        // "endBuyTotalCount": 0,
        endFilterSendConfig: obj.endLunchBreak,
        endWareNumberConfig: obj.endProductNum,
        // "extnoSendConfig": 0,

        clearWare: false,
        filterSendType: obj.isLunchBreak,
        remindSendType: obj.remindSendType == "1" ? 0 : 1,
        // 过滤设置
        sendRequencyType: 1,
        filterBlacklistType: true,

        // "gradeData": "",
        isAllItem: obj.isAllItem,
        isOpen: v == 1 ? 1 : 2,
        orderMoneyEnd: obj.endOrderMoney,
        orderMoneyFilterType: obj.isOrderMoney,
        orderMoneyStart: obj.startOrderMoney,
        otherOrderAlreadyPaymentSend: true,
        payTypeFilterData: obj.payType.join(","),
        persistentOpenFlag: obj.taskType == 0 ? true : false,
        filterPayType: obj.payType.length == 0 ? false : true, // 无支付方式
        // provinceCodes: obj.zip.length != 0 ? obj.zip.split(",") : [],
        provinceCodes: obj.zip.length != 0 ? obj.zip : [],
        remindSendEnd: obj.endRemindTime,
        remindSendStart: obj.startRemindTime,
        sellerCode: obj.logisticsNum,
        tailNumber: obj.tailNumber,
        ztExpressPhone: obj.ztExpressPhone,
        sellerRemarkIsSend: obj.isSellerRemarkSend == "1" ? true : false,

        startFilterSendConfig: obj.startLunchBreak,
        startWareNumberConfig: obj.startProductNum,
        suffix: this.isOfficial ? this.selSuffixName : "【" + this.selSuffixName + "】",
        taskAllowRunEndTime: obj.taskEndTime,
        taskAllowRunStartTime: obj.taskStartTime,
        taskName: obj.taskName,
        type: this.taskTypeActive,
        venderRemarkConfig: obj.sellerRemark ? obj.sellerRemark:'',
        venderRemarkFilterType: obj.isSellerRemark,
        // "wareList": obj.zip?obj.zip.split(","):[],
        wareNumberConfigType: obj.isProductNum,
        waybillType: obj.shipmentNum,
        id: obj.id,
        templateId: obj.templateId,
        url: obj.url ? obj.url : "",
        transformUrl: obj.transformUrl ? obj.transformUrl : "",
        memberSelect:String(obj.memberSelect),
        memberSelectLevel: obj.memberSelectLevel,
        buyerRemarkType: obj.buyerRemarkType,
        sellerRemarkType: obj.sellerRemarkType,

        transformUrl2: obj.transformUrl2 ? obj.transformUrl2 : "",
        // 二次催付
        isOpenSecond: obj.isOpenSecond,
        secondConfigObj: {
          condit: this.condit2,
          contnet: this.postForm.contnet2,
          templateId: obj.templateId2,
          ...this.formSecond
        }
        
      };
      // 同1个买家1天只提醒1次
      if (obj.filterCondition.indexOf("1") == -1) {
        params.sendRequencyType = 0;
      }
      // 过滤黑名单
      if (obj.filterCondition.indexOf("2") == -1) {
        params.filterBlacklistType = false;
      }
      // 过滤黑名单
      if (obj.filterCondition.indexOf("3") == -1) {
        params.otherOrderAlreadyPaymentSend = false;
      }
      if (this.menuType == 4) {
        params.balancePaymentRemidMinutes = params.condit;
      }
      if (obj.isAllItem != "0") {
        // 选择商品列表
        this.postForm.itemList = [...this.returnSelectGoods, ...this.selectGoodsSkuList];
        console.log(this.postForm.itemList, 1111111);
        params.wareList = this.postForm.itemList.map((res) => {
          let obj = {
            price: res.jdPrice || res.price,
            wareId: res.wareId,
            wareLogo: res.logo || res.wareLogo,
            wareTitle: res.wareTitle,
            skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
          };
          if (this.venderQuanxian) {
            obj.skuId = res.skuId;
          }
          return obj;
        });
      } else {
        params.wareList = [];
        params.clearWare = true;
      }
      if (this.isOfficial) {
      }
      console.log("aaaa", params);
      console.log(params.provinceCodes);
      if (this.venderQuanxian) {
        if (obj.areaType == "1") {
          //自营江浙沪
          params.provinceCodes = [
            {
              city: "杭州市,宁波市,温州市,嘉兴市,湖州市,绍兴市,金华市,衢州市,舟山市,台州市,丽水市",
              code: "11",
            },
            {
              city:
                "黄浦区,卢湾区,徐汇区,长宁区,静安区,闸北区,虹口区,杨浦区,宝山区,闵行区,嘉定区,浦东新区,青浦区,松江区,金山区,南汇区,奉贤区,普陀区,崇明区",
              code: "9",
            },
            {
              city: "南京市,无锡市,徐州市,常州市,苏州市,南通市,连云港市,淮安市,盐城市,扬州市,镇江市,泰州市,宿迁市,吴江市,宜兴市",
              code: "10",
            },
          ];
        }
        if (obj.areaType == "2") {
          //自营偏远地区
          params.provinceCodes = [
            {
              code: "5",
              city: "呼和浩特市,包头市,乌海市,赤峰市,通辽市,鄂尔多斯市,呼伦贝尔市,巴彦淖尔市,乌兰察布市,兴安盟,锡林郭乐盟,阿拉善盟,哲里木盟",
            },
            {
              code: "25",
              city:
                "昆明市,玉溪市,曲靖市,昭通市,红河州,文山州,西双版纳州,大理州,怒江州,丽江市,迪庆藏族自治县,楚雄州,临沧市,保山市,德宏州,普洱市,迪庆州",
            },
            { code: "26", city: "拉萨市,那曲地区,昌都地区,山南地区,日喀则地区,阿里地区,林芝市" },
            { code: "29", city: "西宁市,海东地区,海北州,黄南州,海南州,果洛州,玉树州,海西州" },
            {
              code: "31",
              city:
                "乌鲁木齐市,克拉玛依市,吐鲁番地区,哈密地区,和田地区,阿克苏地区,喀什地区,克孜勒苏柯尔克孜自治州,巴音郭楞州,昌吉州,博尔塔拉州,伊犁州,石河子市,阿拉尔市,图木舒克市,五家渠市,塔城地区,阿勒泰地区,奎屯市,新疆维吾尔自治区,铁门关市,昆玉市",
            },
          ];
        }
      }
      // 尾款支付时间
      if (this.balancePath) {
        params.balanceTimeStart = this.postForm.balanceTimeStart;
        params.balanceTimeEnd = this.postForm.balanceTimeEnd;
      }
      if(this.menuType == 4 && this.balancePath){
        params.balancePaymentRemindEndMinutes = this.conditEnd
      }

      if(this.diffTask){
        params = {...params,...this.formData}
        if(!this.hasSms){
          params.isSendSms = false;
          params.secondConfigObj.isSendSms = false;
        }
        if(!this.hasDongDong){
          params.isSendDongDong = false;
          params.secondConfigObj.isSendDongDong = false;
        }
      }
      params.memberSelectLevel = this.postForm.memberSelectLevel.join(",");
      // console.log("params数据");
      // console.log(params);
      // if(params.intelligentSkuId){
      //   this.postForm.itemList = [...this.returnSelectOrderGoods, ...this.selectOrderGoodsSkuList];
      //   console.log(this.postForm.itemList, 1111111);
      //   params.wareList = this.postForm.itemList.map((res) => {
      //     let obj = {
      //       price: res.jdPrice || res.price,
      //       wareId: res.wareId,
      //       wareLogo: res.logo || res.wareLogo,
      //       wareTitle: res.wareTitle,
      //       skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
      //     };
      //     if (this.venderQuanxian) {
      //       obj.skuId = res.skuId;
      //     }
      //     return obj;
      //   });
      // } else {
      //   params.wareList = [];
      //   params.clearWare = true;
      // }
      // return
      addOrdersCare(params)
        .then((res) => {
          this.disBtn1 = false;
          this.disBtn2 = false;
          this.loadBtn1 = false;
          this.loadBtn2 = false;
          res.code === 1 ? (this.$message.success(res.message), this.ModularBtn()) : this.$message.error(res.message);
        })
        .catch((e) => {
          this.disBtn1 = false;
          this.disBtn2 = false;
          this.loadBtn1 = false;
          this.loadBtn2 = false;
          // console.log(e);
        });
    },

    // 退款关怀
    async refund(obj, v) {
      console.log(obj, 5555);
      let params = {
        dayLimit:obj.dayLimit,
        // appointAreaType: obj.areaType == 0 ? 0 : 1,

        // "createTime": "string",
        taskName: obj.taskName,
        taskType: obj.taskType == 0 ? 1 : 2,
        // 会员筛选
        memberSelect:String(obj.memberSelect),
        memberSelectLevel: obj.memberSelectLevel.join(","),
        // 发送时段
        startSendtimeConfig: obj.startRemindTime,
        endSendtimeConfig: obj.endRemindTime,
        extnoSendType: obj.remindSendType == "1" ? 1 : 2,

        id: obj.id,
        isOpen: v == 1 ? 1 : 2,
        openLunchFlag: obj.isLunchBreak == 1 ? true : false,
        lunchStartTime: obj.startLunchBreak,
        lunchEndTime: obj.endLunchBreak,
        // "operateIp": "string",
        // "operateTime": "string",
        orderPaymentFilterType: obj.isOrderMoney == 1 ? 2 : 1,
        startOrderPayment: obj.startOrderMoney ? obj.startOrderMoney : null,
        endOrderPayment: obj.endOrderMoney ? obj.endOrderMoney : null,
        wareCountFlag: obj.isProductNum,
        wareCountDownLimit: obj.startProductNum,
        wareCountUpLimit: obj.endProductNum,

        filterVenderRemarkType: obj.isSellerRemark == 1 ? 2 : 1,
        filterVenderRemark: obj.sellerRemark ? obj.sellerRemark : '',
        sellerRemarkIsSend: obj.isSellerRemarkSend == 1 ? true : false,

        buyerRemarkFlag: obj.isBuyerMessage == 1 ? true : false,
        buyerRemarkKeywordCondition: obj.buyerMessage,
        buyerRemarkIsSend: obj.isBuyerMessageSend == 1 ? true : false,

        // 过滤设置
        remindOneTimesFlag: 1,
        blackmobileFilterType: 1,
        filterBadcommentCustomer: 1,
        filterRefundCustomer: 1,

        waybillFilterType: Number(obj.shipmentNum) + 1, //运单号

        //付款方式
        payType: obj.payType.length == 0 ? "0" : obj.payType.join(","),
        // appointAreaFlag: obj.areaType == 0 ? 0 : 1,
        appointAreaType: obj.areaType == 0 ? 0 : 1,
        //选择商品
        itemFilterType: 1,
        // provinces: null,
        refundItemConfigList: null,

        sort: 1,
        suffix: "【" + this.selSuffixName + "】",
        content: obj.content,
        taskStartTime: obj.taskStartTime,
        taskEndTime: obj.taskEndTime,
        type: this.taskTypeActive,
        buyerRemarkType: obj.buyerRemarkType,
        sellerRemarkType: obj.sellerRemarkType,
      };

      // 同1个买家1天只提醒1次
      if (obj.filterCondition.indexOf("1") == -1) {
        params.remindOneTimesFlag = 0;
      }
      // 过滤黑名单
      if (obj.filterCondition.indexOf("2") == -1) {
        params.blackmobileFilterType = 2;
      }
      // 是否过滤中差评用户
      if (obj.filterCondition.indexOf("4") == -1) {
        params.filterBadcommentCustomer = 0;
      }
      console.log(obj.filterCondition);
      // 是否过滤退过款用户
      if (obj.filterCondition.indexOf("5") == -1) {
        params.filterRefundCustomer = 0;
      }
      // 商品过滤类型
      if (obj.isAllItem == 1) {
        params.itemFilterType = 3;
      }
      if (obj.isAllItem == 2) {
        params.itemFilterType = 2;
      }
      if (obj.areaType != 0) {
        // params.provinceCodes = obj.zip;
        // params.provinces = obj.zip.length != 0 ? obj.zip.split(",") : [];
        params.provinces = obj.zip.length != 0 ? obj.zip : [];
      }
      if (this.isOfficial) {
        params.officialTemplateId = obj.templateId;
      }

      // 新建任务需获取新id
      // if (!obj.id) {
      //   let { data } = await OrdersCareRefundInfo({
      //     type: this.taskTypeActive,
      //   });
      //   console.log(data);
      //   params.id = data.id;
      // }

      // 选择商品列表
      if (obj.isAllItem != "0") {
        // console.log(this.itemList)
        this.postForm.itemList = [...this.returnSelectGoods, ...this.selectGoodsSkuList];
        params.refundItemConfigList = this.postForm.itemList.map((res) => {
          // return {
          //   configId: obj.id,
          //   images: res.logo,
          //   itemTitle: res.wareTitle,
          //   jdPrice: res.jdPrice,
          //   // "sellerNick": "string",
          //   skuId: res.skuId,
          //   type: this.taskTypeActive,
          //   // "venderId": 0,
          //   wareId: res.wareId,
          // };
          let objInfo = {
            configId: obj.id ? obj.id : "",
            images: res.logo || res.wareLogo,
            itemTitle: res.wareTitle,
            jdPrice: res.jdPrice || res.price,
            // "sellerNick": "string",
            skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
            type: this.taskTypeActive,
            // "venderId": 0,
            wareId: res.wareId,
          };
          if (this.venderQuanxian) {
            objInfo.skuId = res.skuId;
          }
          return objInfo;
        });
      } else {
        params.refundItemConfigList = [];
      }

      // return
      updateAndSave(params)
        .then((res) => {
          this.disBtn1 = false;
          this.disBtn2 = false;
          this.loadBtn1 = false;
          this.loadBtn2 = false;
          res.code === 1 ? (this.$message.success(res.message), this.ModularBtn()) : this.$message.error(res.message);
        })
        .catch(() => {
          this.disBtn1 = false;
          this.disBtn2 = false;
          this.loadBtn1 = false;
          this.loadBtn2 = false;
        });
      //添加地区
      // if (obj.areaType != 0) {
      //   console.log(params.id);
      //   addRefundProvinceConfig({
      //     provinceCodes: obj.zip,
      //     refundReminderConfigId: params.id,
      //     type: this.taskTypeActive,
      //   });
      // }
    },
    onlyOnOrTime(val) {
      if (val === "9") {
        let index = this.postForm.filterCondition.indexOf("10");
        if (index > -1) {
          this.postForm.filterCondition.splice(index, 1);
        }
      }
      if (val === "10") {
        let index = this.postForm.filterCondition.indexOf("9");
        if (index > -1) {
          this.postForm.filterCondition.splice(index, 1);
        }
      }
    },
    changeCity(arr, type) {
      if (type == "cancel") {
        return;
      }
      console.log(arr);
      this.checkedList = arr;
    },
    moreBtn() {
      let path = this.isOfficial ? "signature_report_official" : "signature_management";
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/" + path,
        // path: "/backstage",
        // hash:'#/autograph',
      });
      window.open(routeUrl.href, "_blank");
    },
    shortBtnThree() {
      this.sendState = !this.sendState;
    },
    // shortBtnFour() {
    //   this.couponState = !this.couponState;
    // },
    shortBtnTwo() {
      this.smsState = !this.smsState;
    },
    dateParam(date) {
      console.log(date);
      if (date == null) {
        return "";
      }
      return Number(date.substring(0, date.indexOf(":")));
    },
    // 选择模板的返回
    shortBtnTwo1(data) {
      if (typeof data != "boolean") {
        this.postForm.content = this.postForm.content + data.content;
      }
      this.smsState = !this.smsState;
    },
    // 短信记录的返回
    shortBtnTwo2(data) {
      this.smsState2 = !this.smsState2;
    },
    /**
     * 选择完商品
     */
    goodsPopupBtn(event, index) {
      this.goodsState = false;
      // console.log("选择完商品返回",event,index);
      if (typeof event != "boolean" && index === 1) {
        this.goodsStateLength = event.length;
        this.postForm.itemList = event;
      }
    },

    shortBtn() {
      this.shortState = !this.shortState;
    },
    //插入短链接
    shortBtn1(data) {
      if (typeof data != "boolean") {
        // this.postForm.content = this.postForm.content + data.shortUrl;
        let insertStr = (soure, start, newStr) => {
          return soure.slice(0, start) + newStr + soure.slice(start);
        };
        this.postForm.content = insertStr(this.postForm.content, this.getFocusIndex(), " " + data.shortUrl + " ");

        if (!this.postForm.shortUrlId) {
          this.postForm.shortUrlId = data.shortUrlId;
        } else {
          this.postForm.shortUrlId = this.postForm.shortUrlId + "," + data.shortUrlId;
        }
      }
      this.shortState = !this.shortState;
    },
    /*
     * 关闭弹窗
     * */
    ModularBtn() {
      this.$parent.pageConditionCom = false;
      this.$emit("transferName", true);
    },
    ModularBtnClose() {
      this.$parent.pageConditionCom = false;
    },
    /*
     *  下一步
     * */
    nextBtn() {
      // // 嵌套抽屉显示
      // this.innerDrawer = true;
      // return;
      console.log(this.postForm.taskEndTime);
      console.log(this.postForm.taskStartTime);
      console.log(this.postForm.taskType);
      console.log(this.postForm.sendCondition);
      // 顺丰和中通寄件人手机号四位不能为空
      if((this.menuType == 9 || this.menuType == 10)) {
        if(this.postForm.logisticsNum || this.postForm.tailNumber || this.postForm.ztExpressPhone){
          if(this.postForm.tailNumber && this.postForm.tailNumber.length != 4) {
            this.$message.error("请输入4位顺丰寄件人手机号！");
            return;
          }
          if(this.postForm.ztExpressPhone && this.postForm.ztExpressPhone.length != 4) {
            this.$message.error("请输入4位中通寄件人手机号！");
            return;
          }
        }else{
          this.$message.error("请输入京东物流编码！");
          return;
        }
      }
      // 定金支付时间不能为空
      // if (this.balancePath) {
      if ((!this.postForm.moneyPayStartTime || !this.postForm.moneyPayEndTime) && this.menuType == 4) {
        this.$message.error("定金支付时间不能为空");
        return;
      }
      // }
      // 尾款支付时间不能为空
      if (this.balancePath) {
        if (!this.postForm.balanceTimeStart || !this.postForm.balanceTimeEnd) {
          this.$message.error("尾款支付时间不能为空");
          return;
        }
        if (new Date(this.postForm.moneyPayEndTime) > new Date(this.postForm.balanceTimeStart)) {
          this.$message.error("尾款支付时间要大于定金支付时间");
          return;
        }
      }

      let sendCondition = this.postForm.sendCondition + "";
      if (this.apiTypeActive != "refund") {
        if (sendCondition == "" || sendCondition == null) {
          this.$message.error("发送时间不能为空");
          return;
        }
      }

      if(this.menuType == 4 && this.balancePath){
        if(this.postForm.balancePaymentRemindEndMinutes === ""){
          this.$message.error("发送时间不能为空");
          return;
        }
      }

      //当任务时间为指定时间为空时
      if (this.postForm.taskType == 1) {
        if (this.postForm.taskEndTime == "" || this.postForm.taskStartTime == "") {
          this.$message.error("指定时间不能为空");
          return;
        }
      }
      //任务名称不能为空
      if (!this.postForm.taskName) {
        this.$message.error("任务名称不能为空");
        return;
      }

      //每天发送时段不能为空
      if (!this.postForm.endRemindTime || !this.postForm.startRemindTime) {
        this.$message.error("每天发送时段不能为空");
        return;
      }

      this.postForm.startRemindTime ? (this.postForm.startRemindTime = this.postForm.startRemindTime.substring(0, 5)) : "";
      this.postForm.endRemindTime ? (this.postForm.endRemindTime = this.postForm.endRemindTime.substring(0, 5)) : "";

      if (this.postForm.startRemindTime && this.postForm.endRemindTime) {
        var startListRemind = this.postForm.startRemindTime.split(":");
        var endListRemind = this.postForm.endRemindTime.split(":");
        if (parseInt(startListRemind[0]) > parseInt(endListRemind[0])) {
          this.$message.warning("发送时段时间无效");
          return;
        } else if (parseInt(startListRemind[0]) == parseInt(endListRemind[0]) && parseInt(startListRemind[1]) > parseInt(endListRemind[1])) {
          this.$message.warning("发送时段时间无效");
          return;
        }
      }

      this.postForm.startLunchBreak ? (this.postForm.startLunchBreak = this.postForm.startLunchBreak.substring(0, 5)) : "";
      this.postForm.endLunchBreak ? (this.postForm.endLunchBreak = this.postForm.endLunchBreak.substring(0, 5)) : "";

      if (this.postForm.startLunchBreak && this.postForm.endLunchBreak) {
        var startList = this.postForm.startLunchBreak.split(":");
        var endList = this.postForm.endLunchBreak.split(":");
        if (parseInt(startList[0]) > parseInt(endList[0])) {
          this.$message.warning("发送时段时间无效");
          return;
        } else if (parseInt(startList[0]) == parseInt(endList[0]) && parseInt(startList[1]) > parseInt(endList[1])) {
          this.$message.warning("发送时段时间无效");
          return;
        }
      }
      if (this.postForm.startOrderMoney && this.postForm.endOrderMoney) {
        if (Number(this.postForm.startOrderMoney) > Number(this.postForm.endOrderMoney)) {
          this.$message.warning("实付金额初始数值不能大于结束数值");
          return;
        }
      }
      if (this.isProductNum && this.postForm.startProductNum && this.postForm.endProductNum) {
        if (Number(this.postForm.endProductNum) > Number(this.postForm.endProductNum)) {
          this.$message.warning("商品数量初始数值不能大于结束数值");
          return;
        }
      }
      //商品数量判断
      //  isProductNum: false, //发送条件 是否开启商品数量 1 开启(true) 0 关闭(false),
      //startProductNum: "", // 发送条件 商品数量开始,
      // endProductNum: "", // 发送条件 商品数量结束,
      if (this.postForm.isProductNum) {
        // if (
        //   this.postForm.startProductNum == "" ||
        //   this.postForm.endProductNum == ""
        // ) {
        //   this.$message.error("勾选中的商品数量范围不能为空");
        //   return;
        // }
        if (this.postForm.startProductNum != "" && this.postForm.endProductNum != "") {
          if (Number(this.postForm.startProductNum) > Number(this.postForm.endProductNum)) {
            this.$message.error("商品开始数量不能大于结束数量");
            return;
          }
        }
      }

      //过滤设置勾选判断
      if (this.postForm.filterCondition && this.postForm.filterCondition.length > 0) {
        try {
          if (this.postForm.filterCondition.includes("0") && this.postForm.filterWantTime == "") {
            this.$message.error("勾选中的同一个旺旺号提醒天数不能为空");
            return;
          }
          if (this.postForm.filterCondition.includes("1") && this.postForm.filterMobileTime == "") {
            this.$message.error("勾选中的同一个手机号提醒天数不能为空");
            return;
          }
        } catch (e) {}
      }

      //1、判断商品选择指定商品或者排除商品时，需判断具体商品不能为空
      let isAllItem = false,
        areaType = false;
      if (this.postForm.isAllItem === "1" || this.postForm.isAllItem === "2") {
        if (this.goodsStateLength !== 0) {
          isAllItem = false;
        } else {
          isAllItem = true;
        }
      } else {
        isAllItem = false;
      }

      //2、选择地区，选择自定义，需判断自定义地区不为空
      if (this.postForm.areaType === "3") {
        if (this.areaStateLength !== 0) {
          areaType = false;
        } else {
          areaType = true;
        }
      } else {
        areaType = false;
      }

      if (isAllItem === true && areaType === true) {
        this.$message.error("请检查自定义地区和选择商品(指定商品或排除商品)是否不为空!");
        // this.isOne = true;
        this.isTwo = false;
        // 先隐藏
        // } else if (this.postForm.areaType == 3 && this.checkedList.length == 0) {
        //   this.$message.error("您选择了自定义地区，请检查自定义地区是否不为空!");
        //   // this.isOne = true;
        //   this.isTwo = false;
      } else if (isAllItem === true && areaType === false) {
        this.$message.error("您选择商品选择了指定商品或排除商品，请检查是否选择了具体的商品!");
        // this.isOne = true;
        this.isTwo = false;
      } else {
        // this.isOne = false;
        this.isTwo = true;
        // $(".myOne").slideToggle(500);
      }
      // 针对评分不能为空
      if (this.menuType == 14 || this.menuType == 15) {
        console.log(this.postForm.selectStart);
        if (this.postForm.selectStart.length <= 0) {
          this.$message.error("针对评分至少选择一项");
          return;
        }
      }
      // 嵌套抽屉显示
      // this.drawerWidth = '1600px';
      if (this.isTwo) {
        this.innerDrawer = true;
      }
    },

    flagChange(value) {
      let checkedCount = value.length;
      // console.log(this.flagData);
      ///this.isIndeterminateTwo = checkedCount > 0 && checkedCount < this.flagData.length;
    },
    /*
     *  取消
     * */
    noneBtn() {
      this.areaState = false;
    },
    /*
     * 确认
     * */
    yesBtn() {
      this.areaState = false;
    },
    /*
     *  自定义显示
     *
     * */
    popupShowBtn() {
      this.postForm.areaType = "3";
      this.areaState = true;
    },
    /*
     *  禁止滚动事件
     * */
    bodyScroll(event) {
      event.preventDefault();
    },
    unique(arr, arr1) {
      let list = arr.filter((item) => item);
      let listArr = list.map((item) => Number(item));
      let list1 = arr1.filter((item) => item);
      let listArr1 = list1.map((item) => Number(item));
      console.log(listArr, listArr1);
      return [...new Set([...listArr, ...listArr1])];
    },
    handleSelectLevel(val){
      this.$forceUpdate();
      // if(val.includes('0')){
      //   this.postForm.memberSelectLevel = ["0"]
      // }else {
      //   this.postForm.memberSelectLevel = val.filter(item => item!==0);
      // }
    },
    changeMemberLevels(item){
      if (this.postForm.memberSelectLevel.length == 0) {
        this.postForm.memberSelectLevel = ["-1"];
      } else if (item == "-1") {
        this.postForm.memberSelectLevel = ["-1"];
      } else {
        this.postForm.memberSelectLevel.forEach((val, idx, arr) => {
          if (arr[idx] == "-1") {
            this.postForm.memberSelectLevel.splice(idx);
            this.postForm.memberSelectLevel.push(item);
          }
        });
      }
    },
    // 限制客服id个数
    handleWaiterInput(){
      let ids = this.formData.waiter.split(',').filter(id => id.trim() !== '');
      if (ids.length > 5) {
        ids = ids.slice(0, 5); // 截取前5个ID
        this.formData.waiter = ids.join(','); // 拼接成字符串，覆盖原输入
        this.$message.error("最多只能输入5个客服ID");
      }
    },
    handleWaiterInputByformSecond(){
      let ids = this.formSecond.waiter.split(',').filter(id => id.trim() !== '');
      if (ids.length > 5) {
        ids = ids.slice(0, 5); // 截取前5个ID
        this.formSecond.waiter = ids.join(','); // 拼接成字符串，覆盖原输入
        this.$message.error("最多只能输入5个客服ID");
      }
    },
  },
};
</script>
<style lang="scss">
.box-hugs {
  .el-picker-panel .time-select .el-poppe {
    overflow-y: auto;
  }
  .el-popper {
    overflow-y: auto;
  }
  .el-picker-panel__footer {
    display: none;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #666;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #666;
  }
}
</style>
<style lang="scss">
.ask-content-x {
  position: relative;
  display: inline-block;
  vertical-align: text-top;
  cursor: pointer;
  line-height: 19px;
  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }
  .ask-icon-select {
    position: absolute;
    bottom: 35px;
    display: none;
    // height: 80px;
    line-height: 20px;
    background-color: #fff;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 9;
    width: 140px;
    text-align: center;
    left: 0;
    margin-left: 0;
    padding: 10px 10px;
  }
  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    right: 50%;
    margin-left: -4px;
    top: 100%;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
}
.ask-content-x:hover {
  .ask-icon-select {
    // display: block;
  }
}
</style>

<!--条件刷选-->
<style lang="scss" scoped>
/deep/ .time {
  .el-input__inner {
    padding: 0 8px 0 30px !important;
  }
}
.footTips {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding-left: 12px;
  height: 28px;
  background: rgba(255, 250, 238, 1);
  // border: 1px solid rgba(255, 185, 94, 1);
  border-radius: 2px;
  color: #333;
  font-size: 13px;
  position:relative;
}
* {
  // font-family: "Microsoft YaHei";
}
/deep/.el-date-editor--time-select .el-input__inner {
  padding-left: 30px !important;
}
/deep/.el-textarea__inner {
  // font-family: "Microsoft YaHei";
}
.send-textare {
  color: red;
  // font-family: "Microsoft YaHei";
}
@mixin translateX($number) {
  -webkit-transform: translateX($number);
  -moz-transform: translateX($number);
  -ms-transform: translateX($number);
  -o-transform: translateX($number);
  transform: translateX($number);
}

@mixin translateY($number) {
  -webkit-transform: translateY($number);
  -moz-transform: translateY($number);
  -ms-transform: translateY($number);
  -o-transform: translateY($number);
  transform: translateY($number);
}

@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}
/* 发送确认弹窗 */
.send-con-dialog {
  .btn-group {
    margin-top: 30px;
    text-align: center;
  }
}
.mask {
  //   position: fixed;
  //   bottom: 0;
  //   width: 100%;
  height: 100%;
  //   background: rgba(0, 0, 0, 0.5);
  //   // z-index: 99;
  //   z-index: 2000;
}
.selectBox {
  text-align: right;
  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .option {
      z-index: 999999 !important;
    }
  }
  .keepBtn {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
  }
}
.box-hugs {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  // width: 50%;
  height: 100%;
  // // background: rgba(0, 0, 0, 0.5);
  // z-index: 100;
  // overflow-y: auto;
  .box-content-hug {
    // position: relative;

    // min-width: 1200px;
    height: 100%;
    // overflow-y: auto;
    .box-left {
      position: fixed;
      width: 19%;
      height: 100%;
      float: left;
      overflow: hidden;
      .btn-top {
        width: 36px;
        height: 36px;
        background: rgba(255, 255, 255, 0.5);
        float: right;
        cursor: pointer;
        img {
          display: block;
          margin: 10px auto;
          width: 16px;
        }
      }
    }

    .myOne {
      background: #fff;
    }
    .box-content {
      // width: 81%;
      height: 100%;

      background-color: #fff;
      // float: right;
      //overflow-y: auto;
      // padding: 35px 30px 35px 25px;
      // padding: 15px 0px 0px 0px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      overflow: auto;
      position: relative;
      overflow: hidden;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }

      .right-content {
        overflow: hidden;
        margin-bottom: 10px;
        .right-content-left {
          float: left;
          width: 135px;
          font-size: 14px;
          // font-family: "Microsoft YaHei";
          font-weight: 400;
          line-height: 32px;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          .request-tip {
            color: rgb(245, 154, 35);
            font-size: 12px;
            line-height: 13px;
          }
        }
        .right-content-right {
          margin-left: 120px;
          width: auto;
          overflow: hidden;
          .difficulWrap {
            .title {
              padding-right: 8px;
            }
            .selBtn {
              display: inline-block;
              padding: 0px 6px;
              border: 1px solid #ccc;
              cursor: pointer;
              margin-right: 8px;
            }
            .selInput {
              width: 40px;
              margin: 0 8px;
            }
            .selType {
              width: 60px;
            }
            .tips {
              margin-left: 8px;
            }
          }
          span {
            font-size: 14px;
            // font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 32px;
            color: rgba(102, 102, 102, 1);
          }
          .ding {
            position: absolute;
            top: 0;
            right: 3px;
          }
          .el-input__inner {
            padding: 0 20px;
          }
          .bb {
            .el-radio:nth-last-of-type(1) {
              margin-right: 0;
            }
          }
          .bb-button{
            text-align: center;
            font-size: 14px;
            // width: 120px;
            margin-right: 10px;
            // font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 30px;
            display: inline-block;
            cursor: pointer;
            border-radius: 3px;
            padding: 0 10px;
            border-radius: 3px;
            background-color: #f7f8fe;
            border: 1px solid #7f85e9;
            color: #7f85e9;
            &:hover {
              background: rgba(174, 179, 241, 0.16);
              border: 1px solid #7f85e9 !important;
              color: #7f85e9 !important;
            }
            &:active {
              background: rgba(174, 179, 241, 0.24);
              border: 1px solid #7f85e9 !important;
              color: #7f85e9;
            }

          }
          .button {
            // width: 103px;
            // height: 30px;
            // background: rgba(255, 255, 255, 1);
            // border: 1px solid rgba(209, 210, 217, 1);
            opacity: 1;
            // border-radius: 2px;
            text-align: center;
            font-size: 14px;
            // font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 30px;
            display: block;
            float: right;
            cursor: pointer;
            border-radius: 3px;
            padding: 0 10px;
            border-radius: 3px;
            background-color: #f7f8fe;
            border: 1px solid #7f85e9;
            color: #7f85e9;
            &:hover {
              background: rgba(174, 179, 241, 0.16);
              border: 1px solid #7f85e9 !important;
              color: #7f85e9 !important;
            }
            &:active {
              background: rgba(174, 179, 241, 0.24);
              border: 1px solid #7f85e9 !important;
              color: #7f85e9;
            }
          }
        }
      }
      .next_box {
        height: 80px;
        background: rgba(255, 255, 255, 1);
        border-top: 1px solid #f0f0f0;
        position: absolute;
        bottom: -230px;
        width: 100%;
        bottom: 0px;
        z-index: 99;
      }
      .next {
        opacity: 1;
        font-size: 14px;
        // font-family: "Microsoft YaHei";
        font-weight: 400;
        text-align: center;
        cursor: pointer;
        line-height: 32px;
        float: right;
        margin: 24px 28px;
        width: 98px;
        height: 32px;
        color: #ffffff;
        border-radius: 3px;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
  }
  .box-content-hug1 {
    // position: relative;
    // width: 100%;
    // min-width: 1200px;
    opacity: 0.6;
    height: 100%;
    // overflow-y: auto;
    .box-left {
      position: fixed;
      width: 19%;
      height: 100%;
      float: left;
      overflow: hidden;
      .btn-top {
        width: 36px;
        height: 36px;
        background: rgba(255, 255, 255, 0.5);
        float: right;
        cursor: pointer;
        img {
          display: block;
          margin: 10px auto;
          width: 16px;
        }
      }
    }

    .myOne {
      background: #fff;
    }
    .box-content {
      // width: 81%;
      height: 100%;

      background-color: #fff;
      // float: right;
      //overflow-y: auto;
      // padding: 35px 30px 35px 25px;
      // padding: 15px 0px 0px 0px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      overflow: auto;
      position: relative;
      overflow: hidden;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }

      .right-content {
        overflow: hidden;
        margin-bottom: 10px;
        .right-content-left {
          float: left;
          width: 120px;
          font-size: 14px;
          // font-family: "Microsoft YaHei";
          font-weight: 400;
          line-height: 32px;
          color: rgba(51, 51, 51, 1);
          text-align: right;
        }
        .right-content-right {
          margin-left: 120px;
          width: auto;
          overflow: hidden;
          .difficulWrap {
            .title {
              padding-right: 8px;
            }
            .selBtn {
              display: inline-block;
              padding: 0px 6px;
              border: 1px solid #ccc;
              cursor: pointer;
              margin-right: 8px;
            }
            .selInput {
              width: 40px;
              margin: 0 8px;
            }
            .selType {
              width: 60px;
            }
            .tips {
              margin-left: 8px;
            }
          }
          span {
            font-size: 14px;
            // font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 32px;
            color: rgba(102, 102, 102, 1);
          }
          .ding {
            position: absolute;
            top: 0;
            right: 3px;
          }
          .el-input__inner {
            padding: 0 20px;
          }
          .bb {
            .el-radio:nth-last-of-type(1) {
              margin-right: 0;
            }
          }
          .button {
            // width: 103px;
            // height: 30px;
            // background: rgba(255, 255, 255, 1);
            // border: 1px solid rgba(209, 210, 217, 1);
            opacity: 1;
            // border-radius: 2px;
            text-align: center;
            font-size: 14px;
            // font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 30px;
            display: block;
            float: right;
            cursor: pointer;
            border-radius: 3px;
            padding: 0 10px;
            color: #fe4d45;
            border: 1px solid #fe4d45;
            border-radius: 3px;
            background-color: #fff4f4;
            &:hover {
              color: #fe4d45;
              background-color: #ffe5e5;
            }
            &:active {
              color: #fe4d45;
              border: 1px solid #fe4d45;
              background-color: #fff4f4;
            }
          }
        }
      }
      .next_box {
        height: 80px;
        background: rgba(255, 255, 255, 1);
        border-top: 1px solid #f0f0f0;
        margin-top: 210px;
        width: 100%;
        bottom: 0px;
        z-index: 99;
      }
      .next {
        opacity: 1;
        font-size: 14px;
        // font-family: "Microsoft YaHei";
        font-weight: 400;
        text-align: center;
        cursor: pointer;
        line-height: 32px;
        float: right;
        margin: 24px 28px;
        width: 98px;
        height: 32px;
        color: #ffffff;
        border-radius: 3px;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
  }
}

.two-content {
  .item-hug-left {
    float: left;
    overflow: hidden;
  }
  .item-hug-right {
    float: left;
  }
  .two-item {
    // overflow: hidden;
    margin-top: 10px;
    .item-left {
      float: left;
      width: 118px;
      font-size: 14px;
      // font-family: "Microsoft YaHei";
      font-weight: 400;
      line-height: 32px;
      color: rgba(51, 51, 51, 1);
      text-align: right;
    }
    .item-right {
      margin-left: 118px;
      .label_content {
        margin-bottom: 13px;
        display: flex;
        flex-wrap: wrap;
        .label_items {
          background: #fff;
          color: #7f85e9;
          margin-right: 4px;
          margin-bottom: 4px;
          font-size: 13px;
          padding: 4px 10px;
          border: 1px solid #e6e6e6;
          cursor: pointer;
        }
      }
    }
    .write-message-box {
      display: inline-block;
      vertical-align: top;
      .message-content-box {
        border: 1px solid rgba(230, 230, 230, 1);
        border-radius: 2px;
        font-size: 14px;
        width: 550px;

        .message-input-box {
          position: relative;
          font-size: 15px;
          .back-order-button {
            position: absolute;
            width: 68px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #f3f3f3;
            bottom: 1px;
            right: 1px;
          }
        }

        .tabs-foot {
          height: 53px;
          line-height: 53px;
          background-color: #f9fafb;
          padding: 0 8px;
          border-top: 1px solid #e6e6e6;
          .foot-left {
            float: left;
            font-size: 14px;
            span {
              display: inline-block;
              vertical-align: middle;
            }

            .ask-content {
              position: relative;
              display: inline-block;
              vertical-align: middle;
              cursor: pointer;
              .ask-icon {
                display: inline-block;
                vertical-align: middle;
                cursor: pointer;
                position: relative;
              }

              .ask-icon-select {
                position: absolute;
                bottom: 50px;
                margin-left: -158px;
                display: none;
                width: 375px;
                // height: 80px;
                line-height: 20px;
                padding: 20px;
                background-color: #fff;
                text-align: left;
                box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
                color: #999999;
              }
              .ask-icon-select:before {
                position: absolute;
                content: "";
                width: 0;
                height: 0;
                right: 50%;
                margin-left: -4px;
                top: 100%;
                border-left: 8px solid transparent;
                border-top: 8px solid #fff;
                border-right: 8px solid transparent;
              }
            }

            .ask-content:hover {
              .ask-icon-select {
                display: block;
              }
            }
          }
          .foot-right {
            float: right;
            height: 30px;
            margin-top: 11px;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            padding: 0 13px;
            /*background: rgba(46, 114, 248, 0.1);*/
            border: 1px solid #fff;
            border-radius: 2px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            font-size: 14px;
            position: relative;
            .foot-right-bgc {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 30px;
              opacity: 0.1;
            }
          }
        }
      }

      .message-tips-box {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px;
        background: rgba(255, 118, 0, 0.1);
        border-radius: 3px;
        margin-top: 4px;
        color: rgba(255, 118, 0, 1);
        font-size: 14px;
        line-height: 17px;
      }
    }
    .write-message-box2 {
      padding: 12px;
      background: #fafafa;
      width: 615px;
    }
    .button1 {
      width: 98px;
      height: 32px;
      /*border:1px solid rgba(32,98,231,1);*/
      opacity: 1;
      border-radius: 3px;
      font-size: 14px;
      // font-family: "Microsoft YaHei";
      font-weight: 400;
      line-height: 30px;
      float: left;
      text-align: center;
      cursor: pointer;
      /*color:rgba(32,98,231,1);*/
    }
    .button2 {
      width: 98px;
      height: 32px;
      /*border:1px solid rgba(32,98,231,1);*/
      opacity: 1;
      border-radius: 3px;
      font-size: 14px;
      // font-family: "Microsoft YaHei";
      font-weight: 400;
      line-height: 32px;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      float: left;
      margin: 0 12px 0 48px;
      cursor: pointer;
    }
  }

  .tool-button {
    font-size: 15px;
    display: inline-block;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: middle;
    padding: 8px 15px;
    /*background: rgba(46, 114, 248, 0.13);*/
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    /*color: #2E72F8;*/
    margin-right: 16px;
    cursor: pointer;
    position: relative;

    .tool-button-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
    }

    .tool-button-title {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .input-box {
    display: inline-block;
    vertical-align: middle;
    margin-right: 13px;
  }
  .test-button {
    position: relative;
    display: inline-block;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 5px 12px;
    cursor: pointer;
    border-radius: 3px;
    text-align: center;
    font-size: 14px;

    line-height: 18px;
    vertical-align: bottom;
    margin-right: 8px;
    height: 32px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #ffffff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
    &:active {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .test_button2 {
    width: 98px;
    color: #999999;
    border-radius: 3px;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .xiao-hug {
    /*width: 40%;*/
    margin-left: 100px;
  }
  .mobile-box {
    position: relative;
    width: 256px;
    height: 504px;
    background: url("../../assets/images/mobileScreen.png") no-repeat;
    .message-content {
      position: absolute;
      word-wrap: break-word;
      max-height: 250px;
      overflow-y: auto;
      padding: 12px 12px;
      border-radius: 6px;
      background-color: #fafafa;
      width: 210px;
      font-size: 14px;
      line-height: 20px;
      left: 50%;
      margin-left: -104.665px;
      text-align: left;
      top: 25.4%;
    }
  }

  .mobile-tips {
    margin-top: 12px;
    font-size: 16px;
    text-align: center;
    color: rgba(51, 51, 51, 1);
  }
}
.box-step {
  width: 100%;
  height: 60px;
  // overflow: hidden;
  position: relative;
  .box-background {
    width: 100%;
    height: 100%;
    opacity: 0.05;
  }
  .box-step-hug {
    position: absolute;
    left: 0;
    top: 0;
    height: 50px;
    width: 100%;
    overflow: hidden;
    .box-step-circle {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      float: left;
      margin-left: 20px;
      margin-top: 21px;
    }
    .box-step-title {
      margin-left: 20px;
      font-size: 16px;
      // font-family: "Microsoft YaHei";
      font-weight: 600;
      line-height: 50px;
      color: rgba(51, 51, 51, 1);
      float: left;
    }
  }
  .btn_all {
    // margin-top: 30px;
    height: 80px;
    padding-top: 24px;
    border-top: 1px solid #f0f0f0;
    position: absolute;
    bottom: -230px;
    width: 100%;
  }
}

/*.box-hug::-webkit-scrollbar {!*滚动条整体样式*!*/
/*width: 6px;     !*高宽分别对应横竖滚动条的尺寸*!*/
/*height: 1px;*/
/*}*/
/*.box-hug::-webkit-scrollbar-thumb {!*滚动条里面小方块*!*/
/*border-radius: 6px;*/
/*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
/*background: #535353;*/
/*}*/
/*.box-hug::-webkit-scrollbar-track {!*滚动条里面轨道*!*/
/*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
/*border-radius: 6px;*/
/*background: #EDEDED;*/
/*}*/
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 10000;
  .popup-hug {
    width: 700px;
    height: 420px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    @include translate(-50%, -50%);
    .popup-text-top {
      height: 52px;
      overflow: hidden;
      background: rgba(244, 245, 249, 1);
      .span1 {
        font-size: 20px;

        // font-family: "Microsoft YaHei";
        font-weight: 600;
        line-height: 52px;
        color: rgba(51, 51, 51, 1);
        display: block;
        float: left;
        margin-left: 30px;
        margin-right: 30px;
      }
      .span2 {
        font-size: 20px;
        line-height: 52px;
        display: block;
        float: right;
        margin-right: 20px;
        cursor: pointer;
      }
      span {
        font-size: 20px;
        // font-family: "Microsoft YaHei";
        font-weight: 600;
        line-height: 52px;
        color: #333333;
      }
    }
    .area-hug {
      margin-top: 30px;
      padding-left: 20px;
      .area {
        margin-top: 10px;
        overflow: hidden;
      }
    }
    .button-hug {
      margin-top: 30px;
      border-top: 1px solid rgba(230, 230, 230, 1);
      padding-top: 12px;
      .button-small {
        width: 180px;
        margin: 0 auto;
      }
      /*width: 220px;*/
      /*margin: 30px auto;*/
    }
  }
}

@media screen and (max-width: 1550px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 70px;
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 40px;
      }
    }
  }
}
@media screen and (max-width: 1450px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 20px;
      }
    }
  }
}
@media screen and (max-width: 1430px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 0px;
      }
    }
  }
}
@media screen and (max-width: 1410px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 0px;
      }
    }
  }
}
// @media screen and (max-width: 1450px) {
//   .box-hugs {
//     .two-content {
//       .xiao-hug {
//         margin-top: 30px;
//         margin-left: 20%;
//       }
//     }
//   }
// }

//
@media screen and (max-width: 1410px) {
}
@media screen and (max-width: 1395px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        // margin-top: 30px;
        // margin-left: 20%;
      }
    }
  }
  .box-hugs .box-content-hug .box-content {
    // min-height: 1290px;
  }
}
</style>
<style lang="scss">
// .el-textarea__inner {
//   border: 0!important;
// }

.fadeInTop {
  animation-name: fadeInTop 1s;
  -webkit-animation: fadeInTop 1s;
}
/*从右到左进入*/
@keyframes fadeInTop {
  from {
    opacity: 0.8;
    -webkit-transform: translateY(936px);
    transform: stranslateY(936px);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: stranslateY(0);
  }
}

@-webkit-keyframes fadeInTop {
  from {
    opacity: 0;
    -webkit-transform: translateY(936px);
    transform: translateY(936);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.tool-button-bgc {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  opacity: 0.1;
}

.checkbox_filter_time .el-date-editor.el-input {
  width: 190px;
  margin: 10px 0 0;
}
.disBtn1 {
  cursor: not-allowed !important;
}
.disBtn2 {
  cursor: not-allowed !important;
}

.color_gray {
  span {
    font-size: 13px !important;
    color: #c0c4cc !important;
    margin-right: 1px;
  }
}

.more_text {
  display: inline-block;
  vertical-align: text-top;
  cursor: pointer;
}
.more_text:hover {
}
.tabs-button2 {
  display: inline-block;
  vertical-align: middle;
  padding: 0 13px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #e6e6e6;
  text-align: center;
  background-color: #fff;
  color: #2e72f8;
  margin-right: 9px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 8px;
}
</style>
<style lang="scss" scoped>
.tool {
  cursor: pointer;
  display: flex;
  align-items: center;
  p {
    box-sizing: border-box;
    padding: 0 8px;
    margin: 0 8px 0 0;
    // width: 98px;
    height: 32px;
    line-height: 28px;
    font-size: 14px;
    border-radius: 3px;
    background-color: #f7f8fe;
    border: 1px solid #7f85e9;
    color: #7f85e9;
    &:hover {
      background: rgba(174, 179, 241, 0.16);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9 !important;
    }
    &:active {
      background: rgba(174, 179, 241, 0.24);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9;
    }
  }
}
.sms-content-x {
  border-radius: 4px;
  padding: 5px 15px;
  width: 548px;
  height: 145px;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  outline: 1px solid #c0c4cc;
  // overflow: visible;
}
// .page_condition{
.page_title {
  height: 22px;
  font-size: 16px;
  /* font-family: PingFang SC; */
  font-weight: 500;
  line-height: 24px;
  color: rgba(51, 51, 51, 1);
  margin: 20px 0 20px 28px;
  display: inline-block;
}
.del_icon {
  width: 12px;
  height: 12px;
  color: rgba(204, 204, 204, 1);
  opacity: 1;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  float: right;
  margin: 25px 30px;
  cursor: pointer;
  font-size: 16px;
  // background: pink;
  // box-sizing: content-box;
}
.del_icon:hover {
  color: #fe4d45;
}
.circle_icon {
  width: 22px;
  height: 22px;
  background: rgba(254, 77, 69, 1);
  border-radius: 50%;
  opacity: 1;
  display: inline-block;
  text-align: center;
  line-height: 22px;
  color: #fff;
  font-size: 14px;
  margin-right: 8px;
}
.top_step {
  height: 46px;
  line-height: 46px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  box-sizing: content-box;
  position: relative;
  // margin-bottom: 40px;
}
.top_step_item {
  font-size: 14px;
  /* font-family: PingFang SC; */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  width: 50%;
  display: inline-block;
  text-align: center;
  border-bottom: 2px solid #fe4d45;
}
.step3 {
  color: #666;
  border-bottom: 0px;
  .circle_icon {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(254, 77, 69, 1);
    color: #fe4d45;
    line-height: 20px;
  }
}
.step2 {
  color: #999;
  border-bottom: 0px;
  .circle_icon {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    color: #cccccc;
    line-height: 20px;
  }
}
.step4 {
  border-bottom: 2px solid #fe4d45;
}
.to_next {
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -8px;
  width: 10px;
  color: #b9b9b9;
  font-size: 18px;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #ccc !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
}
.topTis {
  display: flex;
  align-items: baseline;
  // margin: 0 0 38px 66px;
  color: #999;
  font-size: 13px;
  margin: 0px 48px 16px 47px;
  .desc {
    line-height: 20px;
    color: #333;
    background-color: #fafafa;
  }
  .i_icon {
    width: 14px;
    height: 14px;
    background: #ffb95e;
    opacity: 1;
    display: inline-block;
    line-height: 14px;
    text-align: center;
    border-radius: 7px;
    color: #fff;
    font-size: 12px;
    margin-right: 8px;
  }
  p {
    margin: 0px;
    // height: 18px;
    line-height: 18px;
    width: 580px;
  }
}
.top_bg {
  box-sizing: border-box;
  padding: 12px;
  background: #fffaee;
}
.topTis2 {
  margin: 18px 0px 16px 90px;
  p {
    width: 580px;
  }
}
.footInfo {
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
  font-size: 14px;
  color: #333;
  .selectBtn {
    width: 76px;
    height: 28px;
    opacity: 1;
    border-radius: 3px;
    font-size: 13px;
    margin-right: 8px;
    cursor: pointer;
    border: 1px solid #fe4d45;
    color: #fe4d45;
    background-color: #fff4f4;
    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }
  }
  .keepBtn {
    width: 76px;
    height: 28px;
    border-radius: 3px;
    font-size: 13px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    margin-right: 8px;
    cursor: pointer;
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 28px;
    outline: none;
    border: none;
    background-color: white;
    border-radius: 2px;
    font-size: 13px;
  }
  div {
    display: flex;
    align-items: center;
  }
  .select {
    color: #7f85e9;
    background: rgba(127, 133, 233, 0.1);
    border: 1px solid rgba(127, 133, 233, 1);
  }
  .keep {
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    margin-right: 16px;
    cursor: pointer;
    width: 98px;
    height: 32px;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.ask-content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }
  .ask-icon-select {
    position: absolute;
    bottom: 35px;
    margin-left: -130px;
    display: none;
    width: 375px;
    // height: 80px;
    line-height: 20px;
    padding: 20px;
    background-color: #fff;
    text-align: left;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 9;
  }
  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    right: 50%;
    margin-left: -4px;
    top: 100%;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
}
.ask-content:hover {
  .ask-icon-select {
    display: block;
  }
}
.btnList {
  display: flex;
  align-items: center;
  height: 32px;
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }
  .btnBox {
    position: relative;
    overflow: hidden;
    height: 31px;
    margin-right: 16px;
    border-radius: 3px;
    .btn {
      width: 114px;
      height: 31px;
      color: #999999;
      border: 1px solid #cccccc;
      padding-left: 15px;
      border-radius: 3px;
      padding-right: 15px;
      cursor: pointer;
    }
    .btn_active {
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .check {
      position: absolute;
      right: -16px;
      bottom: -16px;
      width: 30px;
      height: 30px;
      background-color: #fe4d45;
      border-radius: 50%;
    }
    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}

.return_btn {
  margin-right: 78px;
  color: rgb(144, 144, 144);
  width: 98px;
  height: 32px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(204, 204, 204, 1);
  opacity: 1;
  border-radius: 4px;
  color: #999;
  line-height: 30px;
}
.el-textarea__inner {
  border: 0 !important;
}

.button1 {
  width: 98px;
  height: 32px;
  /*border:1px solid rgba(32,98,231,1);*/
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  // font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 30px;
  float: left;
  text-align: center;
  cursor: pointer;
  /*color:rgba(32,98,231,1);*/
}
.button2 {
  width: 98px;
  height: 32px;
  /*border:1px solid rgba(32,98,231,1);*/
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  // font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 32px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  float: left;
  margin: 0 12px 0 48px;
  cursor: pointer;
}
// }
</style>
<style lang="scss">
@media only screen and (max-width: 1900px) {
  .outside_Drawer {
    width: 900px !important;
  }
  .inner_Drawer {
    width: 1000px !important;
  }
  .xiao_hug {
    left: 620px !important;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
.el-drawer.rtl {
  overflow: scroll;
}
</style>

<!-- 二次催付样式 -->
<style lang="scss" scoped>
.second-remind {
  min-height: 150px;
  .second-remind-switch {
    display: flex;
    align-items: center;
    .second-label {
      float: left;
      width: 118px;
      text-align: right;
      font-size: 14px;
      font-weight: 400;
      line-height: 32px;
      color: rgba(51, 51, 51, 1);
    }
    .second-time-box {
      display: inline-block;
      margin-left: 5px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
}
.notShow {
  position: relative;

  img {
    margin-left: 100px;
    width: 348px;
    height: 348px;
  }

  p {
    position: absolute;
    left: 197px;
    top: 328px;
    color: #999999;
    font-size: 14px;
  }

  .bottom-btn {
    width: 560px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .select {
  width: 98px;
  height: 32px;
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fff4f4;

  &:hover {
    color: #fe4d45;
    background-color: #ffe5e5;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.keep {
  width: 98px;
  height: 32px;
  margin: 0 10px 0 8px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;

  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
}
</style>
